// 명언 기본 타입
export type QuoteType = {
  category: string;
  quote: string;
  author: string;
  image?: string;
};

// export type QuoteCardType = {
//   image: string;
//   quote: string;
//   author: string;
// };

export const cardQuotes: QuoteType[] = [
  {
    category: 'Card',
    quote: '자신감이란 자신의 가능성을 믿는 것입니다.',
    author: '빈스 롬바르디',
    image:
      'https://user-images.githubusercontent.com/56837413/230787591-961274c6-01af-4805-a1e8-0458f9451a78.jpg',
  },
  {
    category: 'Card',
    quote: '현재의 노력이 미래의 성취를 결정짓는다.',
    author: '데일 카네기',
    image:
      'https://user-images.githubusercontent.com/56837413/230787598-ac75f4a5-cae8-41eb-a413-1acd6567e342.jpg',
  },
  {
    category: 'Card',
    quote: '당신의 머리와 마음은 당신이 정하는 것보다 훨씬 더 강합니다.',
    author: '마이크 김',
    image:
      'https://user-images.githubusercontent.com/56837413/230787601-ac51a542-5ad0-4334-a53f-31e618094c23.jpg',
  },
  {
    category: 'Card',
    quote: '당신이 꿈꾸는 것은 이미 누군가의 현실입니다.',
    author: '존 레논',
    image:
      'https://user-images.githubusercontent.com/56837413/230787603-3102c788-acfd-468e-aada-92e7c75243da.jpg',
  },
  {
    category: 'Card',
    quote: '시작하기 위해 기다릴 때보다 실패할 용기를 가지는 것이 낫습니다.',
    author: '로빈 쉐르마',
    image:
      'https://user-images.githubusercontent.com/56837413/230787604-81b2d33b-49af-4e62-a4f6-9034696b16e4.jpg',
  },
  {
    category: 'Card',
    quote: '성공은 단순한 일이 아니며, 당신이 어렵게 얻은 것입니다.',
    author: '라리 페이지',
    image:
      'https://user-images.githubusercontent.com/56837413/230787606-13407684-93c1-4d19-aabf-d4a271d91fcd.jpg',
  },
  {
    category: 'Card',
    quote:
      '성공하는 것은 그것을 달성하기 위해 노력한 모든 시간과 에너지의 가치를 인정하는 것입니다.',
    author: '월트 디즈니',
    image:
      'https://user-images.githubusercontent.com/56837413/230787607-ef5e309e-4c50-4fbc-a39a-aa13a7f14fd3.jpg',
  },
  {
    category: 'Card',
    quote: '행동하는 것이 생각하는 것보다 더 좋습니다.',
    author: '윌 로저스',
    image:
      'https://user-images.githubusercontent.com/56837413/230787610-6155603d-3c65-4891-9622-e33e6602a568.jpg',
  },
  {
    category: 'Card',
    quote: '당신의 노력은 결국 당신의 결과가 됩니다.',
    author: '스티브 마블리',
    image:
      'https://user-images.githubusercontent.com/56837413/230787612-99e8c6b5-b7aa-4ca9-b106-dcf90abf2170.jpg',
  },
  {
    category: 'Card',
    quote: '성공은 실패에서 옵니다. 이유가 있어서 실패하는 것입니다.',
    author: '헨리 포드',
    image:
      'https://user-images.githubusercontent.com/56837413/230787625-6cdab525-f35a-4a91-918f-9ddf55392887.jpg',
  },
  {
    category: 'Card',
    quote: '행복하게 살기 위해서는 먼저 원하는 것을 찾아야 합니다.',
    author: '로이 T. 베넷',
    image:
      'https://user-images.githubusercontent.com/56837413/230787626-abd60ccb-39ea-447a-8ae0-22e15fcc28dd.jpg',
  },
  {
    category: 'Card',
    quote: '당신의 꿈이 살아있는 한, 희망은 존재합니다.',
    author: '롤리 블랙',
    image:
      'https://user-images.githubusercontent.com/56837413/230787627-8cce82b8-68ea-4a2e-835f-744c49798f5d.jpg',
  },
  {
    category: 'Card',
    quote: '당신이 노력하고 기도하는 것보다 더 중요한 것은 믿음입니다.',
    author: '조엘 오스틴',
    image:
      'https://user-images.githubusercontent.com/56837413/230787629-daabf0fc-bac9-4bcd-a54b-5c13099b5fd0.jpg',
  },
  {
    category: 'Card',
    quote: '시작이 어렵다면 끝도 어렵습니다. 하지만 시작하지 않으면 결코 끝내지 못합니다.',
    author: '토니 로빈스',
    image:
      'https://user-images.githubusercontent.com/56837413/230787630-486e9cf3-04ac-473f-b852-6d0da979a58c.jpg',
  },
  {
    category: 'Card',
    quote: '성공의 열쇠는 시도하는 것입니다.',
    author: '프랭크 라이트',
    image:
      'https://user-images.githubusercontent.com/56837413/230787631-9d255e43-c66c-4ec6-9b5a-c9c99bf59e46.jpg',
  },
  {
    category: 'Card',
    quote: '어디서든 누구나 시작할 수 있습니다. 중요한 것은 시작하는 것입니다.',
    author: '존 시든',
    image:
      'https://user-images.githubusercontent.com/56837413/230787632-549be3cc-edaa-4e55-9226-1cb4c4e9d15e.jpg',
  },
  {
    category: 'Card',
    quote: '시도하지 않으면 실패하지 않을 뿐입니다.',
    author: '케네디',
    image:
      'https://user-images.githubusercontent.com/56837413/230787633-bff3d1cd-9629-44e5-9a47-1a8cf12dc96f.jpg',
  },
  {
    category: 'Card',
    quote: '성공은 세부적인 것에서 비롯됩니다.',
    author: '존 폴 게티',
    image:
      'https://user-images.githubusercontent.com/56837413/230787634-ab8cf7b7-3caa-4287-b083-5c961eb4ba63.jpg',
  },
  {
    category: 'Card',
    quote:
      '현재의 상황은 미래를 결정하지 않습니다. 하지만 현재 상황을 변경하는 방법에 따라 미래는 달라질 수 있습니다.',
    author: '로버트 T. 커요사키',
    image:
      'https://user-images.githubusercontent.com/56837413/230787652-7486e212-dad2-45f4-a379-944758f4c49d.jpg',
  },
  {
    category: 'Card',
    quote: '일을 미루면 미룰수록 그 일에 대한 두려움은 더욱 커집니다.',
    author: '레온 브라운',
    image:
      'https://user-images.githubusercontent.com/56837413/230787655-6805462e-02e5-4cc5-a2ac-41dcccd7d528.jpg',
  },
  {
    category: 'Card',
    quote: '성공한 사람들은 실패할 수 있는 두려움보다 더 큰 용기를 가지고 있습니다.',
    author: '로버트 F. 케네디',
    image:
      'https://user-images.githubusercontent.com/56837413/230787658-976f6dc2-2eca-4689-b8f3-f44df64fc14d.jpg',
  },
  {
    category: 'Card',
    quote: '최선을 다하고, 결과에 대해 걱정하지 마세요. 결과는 자신의 노력에 대한 보상입니다.',
    author: '조지 버나드 쇼',
    image:
      'https://user-images.githubusercontent.com/56837413/230787659-d7c119d3-dcaf-481e-a0be-0ffded84b306.jpg',
  },
  {
    category: 'Card',
    quote: '당신은 자신의 인생의 주인공입니다. 어떻게 연기할 것인가는 당신의 선택입니다.',
    author: '존 C. 맥스웰',
    image:
      'https://user-images.githubusercontent.com/56837413/230787662-05e56b83-4813-44c2-9705-2a34e4b6e20b.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신이 할 수 있는 최선을 다하고 두려움 없이 모든 것을 살펴보세요. 그것이 성공에 가까워질 수 있는 가장 좋은 방법입니다.',
    author: '존 원',
    image:
      'https://user-images.githubusercontent.com/56837413/230787664-4eb45af0-1af9-4bd1-b90a-49926a9a6a87.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신은 어떤 상황에서든 능력이 있습니다. 당신의 열정, 인내, 인내력, 믿음, 인내, 결단력을 모두 사용하십시오.',
    author: '데비드 J. 슈왈츠',
    image:
      'https://user-images.githubusercontent.com/56837413/230787665-eeb2977a-8924-4907-b639-38d40f5b6701.jpg',
  },
  {
    category: 'Card',
    quote:
      '성공은 우리가 원하는 것을 얻는 것이 아니라, 우리가 이루고자 하는 것을 추구하는 것입니다.',
    author: '로버트 J. 콜리어',
    image:
      'https://user-images.githubusercontent.com/56837413/230787666-bdc4d99b-7938-4788-a3f6-636cd75bfb2b.jpg',
  },
  {
    category: 'Card',
    quote:
      '성공은 당신이 무엇을 하는가에 따라 달라집니다. 그것은 당신의 행동, 선택, 노력, 그리고 인내력에 따라 결정됩니다.',
    author: '로이 T. 베넷',
    image:
      'https://user-images.githubusercontent.com/56837413/230787667-2f630657-19f4-44a5-b78b-9deda0361613.jpg',
  },
  {
    category: 'Card',
    quote: '성공은 행동으로 이루어집니다. 말로만 말하지 마십시오. 행동으로 보여주세요.',
    author: '더글러스 매케이',
    image:
      'https://user-images.githubusercontent.com/56837413/230787669-5be50ee8-b795-4e83-bcd7-a85e51038568.jpg',
  },
  {
    category: 'Card',
    quote: '당신이 가진 것이 무엇보다도 중요한 것은 당신이 누구인가입니다.',
    author: '알버트 슈바이처',
    image:
      'https://user-images.githubusercontent.com/56837413/230787672-e1d7ab9d-7034-4a86-bb58-cdf1217304ee.jpg',
  },
  {
    category: 'Card',
    quote: '당신이 하고 있는 것이 중요한 것이 아니라, 그것을 어떻게 하는지입니다.',
    author: '마이클 조던',
    image:
      'https://user-images.githubusercontent.com/56837413/230787673-02227584-1ee1-463b-a288-4c9df5db6a2e.jpg',
  },
  {
    category: 'Card',
    quote:
      '성공하려면, 당신은 출발해야 합니다. 그리고 실패할 가능성이 있다는 것을 감수해야 합니다.',
    author: '조지 앨리어',
    image:
      'https://user-images.githubusercontent.com/56837413/230787674-117527fb-3d10-435e-bb13-64a1067c4760.jpg',
  },
  {
    category: 'Card',
    quote: '당신은 출발하는 순간부터 성공을 이루기 시작합니다. 그래서 지금 출발하세요.',
    author: '마크 트웨인',
    image:
      'https://user-images.githubusercontent.com/56837413/230787677-5566eff7-d92c-4402-bc19-b1510b18aa87.jpg',
  },
  {
    category: 'Card',
    quote: '목표를 설정하고 끝까지 추구하세요. 그것이 당신의 인생에서 가장 중요한 것입니다.',
    author: '알랭 라파유',
    image:
      'https://user-images.githubusercontent.com/56837413/230787678-ee323874-c2b5-413b-a972-39820841c681.jpg',
  },
  {
    category: 'Card',
    quote:
      '성공은 자신의 한계를 뛰어넘는 것입니다. 그것은 당신이 이루고자 하는 것을 추구하고 꿈을 위해 노력하는 것입니다.',
    author: '마이클 조던',
    image:
      'https://user-images.githubusercontent.com/56837413/230787680-233f0799-86e5-40c2-b7bc-23a01db918e7.jpg',
  },
  {
    category: 'Card',
    quote: '성공은 당신이 노력하고 자신감을 가지고 일할 때 옵니다.',
    author: '로버트 허브샤만',
    image:
      'https://user-images.githubusercontent.com/56837413/230787682-b27969bc-d31c-4f7f-80bb-43cb0a47ddae.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신의 인생은 당신의 행동에 의해 결정됩니다. 그러므로, 우리는 항상 최선을 다해야 합니다.',
    author: '사이먼 시넥',
    image:
      'https://user-images.githubusercontent.com/56837413/230787684-8c43f829-5ac9-4dcd-8e79-edd5fcf1c3c4.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신의 성공은 당신의 내면의 모습에 의해 결정됩니다. 그것은 당신이 하고 있는 것, 그리고 그것을 어떻게 하는지입니다.',
    author: '데일 카네기',
    image:
      'https://user-images.githubusercontent.com/56837413/230787686-8694352a-232a-4721-bbda-81e6370e23b5.jpg',
  },
  {
    category: 'Card',
    quote: '당신은 당신이 할 수 있는 최선을 다하고 최악의 상황에 직면해도 감사해야 합니다.',
    author: '호주 인디언 속담',
    image:
      'https://user-images.githubusercontent.com/56837413/230787687-6f68fc2e-854c-434b-9f5f-feff6e2e53aa.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신은 자신의 목표를 이루기 위해서 노력해야 합니다. 그리고 그것이 이루어질 때까지 절대 포기하지 마십시오.',
    author: '데일 카네기',
    image:
      'https://user-images.githubusercontent.com/56837413/230787697-f16d99be-6d86-48ba-a6bc-75cb6ec577f5.jpg',
  },
  {
    category: 'Card',
    quote:
      '성공은 결코 쉽지 않습니다. 하지만 성공을 이루는 가장 좋은 방법은 우리가 원하는 것을 추구하고 끊임없이 노력하는 것입니다.',
    author: '나폴레옹 힐',
    image:
      'https://user-images.githubusercontent.com/56837413/230787699-c29dbf55-0a5e-4f2d-9c51-37b53618703b.jpg',
  },
  {
    category: 'Card',
    quote: '당신이 하고 있는 일에 대한 열정을 가지세요. 그리고 그것을 성공적인 것으로 만드세요.',
    author: '스티브 잡스',
    image:
      'https://user-images.githubusercontent.com/56837413/230787701-1efc1ddf-956e-4f8c-8500-8fc75c390ba8.jpg',
  },
  {
    category: 'Card',
    quote: '성공하는 가장 좋은 방법은 당신이 가진 것을 최대한 활용하는 것입니다.',
    author: '로이 T. 베넷',
    image:
      'https://user-images.githubusercontent.com/56837413/230787702-06ff5722-7b37-4240-94d6-c0e389146b2a.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신의 성공은 당신의 행동과 태도에 의해 결정됩니다. 그러므로, 당신이 가진 것을 최대한 활용하십시오.',
    author: '로이 T. 베넷',
    image:
      'https://user-images.githubusercontent.com/56837413/230787703-a6863993-9e5b-47ad-b2b5-d2de85003cf5.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신은 결국 무엇을 위해 살고 있는가요? 그것에 대한 대답을 찾아내면 당신은 무엇을 해야 하는지 알게 될 것입니다.',
    author: '미첼 해보',
    image:
      'https://user-images.githubusercontent.com/56837413/230787704-7c47859f-c2dc-470f-9e9f-52aceba466d5.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신이 가진 것을 최대한 활용하고, 노력하여 최선을 다하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '로이 T. 베넷',
    image:
      'https://user-images.githubusercontent.com/56837413/230787706-42222dd4-47b8-4f77-b9eb-47a0755a98a8.jpg',
  },
  {
    category: 'Card',
    quote: '당신이 가진 능력에 대해 자신감을 가지고 그것을 사용하면, 성공은 당신의 것입니다.',
    author: '조지 앨리어',
    image:
      'https://user-images.githubusercontent.com/56837413/230787707-a24fc913-3a72-464c-8388-25d4986c09ad.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신이 하고 있는 일에 대한 열정을 가지고 끝까지 추구하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
    image:
      'https://user-images.githubusercontent.com/56837413/230787710-1f027ab7-187e-49af-8005-dd870de3a095.jpg',
  },
  {
    category: 'Card',
    quote: '당신의 인생에서 중요한 것은 어떤 상황에서도 자신감을 가지고 성공을 추구하는 것입니다.',
    author: '로이 T. 베넷',
    image:
      'https://user-images.githubusercontent.com/56837413/230787712-39cfad1c-5b37-4475-be94-c379715e9549.jpg',
  },
  {
    category: 'Card',
    quote:
      '성공은 시간과 노력이 필요합니다. 하지만, 당신이 가진 것을 최대한 활용하고 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
    image:
      'https://user-images.githubusercontent.com/56837413/230787718-83ceb5b9-e2d3-4dc4-b88e-89c2cb0c7e70.jpg',
  },
  {
    category: 'Card',
    quote:
      '당신은 당신이 원하는 것을 이룰 수 있습니다. 그러나 그것을 위해서는 노력하고 인내심을 가져야 합니다.',
    author: '미첼 해보',
    image:
      'https://user-images.githubusercontent.com/56837413/230787721-72ee4053-0f53-4c34-a8de-a9a6c51aeb1e.jpg',
  },
];

// 동기 부여
export const MotivationQuotes: QuoteType[] = [
  {
    category: 'Motivation',
    quote: '자신감이란 자신의 가능성을 믿는 것입니다.',
    author: '빈스 롬바르디',
    image: 'https://pbs.twimg.com/profile_images/1326578374085472256/zBYZNAJN_400x400.jpg',
  },
  {
    category: 'Motivation',
    quote: '현재의 노력이 미래의 성취를 결정짓는다.',
    author: '데일 카네기',
  },
  {
    category: 'Motivation',
    quote: '당신의 머리와 마음은 당신이 정하는 것보다 훨씬 더 강합니다.',
    author: '마이크 김',
  },
  {
    category: 'Motivation',
    quote: '당신이 꿈꾸는 것은 이미 누군가의 현실입니다.',
    author: '존 레논',
  },
  {
    category: 'Motivation',
    quote: '시작하기 위해 기다릴 때보다 실패할 용기를 가지는 것이 낫습니다.',
    author: '로빈 쉐르마',
  },
  {
    category: 'Motivation',
    quote: '성공은 단순한 일이 아니며, 당신이 어렵게 얻은 것입니다.',
    author: '라리 페이지',
  },
  {
    category: 'Motivation',
    quote:
      '성공하는 것은 그것을 달성하기 위해 노력한 모든 시간과 에너지의 가치를 인정하는 것입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote: '행동하는 것이 생각하는 것보다 더 좋습니다.',
    author: '윌 로저스',
  },
  {
    category: 'Motivation',
    quote: '당신의 노력은 결국 당신의 결과가 됩니다.',
    author: '스티브 마블리',
  },
  {
    category: 'Motivation',
    quote: '성공은 실패에서 옵니다. 이유가 있어서 실패하는 것입니다.',
    author: '헨리 포드',
  },
  {
    category: 'Motivation',
    quote: '행복하게 살기 위해서는 먼저 원하는 것을 찾아야 합니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote: '당신의 꿈이 살아있는 한, 희망은 존재합니다.',
    author: '롤리 블랙',
  },
  {
    category: 'Motivation',
    quote: '당신이 노력하고 기도하는 것보다 더 중요한 것은 믿음입니다.',
    author: '조엘 오스틴',
  },
  {
    category: 'Motivation',
    quote: '시작이 어렵다면 끝도 어렵습니다. 하지만 시작하지 않으면 결코 끝내지 못합니다.',
    author: '토니 로빈스',
  },
  {
    category: 'Motivation',
    quote: '성공의 열쇠는 시도하는 것입니다.',
    author: '프랭크 라이트',
  },
  {
    category: 'Motivation',
    quote: '어디서든 누구나 시작할 수 있습니다. 중요한 것은 시작하는 것입니다.',
    author: '존 시든',
  },
  {
    category: 'Motivation',
    quote: '시도하지 않으면 실패하지 않을 뿐입니다.',
    author: '케네디',
  },
  {
    category: 'Motivation',
    quote: '성공은 세부적인 것에서 비롯됩니다.',
    author: '존 폴 게티',
  },
  {
    category: 'Motivation',
    quote:
      '현재의 상황은 미래를 결정하지 않습니다. 하지만 현재 상황을 변경하는 방법에 따라 미래는 달라질 수 있습니다.',
    author: '로버트 T. 커요사키',
  },
  {
    category: 'Motivation',
    quote: '일을 미루면 미룰수록 그 일에 대한 두려움은 더욱 커집니다.',
    author: '레온 브라운',
  },
  {
    category: 'Motivation',
    quote: '성공한 사람들은 실패할 수 있는 두려움보다 더 큰 용기를 가지고 있습니다.',
    author: '로버트 F. 케네디',
  },
  {
    category: 'Motivation',
    quote: '최선을 다하고, 결과에 대해 걱정하지 마세요. 결과는 자신의 노력에 대한 보상입니다.',
    author: '조지 버나드 쇼',
  },
  {
    category: 'Motivation',
    quote: '당신은 자신의 인생의 주인공입니다. 어떻게 연기할 것인가는 당신의 선택입니다.',
    author: '존 C. 맥스웰',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 할 수 있는 최선을 다하고 두려움 없이 모든 것을 살펴보세요. 그것이 성공에 가까워질 수 있는 가장 좋은 방법입니다.',
    author: '존 원',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 어떤 상황에서든 능력이 있습니다. 당신의 열정, 인내, 인내력, 믿음, 인내, 결단력을 모두 사용하십시오.',
    author: '데비드 J. 슈왈츠',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 우리가 원하는 것을 얻는 것이 아니라, 우리가 이루고자 하는 것을 추구하는 것입니다.',
    author: '로버트 J. 콜리어',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 당신이 무엇을 하는가에 따라 달라집니다. 그것은 당신의 행동, 선택, 노력, 그리고 인내력에 따라 결정됩니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote: '성공은 행동으로 이루어집니다. 말로만 말하지 마십시오. 행동으로 보여주세요.',
    author: '더글러스 매케이',
  },
  {
    category: 'Motivation',
    quote: '당신이 가진 것이 무엇보다도 중요한 것은 당신이 누구인가입니다.',
    author: '알버트 슈바이처',
  },
  {
    category: 'Motivation',
    quote: '당신이 하고 있는 것이 중요한 것이 아니라, 그것을 어떻게 하는지입니다.',
    author: '마이클 조던',
  },
  {
    category: 'Motivation',
    quote:
      '성공하려면, 당신은 출발해야 합니다. 그리고 실패할 가능성이 있다는 것을 감수해야 합니다.',
    author: '조지 앨리어',
  },
  {
    category: 'Motivation',
    quote: '당신은 출발하는 순간부터 성공을 이루기 시작합니다. 그래서 지금 출발하세요.',
    author: '마크 트웨인',
  },
  {
    category: 'Motivation',
    quote: '목표를 설정하고 끝까지 추구하세요. 그것이 당신의 인생에서 가장 중요한 것입니다.',
    author: '알랭 라파유',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 자신의 한계를 뛰어넘는 것입니다. 그것은 당신이 이루고자 하는 것을 추구하고 꿈을 위해 노력하는 것입니다.',
    author: '마이클 조던',
  },
  {
    category: 'Motivation',
    quote: '성공은 당신이 노력하고 자신감을 가지고 일할 때 옵니다.',
    author: '로버트 허브샤만',
  },
  {
    category: 'Motivation',
    quote:
      '당신의 인생은 당신의 행동에 의해 결정됩니다. 그러므로, 우리는 항상 최선을 다해야 합니다.',
    author: '사이먼 시넥',
  },
  {
    category: 'Motivation',
    quote:
      '당신의 성공은 당신의 내면의 모습에 의해 결정됩니다. 그것은 당신이 하고 있는 것, 그리고 그것을 어떻게 하는지입니다.',
    author: '데일 카네기',
  },
  {
    category: 'Motivation',
    quote: '당신은 당신이 할 수 있는 최선을 다하고 최악의 상황에 직면해도 감사해야 합니다.',
    author: '호주 인디언 속담',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 자신의 목표를 이루기 위해서 노력해야 합니다. 그리고 그것이 이루어질 때까지 절대 포기하지 마십시오.',
    author: '데일 카네기',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 결코 쉽지 않습니다. 하지만 성공을 이루는 가장 좋은 방법은 우리가 원하는 것을 추구하고 끊임없이 노력하는 것입니다.',
    author: '나폴레옹 힐',
  },
  {
    category: 'Motivation',
    quote: '당신이 하고 있는 일에 대한 열정을 가지세요. 그리고 그것을 성공적인 것으로 만드세요.',
    author: '스티브 잡스',
  },
  {
    category: 'Motivation',
    quote: '성공하는 가장 좋은 방법은 당신이 가진 것을 최대한 활용하는 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신의 성공은 당신의 행동과 태도에 의해 결정됩니다. 그러므로, 당신이 가진 것을 최대한 활용하십시오.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 결국 무엇을 위해 살고 있는가요? 그것에 대한 대답을 찾아내면 당신은 무엇을 해야 하는지 알게 될 것입니다.',
    author: '미첼 해보',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 노력하여 최선을 다하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote: '당신이 가진 능력에 대해 자신감을 가지고 그것을 사용하면, 성공은 당신의 것입니다.',
    author: '조지 앨리어',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정을 가지고 끝까지 추구하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote: '당신의 인생에서 중요한 것은 어떤 상황에서도 자신감을 가지고 성공을 추구하는 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 시간과 노력이 필요합니다. 하지만, 당신이 가진 것을 최대한 활용하고 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 당신이 원하는 것을 이룰 수 있습니다. 그러나 그것을 위해서는 노력하고 인내심을 가져야 합니다.',
    author: '미첼 해보',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 성공하고자 하는 것을 명확하게 알고, 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '성공하려면 노력이 필요합니다. 하지만, 노력만으로는 충분하지 않습니다. 당신이 가진 것을 최대한 활용하고, 지속적으로 개선해 나가야 합니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정과 노력을 가지고, 당신의 꿈을 실현하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote: '당신은 늘 최선을 다하십시오. 그리고 당신의 인생에서 최고의 결과를 이끌어 내십시오.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '성공을 이루려면 노력이 필요합니다. 하지만, 당신이 가진 것을 최대한 활용하고 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote: '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 성공은 당신의 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote: '성공을 이루려면, 당신은 끊임없이 노력하고, 지속적으로 개선해 나가야 합니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 당신이 가진 것을 최대한 활용하고, 당신의 목표를 이루기 위해 끊임없이 노력하는 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 향해 끊임없이 나아가십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 성공하고자 하는 것을 명확하게 정의하고, 그것을 위해 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 어떤 상황에서도 최선을 다하고, 자신의 인생에서 가장 좋은 결과를 이끌어 내십시오.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 실현하는 데 필요한 노력을 가지십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 어떤 상황에서도 자신감을 가지고 최선을 다하십시오. 그리고 당신은 그것을 통해 성공을 이룰 수 있습니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정과 노력을 가지고, 당신의 꿈을 실현하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 향해 끊임없이 나아가십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '성공하는 가장 좋은 방법은, 당신이 가진 것을 최대한 활용하고, 당신이 원하는 것을 이루기 위해 끊임없이 노력하는 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 성공하고자 하는 것을 명확하게 정의하고, 그것을 위해 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote: '당신은 늘 최선을 다하십시오. 그리고 당신의 인생에서 최고의 결과를 이끌어 내십시오.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 실현하는 데 필요한 노력을 가지십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 어떤 상황에서도 자신감을 가지고 최선을 다하십시오. 그리고 당신은 그것을 통해 성공을 이룰 수 있습니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 당신이 가진 것을 최대한 활용하고, 당신의 목표를 이루기 위해 끊임없이 노력하는 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 향해 끊임없이 나아가십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정과 노력을 가지고, 당신의 꿈을 실현하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 성공하고자 하는 것을 명확하게 정의하고, 그것을 위해 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 향해 끊임없이 나아가십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote: '당신은 늘 최선을 다하십시오. 그리고 당신의 인생에서 최고의 결과를 이끌어 내십시오.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 실현하는 데 필요한 노력을 가지십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정과 노력을 가지고, 당신의 꿈을 실현하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 어떤 상황에서도 자신감을 가지고 최선을 다하십시오. 그리고 당신은 그것을 통해 성공을 이룰 수 있습니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 성공하고자 하는 것을 명확하게 정의하고, 그것을 위해 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 향해 끊임없이 나아가십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '성공하는 가장 좋은 방법은, 당신이 가진 것을 최대한 활용하고, 당신이 원하는 것을 이루기 위해 끊임없이 노력하는 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote: '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 성공은 당신의 것입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정과 노력을 가지고, 당신의 꿈을 실현하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote: '당신은 늘 최선을 다하십시오. 그리고 당신의 인생에서 최고의 결과를 이끌어 내십시오.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 실현하는 데 필요한 노력을 가지십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정과 노력을 가지고, 당신의 꿈을 실현하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신은 어떤 상황에서도 자신감을 가지고 최선을 다하십시오. 그리고 당신은 그것을 통해 성공을 이룰 수 있습니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote: '성공을 이루려면, 당신은 끊임없이 노력하고, 지속적으로 개선해 나가야 합니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '성공은 당신이 가진 것을 최대한 활용하고, 당신의 목표를 이루기 위해 끊임없이 노력하는 것입니다.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 성공하고자 하는 것을 명확하게 정의하고, 그것을 위해 끊임없이 노력하면, 당신은 어떤 상황에서도 성공할 수 있습니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 가진 것을 최대한 활용하고, 꿈을 향해 끊임없이 나아가십시오. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '나폴레온 힐',
  },
  {
    category: 'Motivation',
    quote: '당신은 늘 최선을 다하십시오. 그리고 당신의 인생에서 최고의 결과를 이끌어 내십시오.',
    author: '로이 T. 베넷',
  },
  {
    category: 'Motivation',
    quote:
      '당신이 하고 있는 일에 대한 열정과 노력을 가지고, 당신의 꿈을 실현하세요. 그것이 성공으로 이끄는 가장 좋은 방법입니다.',
    author: '월트 디즈니',
  },
  {
    category: 'Motivation',
    quote: '당신이 가진 것을 최대한 활용하고, 끊임없이 노력하면, 성공은 당신의 것입니다.',
    author: '나폴레온 힐',
  },
];

export const SuccessQuotes: QuoteType[] = [
  {
    category: `Success`,
    quote: `가난한 사람은 덕행으로, 부자는 선행으로 이름을 떨쳐야 한다.`,
    author: `주베르`,
  },
  { category: `Success`, quote: `가는 자는 쫓지 말지며, 오는 자는 막지 말라.`, author: `맹자` },
  { category: `Success`, quote: `가르치는 것은 두번 배우는 것이다.`, author: `주베르` },
  {
    category: `Success`,
    quote: `가시나무를 심는 자는 장미를 기대해서는 안된다.`,
    author: `필페이`,
  },
  {
    category: `Success`,
    quote: `가시에 찔리지 않고서는 장미꽃을 모을 수가 없다.`,
    author: `필페이`,
  },
  {
    category: `Success`,
    quote: `가장 감사해야 할 것은 신이 주신 능력을 제대로 이용하는 것이다.`,
    author: `트릴로프`,
  },
  {
    category: `Success`,
    quote: `가장 깊은 감정은 항상 침묵속에 있다.`,
    author: `토머스 무어 - Thomas Moore`,
  },
  {
    category: `Success`,
    quote: `가장 깊은 진리는 가장 깊은 사랑에 의해서만 열린다.`,
    author: `하인리히 하이네 - 독일 시인 : 1797-1856`,
  },
  {
    category: `Success`,
    quote: `가장 높은 곳에 올라가려면, 가장 낮은 곳부터 시작하라.`,
    author: `푸블릴리우스 시루스`,
  },
  { category: `Success`, quote: `가장 뛰어난 예언자는 과거이다.`, author: `바이런` },
  {
    category: `Success`,
    quote: `가장 무서운 사람은 침묵을 지키는 사람이다.`,
    author: `호라티우스 - 로마 시인 : BC 65-8`,
  },
  {
    category: `Success`,
    quote: `가장 부유한 사람은 절약가이고 가장 가난한 사람은 수전노이다.`,
    author: `상포르`,
  },
  {
    category: `Success`,
    quote: `가장 오래 지속되는 사랑은 다시는 돌아오지 않는 사랑이다.`,
    author: `윌리엄 서머싯 몸 - 영국 작가:1874 ~ 1965`,
  },
  {
    category: `Success`,
    quote: `가장 최상의 길은 없다. 많은 사람이 가고 있다면 그 길이 최상이다.`,
    author: `루신`,
  },
  {
    category: `Success`,
    quote: `가장 큰 어려운 일 중 세가지, 첫째는 명성을 얻는 것, 둘째는 생명있는 동안 명성을 유지 하는것, 셋째는 죽은 뒤에도 명성을 보유하는것.`,
    author: `프란츠 요제프 하이든 - 오스트리아 작곡가`,
  },
  {
    category: `Success`,
    quote: `가장 탁월한 천분도 무위도식에 의해서 멸망된다.`,
    author: `몽테뉴`,
  },
  {
    category: `Success`,
    quote: `가장 훌륭한 기술, 가장 배우기 어려운 기술은 세상을 살아가는 기술이다.`,
    author: `메이시`,
  },
  {
    category: `Success`,
    quote: `가장 훌륭한 예언은 상식,즉 우리의 원래의 지혜이다.`,
    author: `에우리피데스`,
  },
  {
    category: `Success`,
    quote: `가장 훌륭한 인간은 모든 사람을 사랑하는 사람이다. 그 사람은 좋고 나쁨을 가리지 않고 모든 사람에게 선으 베푸는 사람이다.`,
    author: `마호메트 - 이슬람교창시자:570~632`,
  },
  {
    category: `Success`,
    quote: `가정과 가정 생활의 안전과 향상이 문명의 중요 목적이요, 산업의 궁극적 목적이다.`,
    author: `C.W.엘리어`,
  },
  {
    category: `Success`,
    quote: `가정은 그대가 그곳에 가야만 할 때, 그들이 받아들여야 하는 곳이다.`,
    author: `R.L.프로스트`,
  },
  {
    category: `Success`,
    quote: `가정은 나의 대지이다. 나는 거기서 나의 정신적인 영양을 섭취하고 있다.`,
    author: `펄 벅 - 미국 작가:1892~1973`,
  },
  {
    category: `Success`,
    quote: `가정은 사람이 '있는 그대로'의 자기를 표시할 수 있는 장소이다.`,
    author: `A.모루아`,
  },
  { category: `Success`, quote: `가정은 삶의 보물상자가 되어야 한다.`, author: `코르뷔제` },
  {
    category: `Success`,
    quote: `가정이 가난하고 신분이 천한 것은 부끄러워할 것이 아니고,올바른 진리를 배워 가지고도 실행하지 않는 것이 실로 부끄로운 일이다.`,
    author: `강 수`,
  },
  {
    category: `Success`,
    quote: `가정이란 어떠한 형태의 것이든 인생의 커다란 목표이다.`,
    author: `J.G.홀랜드`,
  },
  { category: `Success`, quote: `가정이여, 그대는 도덕의 학교이다.`, author: `J.H.페스탈로치` },
  {
    category: `Success`,
    quote: `가족, 친구, 조국, 모든 사람을 위해서 힘을 써라. 들뜬 마음, 나약함을 물리쳐라, 용기를 가져라, 강해져라. 즉 남자가 되라.`,
    author: `앙리 프레데리크 아미엘 - 스위스 철학자 : 1821-1881`,
  },
  {
    category: `Success`,
    quote: `가치있는 적이 될 수 있는 자는 화해하면 더 가치있는 친구가 될 것이다.`,
    author: `펠담`,
  },
  {
    category: `Success`,
    quote: `갑작스럽게 착한 사람이 되거나 악인이 되는 사람은 없다.`,
    author: `시드니`,
  },
  {
    category: `Success`,
    quote: `강도는 당신의 돈이나 생명의 어느 하나를 요구한다. 그러나 여자는 그 양쪽을 요구한다.`,
    author: `버클러`,
  },
  {
    category: `Success`,
    quote: `강렬한 욕망을 버리고 싶거든 그 어머니인 낭비를 버려라.`,
    author: `마르쿠스 툴리우스 키케로 - Marcus Tullius Cicero`,
  },
  { category: `Success`, quote: `강을 거슬러 헤엄치는 자가 강물의 세기를 안다.`, author: `윌슨` },
  {
    category: `Success`,
    quote: `강한 사람이란 가장 훌륭하게 고독을 견디어 낸 사람이다.`,
    author: `쉴러`,
  },
  { category: `Success`, quote: `강한 인간이 되고 싶다면 물과 같아야 한다.`, author: `노자` },
  {
    category: `Success`,
    quote: `강한 자가 이기는 것이 아니라 이긴 자가 강한 것이다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `개선으로부터 몰락까지의 거리는 단 한걸음에 지나지 않는다. 나는 사소한 일이 가장 큰 일을 결정함을 보았다.`,
    author: `보나파르트 나폴레옹`,
  },
  {
    category: `Success`,
    quote: `개성과 인간과의 관계는 향기와 꽃과의 관계이다.`,
    author: `시위브`,
  },
  {
    category: `Success`,
    quote: `개조해야 할 것은 세계뿐이 아니라 인간이다. 그 새로운 인간은 어디서 나타날 것인가 ? 그것은 결코 외부로부터 오지 않는다.친구여, 그것은 자신 속에서 발견된다는 것을 깨달으라.`,
    author: `앙드레 폴 기욤 지드 - 프랑스소설가:1869~1951`,
  },
  {
    category: `Success`,
    quote: `거룩하고 즐겁고 활기차게 살아라.믿음과 열심에는 피곤과 짜증이 없다.`,
    author: `어니스트 핸즈`,
  },
  {
    category: `Success`,
    quote: `거만한 자를 책망하지 말라. 그가 너를 미워할까 두렵다. 지혜있는 자를 책망하라. 그가 너를 사랑하리라.`,
    author: `성경 잠언`,
  },
  {
    category: `Success`,
    quote: `거지에게 침대를 주면 거지는 보답으로 이를 줄 것이다.`,
    author: `레이`,
  },
  {
    category: `Success`,
    quote: `거짓말은 눈사람 같아서 오래 굴리면 그만큼 더 커진다.`,
    author: `로터`,
  },
  {
    category: `Success`,
    quote: `거짓말을 한 그 순간부터 뛰어난 기억력이 필요하게 된다.`,
    author: `코르네이유`,
  },
  {
    category: `Success`,
    quote: `거짓말쟁이가 받는 가장 큰 형벌은 그가 다른 사람으로부터 신임을 받지 못한다는 것보다 그 자신이 아무도 믿지 못한다는 슬픔에 빠지는 데에 있다.`,
    author: `조지 버나드 쇼 - George Bernard Shaw`,
  },
  {
    category: `Success`,
    quote: `걱정없는 인생을 바라지 말고 걱정에 물들지 않는 연습을 하라.`,
    author: `알랭 - 프랑스 철학자`,
  },
  { category: `Success`, quote: `건강과 부는 미를 창조한다.`, author: `H.G.보운` },
  { category: `Success`, quote: `건강과 지성은 인생의 두가지 복이다.`, author: `메난드로스` },
  {
    category: `Success`,
    quote: `건강은 有一無二유일무이의 보배이며 이것을 얻기 위해서는 생명 자체까지 내던진다.`,
    author: `미셸 에켐 드 몽테뉴 - 프랑스 사상가:1533~1592`,
  },
  { category: `Success`, quote: `건강은 행복의 어머니이다.`, author: `프란시스 톰슨` },
  {
    category: `Success`,
    quote: `건강을 유지한다는 것은 자기에 대한 의무인 동시에 사회에 대한 의무이다. 오늘날 백살이 넘게 오래 산 사람은 거의 모두가 여름이나 겨울에 일찍 일어난 사람들이다.`,
    author: `푸슈킨 - 러시아 시인 : 1799-1837`,
  },
  {
    category: `Success`,
    quote: `건강이 있는 곳에 자유가 있다. 건강은 모든 자유중에서 으뜸가는 것이다.`,
    author: `앙리 프레데리크 아미엘 - 스위스 철학자:1821~1881`,
  },
  { category: `Success`, quote: `건강한 신체에 건강한 정신.`, author: `유베날리스` },
  { category: `Success`, quote: `검약은 훌륭한 소득이다.`, author: `에라스무스` },
  {
    category: `Success`,
    quote: `겁쟁이는 죽음에 앞서서 여러 차례 죽지만 용기있는 자는 한번밖에 죽지 않는다.`,
    author: `셰익스피어`,
  },
  {
    category: `Success`,
    quote: `게으름은 쇠붙이의 녹과 같다. 노동보다도 더 심신을 소모시킨다.`,
    author: `프랭클린`,
  },
  {
    category: `Success`,
    quote: `겨울은 하늘의 물도, 사람의 마음도 돌처럼 만들어 버린다.`,
    author: `빅토르 마리 위고 - 프랑스 소설가 : 1802-1885`,
  },
  {
    category: `Success`,
    quote: `격에 맞지 않는 선행은 악행이라고 나는 생각한다.`,
    author: `엔니우스`,
  },
  { category: `Success`, quote: `결백한 자와 미인은, 시간 이외에는 적이 없다.`, author: `예이츠` },
  {
    category: `Success`,
    quote: `결점 없는 사람을 고르다간 끝내 벗을 얻을 수 없다.`,
    author: `프랑스 속담`,
  },
  {
    category: `Success`,
    quote: `결함이 나의 출발의 바탕이고 무능이 나의 근원이다.`,
    author: `발레리`,
  },
  {
    category: `Success`,
    quote: `결혼도 역시 일반 약속과 마찬가지로 성을 달리하는 두 사람 즉, 나와 그대 사이에만 아이를 낳자는 계약이다. 이 계약을 지키지 않는 것은 기만이며 배신이요, 죄악이다.`,
    author: `L.N.톨스토이`,
  },
  { category: `Success`, quote: `결혼은 자손 만대의 시작이다.`, author: `예기` },
  {
    category: `Success`,
    quote: `결혼이란 경건하고 신성한 결합이다. 그러므로 거기에서 얻어지는 즐거움은 억제되고 진지하며 조심스럽고 양심적인 쾌락이어야 한다.`,
    author: `M.E.몽테뉴`,
  },
  {
    category: `Success`,
    quote: `결혼이란, 독립은 동등하고 의존은 상호적이며, 의무는 상반되는 남녀간의 관계이다.`,
    author: `L.K.안스파`,
  },
  { category: `Success`, quote: `결혼이란 하늘에서 맺어지고 땅에서 완성된다.`, author: `존 릴리` },
  {
    category: `Success`,
    quote: `결혼 전에는 눈을 크게 뜨고, 결혼 후에는 반쯤 감아라.`,
    author: `프랭클린`,
  },
  {
    category: `Success`,
    quote: `결혼 전에는 두 눈을 커다랗게 뜨고 보라. 결혼 후에는 한쪽 눈을 감으라.`,
    author: `토머스 풀러`,
  },
  {
    category: `Success`,
    quote: `결혼하는 편이 좋은가, 아니면 하지 않는 편이 좋은가를 묻는다면 나는 어느 편이나 후회할 것이라고 대답하겠다.`,
    author: `소크라테스`,
  },
  {
    category: `Success`,
    quote: `겸손은 남의 칭찬을 싫어하는 듯이 보이지만 사실은 좀더 넌즈시 칭찬받고 싶다는 욕망에 불과하다.`,
    author: `라 로시푸코`,
  },
  { category: `Success`, quote: `겸손은 모든 미덕의 근본이다.`, author: `P.J.베일리` },
  {
    category: `Success`,
    quote: `겸손은 범인에게는 한갓 성실이지만, 위대한 재능의 소유자인 사람에게는 위선이다.`,
    author: `W.셰익스피어`,
  },
  {
    category: `Success`,
    quote: `겸손은 신이 우리에게 제물을 바치기 바라는 제단이다.`,
    author: `라 로시푸코`,
  },
  { category: `Success`, quote: `겸손은 신이 인간에게 내린 최고의 덕이다.`, author: `브하그완` },
  { category: `Success`, quote: `겸손은 육체의 양심이다.`, author: `H.발자크` },
  {
    category: `Success`,
    quote: `겸손이 없다면 당신은 인생의 가장 기본적인 교훈도 배울 수가 있다.`,
    author: `좀 톤슨`,
  },
  {
    category: `Success`,
    quote: `겸손하고 양보하는 마음은 인격을 완성하는데 있어서 절대 필요한 양식이다. 이러한 인격 완성의 양식이 떨어지면 사람들은 교만하고 약해진다.`,
    author: `존 러스킨 - 영국 비평가:1819~1900`,
  },
  {
    category: `Success`,
    quote: `겸손하지 못한 사람은 언제나 타인을 비난한다. 그런 사람은 다만 타인의 그릇된 것만을 인정한다. 그럼으로써 그사람 자신의 욕망과 죄과는 점점 더 커가는 것이다.`,
    author: `레프 니콜라예비치 톨스토이 - 미국 시인:1807~1882`,
  },
  {
    category: `Success`,
    quote: `겸손한 사람은 언제나 신을 그의 안내자로 삼을 것이다.`,
    author: `번연`,
  },
  {
    category: `Success`,
    quote: `겸손한 자만이 다스릴 것이요, 애써 일하는 자만이 가질 것이다.`,
    author: `에머슨`,
  },
  { category: `Success`, quote: `경험은 지식의 어머니이다.`, author: `브레튼` },
  {
    category: `Success`,
    quote: `경험은 최고의 교사이다. 다만 수업료가 지나치게 비싸다고 할까.`,
    author: `칼라일`,
  },
  {
    category: `Success`,
    quote: `경험이 많을수록 말 수가 적어지고 슬기를 깨칠수록 감정을 억제한다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `고난과 눈물이 나를 높은 예지로 이끌어 올렸다. 보석과 즐거움은 이것을 이루어 주지 못했을 것이다.`,
    author: `하인리히 페스탈로치 - Johann Heinrich Pestalozzi`,
  },
  { category: `Success`, quote: `고난은 인간의 진가를 증명하는 것이다.`, author: `에피테토스` },
  {
    category: `Success`,
    quote: `고뇌는 철저하게 경험하는 것에 의해서만 치유될 수 있다.`,
    author: `마르셀 프루스트 - Marcel Proust`,
  },
  {
    category: `Success`,
    quote: `고독은 이 세상에서 가장 무서운 괴로움이다. 아무리 지독한 공포에도 모두가 함께 있으면 견딜만하지만 고독만은 죽음과 같다.`,
    author: `콘스탄트 비르질 게오르규 - 루마니아 망명작가 : 1916-1992`,
  },
  { category: `Success`, quote: `고독은 지혜의 최선의 유모다.`, author: `로런스 시테르네` },
  { category: `Success`, quote: `고독한 것이 두렵다면 결혼을 하지 마라.`, author: `체홉` },
  {
    category: `Success`,
    quote: `고립된 개인은 존재하지 않는다. 슬픈자는 타인을 슬프게 한다.`,
    author: `앙투안 드 생텍쥐페리 - 프랑스 작가`,
  },
  {
    category: `Success`,
    quote: `고민은 어떤 일을 시작하였기 때문에 생기기보다는 일을 할까 말까 망설이는 데에서 더 많이 생긴다. 실패를 미리 두려워할 필요는 없다. 성공하고 못하고는 하늘에 맡겨 두는게 좋다.`,
    author: `버트런드 아서 윌리엄 러셀 - 영국 철학자`,
  },
  {
    category: `Success`,
    quote: `고통은 인간의 위대한 교사이다. 고통의 숨결 속에서 영혼은 발육된다.`,
    author: `에센 바하`,
  },
  { category: `Success`, quote: `고통을 주지 않는 것은 쾌락도 주지 않는다.`, author: `몽테뉴` },
  {
    category: `Success`,
    quote: `고향을 묻지 말자 우리가 고국에 돌아가게 되면 피차 고향을 묻지 말고 일하자 . 인화와 단결이야말로 국권을 회복하는 과정에서 뿐 만 아니라 나라가 독립했을 경우에도 마찬가지로 중요한 것이다.`,
    author: `고당 조만식`,
  },
  { category: `Success`, quote: `곤란이란 위대한 마음을 키워주는 유모이다.`, author: `브라이언트` },
  {
    category: `Success`,
    quote: `공복으로 때를 짐작하고 졸음이 올 때 겨우 끝을 내는 짓을 하지 않는다면 여름날이 얼마나 끝없이 길다는 것을 모를 것이다.`,
    author: `스티븐슨`,
  },
  {
    category: `Success`,
    quote: `공손과 인간성과의 관계는, 따스함과 밀초와의 관계와 같다.`,
    author: `쇼펜하우어`,
  },
  {
    category: `Success`,
    quote: `공손이란 가장 친절한 방법으로 가장 친절한 것을 향하고 말하는 것이다.`,
    author: `루이전`,
  },
  { category: `Success`, quote: `공인된 키스는 훔친 키스보다 감미롭지 못하다.`, author: `모파상` },
  {
    category: `Success`,
    quote: `공정하고 바른데는 근거를 두었다면 긍지보다 이익을 주는 것은 좀처럼 없다.`,
    author: `밀턴`,
  },
  {
    category: `Success`,
    quote: `공화국은 사치로 멸망하며, 전제주의 국가는 빈곤으로 멸망한다.`,
    author: `몽테스키에`,
  },
  {
    category: `Success`,
    quote: `과거는 잊어버리고 다른 일에 몰두하자. 이것이 고민의 해결이다.`,
    author: `잭 템프시`,
  },
  {
    category: `Success`,
    quote: `과거에 한 번도 적을 만들어 본 일이 없는 인간은 결코 친구를 가질 수 없다.`,
    author: `테니슨`,
  },
  {
    category: `Success`,
    quote: `과도한 재산을 소유하게 되었을 때보다 더 시련을 당하게 되는 적은 없다.`,
    author: `레우왈레이스`,
  },
  {
    category: `Success`,
    quote: `과장에는 과장으로 대처하라. 재치있는 말은 상황과 경우에 따라 사용되어야 하며, 이것이 바로 지혜의 힘임을 알라.`,
    author: `발타자르 그라시안 - 스페인 철학자`,
  },
  {
    category: `Success`,
    quote: `관습은 법만큼 현명하지 못할지 모른다. 그러나 관습은 언제나 법보다 훨씬 보편적이다.`,
    author: `벤자민 디즈레일리 - Benjamin Disraeli earl of Beaconsfield`,
  },
  {
    category: `Success`,
    quote: `관용이란 무엇인가. 그것은 인간애의 소유이다. 우리는 모두 약함과 과오로 만들어져 있다. 우리는 어리석음을 서로 용서한다. 이것이 자연의 제일 법칙이다.`,
    author: `볼테르 - 프랑스 사상가 : 1694-1778`,
  },
  {
    category: `Success`,
    quote: `괴로워하거나 불평하지 말라. 사소한 불평은 눈감아 버리라. 어떤 의미에서는 인생의 큰 불행까지도 감수하고 목적만을 향하여 똑바로 전진하라.`,
    author: `빈센트 반 고흐 - Vincent Willem van Gogh`,
  },
  {
    category: `Success`,
    quote: `괴로움을 견디려면 죽는 것보다 더 큰 용기가 필요하다.`,
    author: `나폴레옹`,
  },
  {
    category: `Success`,
    quote: `교사의 임무는 독창적인 표현과 지식의 희열을 불러 일으켜주는 일이다.`,
    author: `알베르트 아인슈타인 - 미국의 물리학자 : 1897~1955`,
  },
  {
    category: `Success`,
    quote: `교육의 목표는 지식의 증진과 진리의 씨뿌리기이다.`,
    author: `케네디`,
  },
  {
    category: `Success`,
    quote: `교육이란 화를 내지 않고, 자신감을 잃지 않으면서도 거의 모든것에 귀기울일 수 있는 능력이다.`,
    author: `로버트 프로스트 - 미국 시인:1874~1963`,
  },
  {
    category: `Success`,
    quote: `구(9)개월이 걸려 인간은 살아갈 준비를 하지만 인간을 죽음으로 인도하는 데는 일순간만으로도 충분하다.`,
    author: `로가우`,
  },
  {
    category: `Success`,
    quote: `국가가 그 권위에의 비판을 어느 정도까지 허용 하는가가 그 국가가 사회의 충성심을 어느 정도까지 쥐고 있는가에 대한 가장 확실한 지표다.`,
    author: `해럴드 조지프 래스키 - 1893 ~ 1950 : 영국의 철학자`,
  },
  {
    category: `Success`,
    quote: `국가는 영토와 국민과 법률로 구성된다고 말할 수 있을 것이다. 영토는 어떤 내구적인것으로 이루어지는 유일한 부분이다.`,
    author: `에이브러햄 링컨 - 미국 16대 대통령:1809~1865`,
  },
  {
    category: `Success`,
    quote: `국가는 좋은 생활을 위해서 존재하지 생활만을 위해서 존재하지 않는다.`,
    author: `아리스토텔레스`,
  },
  {
    category: `Success`,
    quote: `국가란 내일을 위한 계획을 가지고 있다는 사실에 의하여 형성되고 생명이 유지된다.`,
    author: `J.오르데가이 가세트`,
  },
  { category: `Success`, quote: `국가란 어머니와 같은 것이다.`, author: `소크라테스` },
  {
    category: `Success`,
    quote: `국가란 인간이나 다름이 없다. 국가도 인간의 가지각색의 성격으로 형성되어 있으므로.`,
    author: `플라톤`,
  },
  { category: `Success`, quote: `국가란 최고의 도덕적인 존재이다.`, author: `H.트라이치케` },
  {
    category: `Success`,
    quote: `국가의 가치는 결국 그것을 구성하고 있는 개개인의 가치다.`,
    author: `J S 밀`,
  },
  {
    category: `Success`,
    quote: `국내 생산성이 다양한 한, 전문화와 무역은 유리하게 된다. 똑같이 국가간에도 적용된다. 국가간의 교역은 우리가 한 재화를 다른 것으로 바꾸는데 효과적인 방법이며, 국내 생산에만 의존하는 것보다 훨씬 효과적이다.`,
    author: `폴 앤터니 새뮤얼슨 - 미국 경제학자 : 1915-`,
  },
  {
    category: `Success`,
    quote: `군대가 강하면 즉 멸망할 것이요, 나무가 단단하면 즉 부러진다.`,
    author: `노자`,
  },
  {
    category: `Success`,
    quote: `국민이 내일에의 신념을 갖지 않으면 발전은 있을 수 없다.`,
    author: `존 피츠제럴드 케네디 - John Fitzgerald Kennedy`,
  },
  {
    category: `Success`,
    quote: `군인은 다른 모든 국민보다 평화를 기구한다. 그는 깊은 상처와 전쟁의 상흔을 고통받고, 참아야 하기 때문이다.`,
    author: `더글라스 맥아더 - 미국장군:1880~1964`,
  },
  {
    category: `Success`,
    quote: `군인이 소유할 수 있는 가장 중요한 자질은 철저하고, 완전하고, 거만한 자신감이다.`,
    author: `조지 스미스 패튼 - George Smith Patton`,
  },
  { category: `Success`, quote: `군자는 기회가 없다고 불평하지 않는다.`, author: `에머슨` },
  { category: `Success`, quote: `군자는 의리에 밝고, 소인은 이익에 밝다.`, author: `세익스피어` },
  {
    category: `Success`,
    quote: `군자의 사귐은 담담함이 물과 같고, 소인의 사귐은 달콤함이 단술과 같다.`,
    author: `장자`,
  },
  {
    category: `Success`,
    quote: `군주는 민중으로부터 사랑받지 않아도 좋지만 원망받지 말아야 한다. 이것은 시민들이 생명과 재산에 대한 위협없이 안심하고 살 수 있게만 해준다면 얼마든지 가능하다.`,
    author: `니콜로 마키아벨리 - Niccolo Machiavelli`,
  },
  {
    category: `Success`,
    quote: `군중이란 설령 좋은 사람만 모인 곳에서라도 동물적인 큰 악한 면만 나타내는 것이고, 인간의 본성적 약점과 잔인성만 보이는 법이다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아 작가 : 1828-1910`,
  },
  { category: `Success`, quote: `굳은 결심은 가장 유용한 지식이다.`, author: `나폴레옹` },
  { category: `Success`, quote: `굴욕적인 신앙보다는 숫제 무신앙인 편이 좋다.`, author: `베이컨` },
  {
    category: `Success`,
    quote: `굶주림이 혁명을 낳는 것은 아니다. 그보다도 민중이 먹게 되자 식욕을 얻은 것이다.`,
    author: `니체`,
  },
  {
    category: `Success`,
    quote: `권리는 어느 곳에나 도리를 벗어난 곳에서는 존재할수 없다.`,
    author: `파크`,
  },
  {
    category: `Success`,
    quote: `권세가 인간을 교만으로 이끌어갈 때, 시가 그에게 한계를 상기시켜준다.`,
    author: `케네디`,
  },
  {
    category: `Success`,
    quote: `귀하여! 가라, 달려라, 그리고 세계가 6일 동안에 만들어졌음을 잊지말라. 그대는 그대가 원하는 것은 무엇이든지 나에게 청구할수 있지만 시간만은 안된다.`,
    author: `보나파르트 나폴레옹 - 프랑스군인황제:1769~1821`,
  },
  {
    category: `Success`,
    quote: `그날의 일은 그날 해치우는 것이 나의 일상규칙이다.`,
    author: `웨링턴`,
  },
  {
    category: `Success`,
    quote: `그는 시골을 무척 좋아한다. 그런데 실은 그가 시골이 가장 좋아지는 것은 도시에서 시골에 관해 배우고 있을 때이다.`,
    author: `윌리엄 쿠퍼 - 영국 시인 : 1731-1800`,
  },
  {
    category: `Success`,
    quote: `그대는 두개의 손과 한개의 입을 가지고 있다. 그 뜻을 잘 생각해보라. 하나가 노동을 위해서, 다른 하나가 식사를 위해서 있다.`,
    author: `하인리히 리케르트 - 독일 철학자 : 1863-1939`,
  },
  {
    category: `Success`,
    quote: `그대들은 씨를 뿌린다. 거두어들이는 것은 다른 사람들이다. 그대들은 부를 발견했다. 그것들을 모으는 것은 다른 사람들이다. 그대들은 옷감을 짰으나 입는 것은 다른 사람들이다. 그대들은 무기를 만든다. 쓰는 것은 다른 사람들이다.`,
    author: `셀리`,
  },
  {
    category: `Success`,
    quote: `그대에게 죄를 지은 사람이 있거든, 그가 누구이든 그것을 잊어버리고 용서하라. 그때에 그대는 용서한다는 행복을 알 것이다. 우리에게는 남을 책망할 수 있는 권리는 없는 것이다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아작가:1828~1910`,
  },
  {
    category: `Success`,
    quote: `그대의 생활은 그대 자신이 거기에 의미를 부여하려고 노력하는, 그 노력에 따라서 꼭 그만큼의 의미를 갖는다.`,
    author: `헤르만 헤세 - 독일 시인`,
  },
  { category: `Success`, quote: `그래도 지구는 돈다.`, author: `갈릴레오 - G. Galileo` },
  {
    category: `Success`,
    quote: `그릇이 차면 넘치고, 사람이 자만하면 이지러진다.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `그 어떤 강제의 의해서 우리들은 결코 행복하게 될 수는 없다.`,
    author: `콜르리지`,
  },
  {
    category: `Success`,
    quote: `극단은 부도덕한 것이다. 그건 사람으로부터 발생한다. 모든 균형은 옳다. 그 것은 신으로부터 오는 것이므로.`,
    author: `라 브르예르`,
  },
  {
    category: `Success`,
    quote: `근대는 비극을 희극의 옷속에 감추고 위대한 진실도 평범하게, 혹은 추악하 게 혹은 아무것도 없는 것으로 만들었다. 이것 이 틀림없는 근대성이란 것 이다.`,
    author: `와일드`,
  },
  { category: `Success`, quote: `근로가 잠들면 빈곤은 창으로 들어온다.`, author: `라이닉` },
  {
    category: `Success`,
    quote: `근면이야말로 태만, 불성실, 빈곤의 세가지 부끄러움을 쫓아줍니다.`,
    author: `볼테일`,
  },
  { category: `Success`, quote: `근심은 미를 훔치는 도둑이다.`, author: `마미언` },
  {
    category: `Success`,
    quote: `근심은 세월을 거치지 않고 백발과 노령을 가져온다.`,
    author: `영국 속담`,
  },
  {
    category: `Success`,
    quote: `금전은 무자비한 주인이지만 유익한 종이 되기도 한다.`,
    author: `유태격언`,
  },
  {
    category: `Success`,
    quote: `긍지는 인간이 입을 수 있는 가장 훌륭한 갑옷이다.`,
    author: `제롬`,
  },
  {
    category: `Success`,
    quote: `기계는 인간을 위대한 자연의 문제로부터 분리시키지 않을 것이다. 오히려 더욱 심각한 문제로 인간을 괴롭힐 것이다.`,
    author: `앙투안 드 생텍쥐페리 - 프랑스 작가:1900~1944`,
  },
  {
    category: `Success`,
    quote: `기고만장하게 행동하느니보다 허리를 굽히는 것이 슬리로움에 더 가깝다.`,
    author: `윌리엄 워즈워스 - 영국 시인:1770~1850`,
  },
  { category: `Success`, quote: `기대하지 않는 자는 실망하지도 않을 것이다.`, author: `울거트` },
  {
    category: `Success`,
    quote: `기도는 음악처럼 신성하고 구원이 된다. 기도는 신뢰이며 확인이다. 진정 기도하는 자는 원하지 않는다. 단지 자기의 경우와 고뇌를말할 뿐이다.`,
    author: `헤르만 헤세 - Hermann Hesse`,
  },
  {
    category: `Success`,
    quote: `기둥이 약하면 집이 흔들리듯, 의지가 약하면 생활도 흔들린다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `기분좋은 잠과 부담없는 독서 사이에는 밀접한 관계가 있다. 어느 경우에도 심장의 고동이 부드러워지고 긴장감이 풀리며, 마음은 냉정하게 된다. 최선의 독서법은 잠자리 곁에서의 독서이다.`,
    author: `林語堂 - 중국문학가:1895~1976`,
  },
  {
    category: `Success`,
    quote: `기억은 종종 어리석음의 속성이다. 그것은 무거운 정신의 소유자의 것으로서, 그들에게 지워짐으로써 주저앉을 정도로 그 무거움을더하게 만든다.`,
    author: `프랑수아 르네 드 샤토브리앙 - Francois Auguste Rene, vicomte de Chateaubriand`,
  },
  { category: `Success`, quote: `기와 한장 아껴서 대들보 썩는다.`, author: `한국 속담` },
  {
    category: `Success`,
    quote: `기회는 새와 같은 것, 날아가기 전에 꼭 잡아라.`,
    author: `스마일즈`,
  },
  {
    category: `Success`,
    quote: `기쁨을 그 자신에게 묶어두는 사람은 날개달린 인생을 파괴한다. 그러나 기쁨이 날아갈 때 그것에 키스하는 사람은 영원한 해돋이에서 산다.`,
    author: `윌리엄 블레이크 - WIlliam Blake`,
  },
  {
    category: `Success`,
    quote: `기쁨을 주는 사람만이 더 많은 기쁨을 즐길 수 있다.`,
    author: `알렉산더 듀마`,
  },
  {
    category: `Success`,
    quote: `깃털보다도 가벼운 것은 - 먼지다. 먼지보다도 가벼운 것은 - 바람이다. 바람보다도 가벼운 것은 - 여자다. 여자보다도 가벼운 것은 - 아무 것도 없다.`,
    author: `뭇세`,
  },
  {
    category: `Success`,
    quote: `깊고 무서운 진실을 말하라. 자기가 느낀 바를 표현하는 데 있어 결코 주저하지 말라.`,
    author: ` `,
  },
  { category: `Success`, quote: `깨끗한 의복은 좋은 소개장.`, author: `영국속담` },
  {
    category: `Success`,
    quote: `깨닫기만 하고 실천을 안하면 깨달음이 아무 소용없다.`,
    author: `힐티`,
  },
  {
    category: `Success`,
    quote: `꿈을 품고 무언가 할 수 있다면 그것을 시작하라. 새로운 일을 시작하는 용기 속에 당신의 천재성과 능력과 기적이 모두 숨어 있다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `끝나 버리기 전에는 무슨 일이든 불가능하다고 생각하지 말라.`,
    author: `마르쿠스 툴리우스 키케로 - Marcus Tullius Cicero`,
  },
  {
    category: `Success`,
    quote: `나는 간소하면서 아무 허세도 없는 생활이야말로 모든 사람에게 최상의 것. 육체를 위해서나 정신을 위해서나 최상의 것이라고 생각한다.`,
    author: `알베르토 아인슈타인 - Albert Einstein`,
  },
  {
    category: `Success`,
    quote: `나는 감사하며 미안해하는 새앙쥐처럼 '찍찍' 하지 않고 나의 직업에 자만심을 가지고 사자처럼 외치고 싶다.`,
    author: `존 어니스트 스타인벡 - 미국 소설가:1902~1968`,
  },
  { category: `Success`, quote: `나는 나 자신을 빼놓고는 모두 안다.`, author: `비용` },
  {
    category: `Success`,
    quote: `나는 내가 알기 원하는 것을 배우려면 늙어야 하겠고, 내가 아는 것을 말하기 위해서는 젊어야 하겠다.`,
    author: `조제프 주베르 - Barthelemy Catherine Joubert`,
  },
  {
    category: `Success`,
    quote: `나는 내 운명의 주인이요, 나는 내 마음의 선장이다.`,
    author: `윌리암 어네스트 헨리`,
  },
  {
    category: `Success`,
    quote: `나는 대단한 인간이 아니다. 노력하는 노인일뿐이다.`,
    author: `넬슨 롤리랄라 만델라 - 남아공 대통령`,
  },
  {
    category: `Success`,
    quote: `나는 비극을 사랑한다. 나는 비극의 밑바닥에는 언제나 어떤 아름다운 것이 있음으로해서 비극을 사랑한다.`,
    author: `찰리 채플린 - 미국 희극배우 : 1889-1977`,
  },
  { category: `Success`, quote: `나는 세계 시민이다.`, author: `디오게네스 - Diogenes` },
  {
    category: `Success`,
    quote: `나는 아무래도 이 세상에서 한 사람의 여행하는 사람, 한 개의 편로에 지나지 않는 것 같다. 당신들인들 그 이상이겠는가.`,
    author: `요한 볼프강 폰 괴테 - 독일 문호 : 1749-1832`,
  },
  {
    category: `Success`,
    quote: `나는 알몸으로 이 세상에 태어났다. 따라서 나는 이 세상을 떠날 때도 알몸으로 가지 않을 수 없다.`,
    author: `미겔 데 사아베드라 세르반테스 - 스페인 소설가 : 1547 ~ 1616`,
  },
  {
    category: `Success`,
    quote: `나는 언제나 친구나 조국을 위하여 목숨 바치기를 두려워하지 않는다.`,
    author: `호라티우스 - 로마 시인:BC65~8`,
  },
  { category: `Success`, quote: `나는 여자의 맹세를 물에 적어놓는다.`, author: `소포클레스` },
  {
    category: `Success`,
    quote: `나는 완고한 덕보다는 융통성이 있는 악덕을 좋아한다.`,
    author: `몰리에르`,
  },
  {
    category: `Success`,
    quote: `나는 완미한 덕보다 융통성 있는 악덕을 더 사랑한다.`,
    author: `모리에르`,
  },
  {
    category: `Success`,
    quote: `나는 우리나라가 세계에서 가장 아름다운 나라가 되기를 원한다. 우리나라가 독립하여 정부가 생기거든 그 집의 뜰을 쓸고 유리창을 닦은 일을 해 보고 죽게 하소서 ! `,
    author: `백범 김구`,
  },
  {
    category: `Success`,
    quote: `나는 이제까지 토지를 사랑해왔다. 토지는 언제나 인간보다 좋은 것이었다.인간은 일시적으로 겨우 소수의 사람들밖에 관심을 가질 수 없는 것이다.`,
    author: `헤밍웨이 - 미국작가:1899~1961`,
  },
  {
    category: `Success`,
    quote: `나는 인간이었다. 그것은 싸우는 者자란 것을 의미한다.`,
    author: `요한 볼프강 폰 괴테 - 독일 문호 : 1749-1832`,
  },
  {
    category: `Success`,
    quote: `나는 인내하는 데에는 마음을 강하게 하고, 욕심을 부리는 데에는 마음을 둔하게 하고 있다. 다만 내가 구할 수 있는 방향에서 손에 닿는 것을 구할 뿐이다.`,
    author: `미셸 에켐 드 몽테뉴 - 프랑스 사상가`,
  },
  {
    category: `Success`,
    quote: `나는 인생 속에서 네가지 金言을 익혔다. 남을 해롭게 하는 말은 결코 하지 말라. 아무도 받아들이지 않는 충고는 하지말라. 불평하지 말라. 설명하지 말라.`,
    author: `R. F. 스콧 - 영국 탐험가:1868~1912`,
  },
  {
    category: `Success`,
    quote: `나는 일찍이 고독만큼 사이좋은 친구를 찾아 본 일이 없다.`,
    author: `H D 도로`,
  },
  {
    category: `Success`,
    quote: `나는 적성으로써 조국의 독립과 자유를 회복하기 위하여 한인 애국단의 일원이 되어 적국의 수괴 우두머리를 죽이기로 맹세하나 이다.`,
    author: `이봉창 열사`,
  },
  {
    category: `Success`,
    quote: `나는 타인의 고통에 동정할 수는 있지만 그들의 즐거움에 공감할 수 없다. 타인의 행복에는 무엇인가 기묘하게 지루한 감이 든다.`,
    author: `토머스 헨리 헉슬리 - 영국 자연과학자:1825~1895`,
  },
  {
    category: `Success`,
    quote: `나는 평화의 수단으로서 밖에는 아직 전쟁을 주장해 본 일이 없다.`,
    author: `유리시즈 그란트`,
  },
  {
    category: `Success`,
    quote: `나는 하나의 법칙, 즉 분명해야 한다는 것만 안다. 내가 분명하지 않다면 모든 내 세계는 無무로 허무하게 사라진다.`,
    author: `스탕달 - 프랑스 소설가`,
  },
  {
    category: `Success`,
    quote: `나라가 없고서 한 집과 한 몸이 있을 수 없고, 민족이 천대받을 때 혼자만이 영광을 누릴 수 없다. 나 하나를 건전한 인격으로 만드는 것이 우리 민족을 건전하게 만드는 유일한 길이다. 진리는 반드시 따르는 자 있고, 정의는 반드시 이루는 날 있다.`,
    author: `도산 안창호`,
  },
  {
    category: `Success`,
    quote: `나라의 질서가 바로잡혀 있을때에는 돈이나 지위가 없다는 것이 부끄러운 일이 된다. 그러나 나라가 어지러울 때는 돈이 있고 지위가 높다는 것은 수치이다.`,
    author: `공자 - 孔子 : 유교의 시조`,
  },
  {
    category: `Success`,
    quote: `나로서는 어느 목적지에 가고자 여행하는 것이 아니고 그저 가기 위해서 여행한다. 나는 여행을 위해서 여행한다. 중요한 것은 이동하는 것이다.`,
    author: `로버트 루이스 스티븐슨 - 영국 소설가:1850 ~ 1894`,
  },
  {
    category: `Success`,
    quote: `나를 가장 잘 아는 자를 친구로 하고, 나를 가장 잘 모르는 자를 적으로 삼 는다면 그보다 더 좋은 일은 없다.`,
    author: `보 나르`,
  },
  {
    category: `Success`,
    quote: `나쁜 책을 읽고 몸을 버렸다는 어느 소녀의 이야기를 들어본 적이 없다.`,
    author: `워커`,
  },
  {
    category: `Success`,
    quote: `나에게 자유를 다오, 그렇지 않으면 죽음을 다오.`,
    author: `패드릭 핸리`,
  },
  {
    category: `Success`,
    quote: `나의 실제적인 독서 법칙은 세가지다. 첫째, 1년이 지나지 않은 책은 읽지 않는다. 둘째, 유명한 책만 읽는다. 셋째, 좋아하는 책만 읽는다.`,
    author: `랠프 월도 에머슨 - 미국 시인 : 1803-1882`,
  },
  {
    category: `Success`,
    quote: `나의 음악은 어린 아이들과 동물들이 가장 잘 이해한다.`,
    author: `스트라빈스키`,
  },
  {
    category: `Success`,
    quote: `나의 인생 신조는, 일로 즐거움을 삼고 즐거움을 또한 나의 가장 큰 일로 삼 는 것이다.`,
    author: `아이론 바하`,
  },
  { category: `Success`, quote: `나의 취미는 귀족적이고 나의 행동은 민주적이다.`, author: `위고` },
  { category: `Success`, quote: `나이는 사랑과 같아 숨길 수 없다.`, author: `데커` },
  {
    category: `Success`,
    quote: `낙천주의자는 모든 장소에서 청신호밖에는 보지 않는 사람. 비관주의자는 붉은 정지신호밖에는 보지 않는사람. 그러나 정말 현명한 사람이란 색맹을 말한다.`,
    author: `슈바이처`,
  },
  { category: `Success`, quote: `낙천주의자는 우매하고 비관주의자는 무정하다.`, author: `콕토` },
  { category: `Success`, quote: `날이 밝기 직전에 항상 가장 어둡다.`, author: `풀러` },
  {
    category: `Success`,
    quote: `남녀 관계란 두 사람만이 저녁식사를 세 번씩이나 갖고도 아무 일이 없을 때는 단념하는 것이 좋다.`,
    author: `고즈 야스지로`,
  },
  {
    category: `Success`,
    quote: `남에게 부정하게 대하지 말 것이며, 남이 나에게 부정하지 못하게 하라.`,
    author: `마호메트 - Mahomet`,
  },
  {
    category: `Success`,
    quote: `남은 많이 용서하되 자신은 결코 용서하지 말라.`,
    author: `푸블릴리우스 시루스`,
  },
  {
    category: `Success`,
    quote: `남을 아는 사람은 지혜있는 자이지만 자기를 아는 사람이 더욱 명찰한 자이다. 남을 이기는 사람은 힘이 있는 자이지만 자기 스스로를 이기는 사람은 더욱 강한 사람이다.`,
    author: `노자`,
  },
  {
    category: `Success`,
    quote: `남을 정면으로 비난하는 것은 좋지 않다. 그를 망신시키기 때문이다. 보이지 않는 곳에서 비난하는 것은 불성실하다. 덕을 기만하는 것이 되기 때문이다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아 작가:1828~1910`,
  },
  {
    category: `Success`,
    quote: `남의 위험에서 자신에게 이익이 되는 교훈을 끌어내라.`,
    author: `푸블리우스 아페르 테렌티우스 - Publius Terentius Afer`,
  },
  {
    category: `Success`,
    quote: `남의 일을 잘 알고 있는 사람은 똑똑한 사람이다. 자기 자신을 잘 알고있는 사람은 더 총명한 사람이다. 그리고 자기 자신을 이겨내는 사람은 그 이상으로 강한 사람이다.`,
    author: `노자 - 중국 사상가:BC604 ? ~ ?`,
  },
  {
    category: `Success`,
    quote: `남의 학설을 변론함에 있어 먼저 그 입장을 이해하여야 한다. 그 근본 자체를 파악하지 못하고 어구에 얽매이거나 문자에 구애되어서는 안된다. 그 이론 자체가 드러나지 않고, 가리워 보이지 않는 것이 있기 때문이다.`,
    author: `정제두`,
  },
  {
    category: `Success`,
    quote: `남이 고생하고 있는 것을 보면, 어떤때는 무한한 동정심이 샘솟지만 또 그것을 보고 가장 참혹한 기쁨을 느끼는 경우도 있다.`,
    author: `아르투어 쇼펜하워 - 독일 철학자:1788~1860`,
  },
  {
    category: `Success`,
    quote: `남이 나를 속인다고 하지말라. 사람은 늘 자기가 자기를 속이고 있는 것이다. 그대의 생각이 일부러 올바른 중심을 벗어나서 자기를 괴롭히고 있는 것이다.`,
    author: `요한볼프강 폰 괴테 - 독일의 철학자`,
  },
  {
    category: `Success`,
    quote: `남자가 야생동물이면 여자는 이 야생동물을 길들이는 자이다.`,
    author: `폴리스 바이언`,
  },
  {
    category: `Success`,
    quote: `남자끼리는 원래 서로가 무관심하 것이지만 여자란 태어나면서부터 적이다.`,
    author: `쇼펜하워`,
  },
  {
    category: `Success`,
    quote: `남자나 여자의 교양의 시금석은 싸울때 어떻게 행동하는가이다.`,
    author: `조지 버나드 쇼 - 영국 작가 : 1856-1950`,
  },
  { category: `Success`, quote: `남자는 마음으로 늙고 여자는 얼굴로 늙는다.`, author: `서양 속담` },
  {
    category: `Success`,
    quote: `남자는 언제나 여인의 첫사랑이 되고 싶어한다. 여자는 남자의 마지막 낭만이 되려고 한다.`,
    author: `와일`,
  },
  {
    category: `Success`,
    quote: `남자는 인생을 지나치게 빨리 깨닫고, 여자는 인생을 너무나 늦게 알게 된 다.`,
    author: `와일드`,
  },
  {
    category: `Success`,
    quote: `남자는 자기 자신의 비밀보다는 타인의 비밀을 한층 굳게 지킨다. 여자는 그와는 반대로 타인의 비밀보다는 자기 자신의 비밀을 더욱 잘 지킨다.`,
    author: `라 브뤼에르`,
  },
  {
    category: `Success`,
    quote: `남자들은 자기보다도 못한 것을 사랑할 수가 있습니다.--보잘것없는 것, 더 러운 것, 불명예스러운 것, 그런 것까지 사랑하실 수 있어요. 허지만 저희 들 여자는 사랑하고 있을 때는 그 사람을 존경하는 거예요. 만약 그 존경을 잃어 버린다면 그들은 모든 것을 잃어버리고 마는 것입니다.`,
    author: `오스카 와일 드`,
  },
  {
    category: `Success`,
    quote: `남자란, 말하며 접근할 때는 봄이지만 결혼해 버리면 겨울이다.`,
    author: `셰익스피어`,
  },
  {
    category: `Success`,
    quote: `남자의 마음은 대리석과 같고 여자의마음은 밀림과 같다.`,
    author: `세익스피어`,
  },
  {
    category: `Success`,
    quote: `남자의 사랑은 그 인생의 일부이고 여자의 사랑은 그 인생의 전부이다.`,
    author: `빠 이론`,
  },
  {
    category: `Success`,
    quote: `내가 가장 사랑하는 덕이 있다. 단 하나, 그 이름은 '자유'라고 한다.`,
    author: `헷 세`,
  },
  {
    category: `Success`,
    quote: `내가 소라고 말하면 그것은 소가 되고, 내가 말이라고 하면 그것은 말이 된다.`,
    author: `장자`,
  },
  { category: `Success`, quote: `내가 십오에 학에 뜻을 두고, 삼십에 서고.`, author: `공자 - 孔子` },
  {
    category: `Success`,
    quote: `내가 아직 살아있는 동안에는 나로 하여금 헛되이 살지 않게 하라.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `내가 알고 있는 한도에 있어서 가장 큰 기쁨은 남몰래 어떤 좋은 일을 해 놓고 나서, 그것이 우연히 여러 사람에 게 알려진다는 일이다.`,
    author: `램`,
  },
  {
    category: `Success`,
    quote: `내가 없는 곳에서 나를 칭찬해 주는 사람은 좋은 친구다.`,
    author: `이 언`,
  },
  {
    category: `Success`,
    quote: `내가 처한 모든 땅에서 내가 당한 모은 일을 할 수 있도록 최선을 다하자.`,
    author: `루터`,
  },
  {
    category: `Success`,
    quote: `내기는 탐욕의 아들이며, 부정의 형제이며, 불행의 아버지이다.`,
    author: `워싱턴`,
  },
  {
    category: `Success`,
    quote: `내 비장의 무기는 아직 손 안에 있다. 그것은 희망이다.`,
    author: `나폴레옹`,
  },
  { category: `Success`, quote: `내 사전에 불가능은 없다.`, author: `나폴레옹` },
  {
    category: `Success`,
    quote: `내일에 아무런 도움이 되지 않는다면 당신의 과거는 쫓아버려라.`,
    author: `오슬러`,
  },
  {
    category: `Success`,
    quote: `내일의 모든 꽃은 오늘의 씨앗에 근거한 것이다.`,
    author: `중국 속담`,
  },
  {
    category: `Success`,
    quote: `내일의 현실에 대한 유일한 제한은 오늘의 의구심이다. 강하고 적극적인 신념을 가지고 앞으로 나아가자.`,
    author: `프랭클린 델러노 루스벨트 - 미국 32대 대통령`,
  },
  {
    category: `Success`,
    quote: `내 자신의 무식을 아는 것은 지식에로의 첫걸음이다.`,
    author: `바이런`,
  },
  {
    category: `Success`,
    quote: `내 차라리 하룻동안 계율을 지키다가 죽을지언정 백년 동안 계율을 깨뜨리고서 살기를 원하지 않는다.`,
    author: `자장`,
  },
  {
    category: `Success`,
    quote: `냉소자란 어떠한 사람인가. 모든것의 가격을 알면서 어느 것의 가치도 모르는 사람이다.`,
    author: `오스카 핑걸 오프레어티 윌스 와일드 - 영국 작가:1854~1900`,
  },
  { category: `Success`, quote: `너는 네가 가장 가까이 있는 의무를 수행하라.`, author: `킹그슬리` },
  {
    category: `Success`,
    quote: `너무 많다는 것은 부족하다는 것을 의미한다. 너무 건강한 사람같이 심한 병자는 없다.`,
    author: `로맹 롤랑 - 프랑스 작가:1866~1944`,
  },
  { category: `Success`, quote: `너의 위대한 조상을 본받아 행동하라.`, author: `드라이든` },
  {
    category: `Success`,
    quote: `너의 의무를 다하라. 그리고 나머지는 하나님에게 맡겨라.`,
    author: `코니일`,
  },
  {
    category: `Success`,
    quote: `너 자신을 다스려라. 그러면 당신은 세계를 다스릴 것이다.`,
    author: `중국 속담`,
  },
  {
    category: `Success`,
    quote: `너 자신을 아는 것을 너의 일로 삼으라. 그것은 세상에서 가장 어려운 교훈이다.`,
    author: `미겔 더 사아베드라 세르반테스 - 스페인 소설가:1547~1616`,
  },
  { category: `Success`, quote: `너 자신을 알라.`, author: `소크라테스 - Socrates` },
  {
    category: `Success`,
    quote: `넌 자신을 누구에겐가 필요한 존재로 만들라.누구에게든 인생을 고되게 만들지 말라.`,
    author: `에머슨`,
  },
  { category: `Success`, quote: `네가 고독했을 때, 나는 가장 고독하지 않다.`, author: `키케로` },
  {
    category: `Success`,
    quote: `네가 아무리 자연의 문을 세게 두드려도 자연은 너에게 알아들을 수 있는 말로 대답해 주지는 않을 것이다.`,
    author: `이반 세르게예비치 투르게네프 - 러시아 작가:1818~1883`,
  },
  { category: `Success`, quote: `노년은 청춘에 못지 않은 좋은 기회이다.`, author: `롱펠로우` },
  { category: `Success`, quote: `노동은 생명이요, 사상이요, 광명이다.`, author: `위고` },
  {
    category: `Success`,
    quote: `노동은 인류를 괴롭히는 온갖 질병과 비참에 대한 최고의 치료법이다.`,
    author: `토마스 칼라일 - 영국비평가,역사가:1795~1881`,
  },
  {
    category: `Success`,
    quote: `노동은 인생을 감미롭게 한다. 노동을 미워하는 자만이 고뇌를 맛본다.`,
    author: `월 헤름 브르만`,
  },
  {
    category: `Success`,
    quote: `노력을 중단하는 것보다 더 위험한 것은 없다. 그것은 습관을 잃는다. 습관은 버리기는 쉽지만 다시 들이기는 어렵다.`,
    author: `빅토르 마리 위고 - Victor Marie Hugo`,
  },
  {
    category: `Success`,
    quote: `노령에 활기를 주는 진정한 방법은 마음의 청춘은 연장하는 것이다.`,
    author: `콜린즈`,
  },
  {
    category: `Success`,
    quote: `노병은 결코 죽지 않고 사라질 뿐이다.`,
    author: `맥아더 - D. Macarthur`,
  },
  { category: `Success`, quote: `논리와 상식은 다르다.`, author: `하버드` },
  {
    category: `Success`,
    quote: `논리의 결핍은 괴롭다. 지나친 논리는 싫증나게 한다. 인생은 논리를 회피한다. 논리만으로 이루려하면 인위적이며 어색하게 된다.`,
    author: `앙드레 폴 기욤 지드 - Andre Paul Guillaume Gide`,
  },
  {
    category: `Success`,
    quote: `논쟁에는 귀를 기울여라. 그러나 논쟁에 끼여들지 않도록 하라. 아무리 작은 말이라 할지라도 노여움이나 격정이 일어난다는 것을 경계하다.`,
    author: `고리키 - 러시아소설가:1868~1936`,
  },
  {
    category: `Success`,
    quote: `높이 나는 새가 멀리본다.안톤 쉬나크의 갈매기의 꿈에 나오는 말로 당연히 높이 날아 올라야 멀리 볼수 있다는 내용을 높이 높이 날고자하는 한 갈매기의 꿈에 비유한 말.- 맘속행복 `,
    author: `lcw1999@hanmail.net`,
  },
  {
    category: `Success`,
    quote: `누가 가장 영광스럽게 사는 사람인가? 한번도 실패함이 없이 나아가는 데 있는 것이 아니라, 실패할 때마다 조용히 그러나 힘차게 다시 일어나는 데에 인간의 참된 영광이 있다.`,
    author: `스미스`,
  },
  {
    category: `Success`,
    quote: `누구나 단번에 비상한 악인이 되는 일은 없다.`,
    author: `유베나리우스`,
  },
  {
    category: `Success`,
    quote: `누구나 오래 살기를 바란다. 그러나 누구를 막론하고 나이는 먹기 싫어한다.`,
    author: `스위프트`,
  },
  {
    category: `Success`,
    quote: `누구든지 크나큰 시련을 당하기 전에는 참다운 인간이 못된다.`,
    author: `레오랄지이`,
  },
  {
    category: `Success`,
    quote: `누구의 말에도 귀를 기울이고 누구를 위해서도 입을 열지 말라.`,
    author: `윌리엄 셰익스피어 - 영국극작가:1564~1616`,
  },
  {
    category: `Success`,
    quote: `누구 한 사람 아는 이 없는 곳에서 사는 것은 즐거운 일이기도 하다.`,
    author: `헤르만 헤세 - 독일 시인:1877~1962`,
  },
  {
    category: `Success`,
    quote: `눈물과 함께 빵을 먹어보지 않은 사람은 인생의 참다운 맛을 못본다.`,
    author: `요한 볼프강 폰 괴테 - 독일의 문호:1749~1832`,
  },
  {
    category: `Success`,
    quote: `눈물을 흘리면서 빵을 먹어보지 못한 사람은 인생의 참맛을 알 수 없다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `눈 오는 길을 걸어갈 때 발걸음 함부로 하지말지어다.오늘 내가 남긴 자국은 드디어 뒷 사람의 길이 되느니.눈보라 치는 조국의 암담한 운명을 맞아 자신의 안위와 정치적인 이해관계에 얽매이지 않고 후세에 이어줄 역사를 강조하며 백범 김구 선생께서 주로 쓰셨다고 합니다.`,
    author: `서산대사의 禪詩`,
  },
  {
    category: `Success`,
    quote: `눈을 감아라. 그럼 너는 너 자신을 볼 수 있으리라.`,
    author: `버틀러`,
  },
  { category: `Success`, quote: `늑대는 이빨을 잃어도 그 천성은 잃지 않는다.`, author: `풀러` },
  {
    category: `Success`,
    quote: `늘 원대한 포부가 나를 인도하고, 깊은 사상이 나의 행동을 인도해야 한다. 조그마한 목전의 감정이 내 마음을 지배하고 얕은 생각이 나의 행동을 명령하지 않도록 해야 한다.`,
    author: `아르투어 쇼펜하워 - Arthur Schopennauer`,
  },
  {
    category: `Success`,
    quote: `다른 사람들을 비난하려고 생각하기 전에 자기 자신을 충분히 살펴보아야 한다.`,
    author: `몰리에르`,
  },
  {
    category: `Success`,
    quote: `다른 사람을 지배하려는 사람은,먼저 자기 자신의 주인이 되어야 한다.`,
    author: `매신저`,
  },
  {
    category: `Success`,
    quote: `다른 사람의 속마음으로 들어가라. 그리고 다른 사람으로 하여금 당신의 속마음으로 들어오도록 하라.`,
    author: `아우렐리우스`,
  },
  {
    category: `Success`,
    quote: `다른 사람이 말하는 일에는 세심한 주의를 기울이고, 되도록 말하는 상대방의 마음속으로 파고들도록 그대 자신을 길들이게 하라.`,
    author: `마르쿠스 아우렐리우스 - 로마 황제:121~180`,
  },
  {
    category: `Success`,
    quote: `다른 사람이 성공한 일은 누구나, 언제든지, 어디에서건 성공 할 수 있다.`,
    author: `쌩 떽쥐베리 [Antoine de Saint-Exupery] :1900-1955`,
  },
  {
    category: `Success`,
    quote: `다른 인간을 증오하는 댓가는,자신을 더 적게 사랑하는 것이다.`,
    author: `클리버`,
  },
  {
    category: `Success`,
    quote: `다리에 의지하는 농민이 무릎에 의지하는 신사보다 고결하다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `다시 한번이라는 어리석은 말을 내게는 하지 말라.`,
    author: `미라보`,
  },
  { category: `Success`, quote: `다정하고 조용한 말은 힘이 있다.`, author: `에머슨` },
  {
    category: `Success`,
    quote: `단순하지만 저항할 수 없을 정도로 강력한 세가지 열정이 나의 삶을 지배해왔다. 그것들은 사랑의 열망과 지식의 탐구와 고난을 겪고 있는 인류에 대한 견딜 수 없는 동정심이다.`,
    author: `버트런드 아서 윌리엄 러셀 - 영국 철학자:1872 ~ 1970`,
  },
  {
    category: `Success`,
    quote: `단지 돈만을 위해 결혼하는 것보다 더 나쁜 것은 없고, 단지 사랑만을 위해 결혼하는 것보다 더 어리석은 일은 없다.`,
    author: `새뮤얼 존슨 - 영국시인,비평가:1709~1784`,
  },
  {
    category: `Success`,
    quote: `단 하나의 하늘에 올려진 고마워하는 생각이 완전한 기도이다.`,
    author: `레싱`,
  },
  {
    category: `Success`,
    quote: `달콤한 사랑이여...아아, 네게 날개가 없었으면 좋겠는데 .`,
    author: `아이텐드르프`,
  },
  { category: `Success`, quote: `담화는 마음의 보다 즐거운 향연이다.`, author: `호메로스` },
  {
    category: `Success`,
    quote: `당나귀는 긴 귀로 구별할 수 있으며 어리석은 자는 긴 혀로 구별할 수 있다.`,
    author: `유태 격언`,
  },
  {
    category: `Success`,
    quote: `당신은 모든 사람들을 잠시동안 속일 수 있다. 그리고 어떤 사람들을 항상 속일수는 없다. 그러나 모든 사람들을 항상 속일수는 없다.`,
    author: `에이브러햄 링컨 - Abraham Lincoln`,
  },
  { category: `Success`, quote: `당신은 바로 자기 자신의 창조자이다.`, author: `카네기` },
  {
    category: `Success`,
    quote: `당신은 의지의 주인이 되라. 그리고 당신은 양심의 노예가 되라.`,
    author: `유태 속담`,
  },
  {
    category: `Success`,
    quote: `당신은 항상 영웅이 될 수 없다. 그러나 항상 사람은 될 수 있다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `당신의 인생은 당신이 하루종일 무슨 생각을 하는지에 달려있다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `당신의 정신을 위대한 사상으로 기르라. 영웅을 믿는 일이 영웅을 만들어 낸 다.`,
    author: `밴자민 디즈렐리`,
  },
  {
    category: `Success`,
    quote: `당신의 정열을 지배하라. 그러지 않으면 정열이 당신을 지배할 것이다.`,
    author: `호라티우스 - 로마시인:BC65~8`,
  },
  {
    category: `Success`,
    quote: `당신이 가지고 있는 상식이 전문가의 지식과 다르다고 해서 두려워할 필요가 없다. 그들 두 사람 중 한사람은 학자인체 할 뿐이기 때문에.`,
    author: `올리버 웬들 홈스 - 미국 시인:1809~1894`,
  },
  {
    category: `Success`,
    quote: `당신이 누군가를 배반 한다면, 당신은 또한 당신 자신을 배반하는 셈이다.`,
    author: `싱거`,
  },
  {
    category: `Success`,
    quote: `당신이 자신에 대해서 생각하는 것은 다른 사람들이 당신에 대해서 생각하는 것보다 훨씬 중요하다.`,
    author: `루시우스 아니에우스 세네카 - 로마 철학자 : BC4 - AD65`,
  },
  {
    category: `Success`,
    quote: `대도시에서는 우정이 뿔뿔이 흩어진다. 이웃이라는 가까운 교제는 찾아 볼 수 없다.`,
    author: `프란시스 베이컨 - 영국 정치가:1561 ~ 1626`,
  },
  {
    category: `Success`,
    quote: `대부분의 사람들이 커다란 야망으로 시달리지만 않는다면 작은 일에 성공하련만.`,
    author: `헨리 워즈워스 롱펠로 - 미국 시인 : 1807-1882`,
  },
  {
    category: `Success`,
    quote: `대자연은 인간이 사는 거리와 멀리 떨어져 자연만이 혼자 있을 때 가장 번 영한다.`,
    author: `솔로`,
  },
  {
    category: `Success`,
    quote: `대장부란, 인이라는 천하의 넓은 집에 살고, 예라는 천하의 바른 위치에 서서, 의리라는 천하의 큰 도를 행하는 것이다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `대지는 인간이 살아가기 위한 寶庫보고다.`,
    author: `토마스 제퍼슨 - 미국대통령:1743~1826`,
  },
  {
    category: `Success`,
    quote: `대학은 직업을 위한 훈련학교로 되어가고 있다. 그것은 교양따위에는 전혀 무관심한 전권주의자들이 요청하고 있기 때문이다.`,
    author: `버트런트 아서 윌리엄 러셀 - 영국 철학자 : 1872-1970`,
  },
  { category: `Success`, quote: `대화는 학생들의 실험실이요,작업장이다.`, author: `에머슨` },
  { category: `Success`, quote: `대화시의 신중은 웅변보다 더 중요하다.`, author: `그라시안` },
  {
    category: `Success`,
    quote: `덕은 중용을 지키는데 있다.`,
    author: `아리스토텔레스 - Aristoteles`,
  },
  { category: `Success`, quote: `덕이 없는 아름다움은 향기 없는 꽃이다.`, author: `프랑스 격언` },
  {
    category: `Success`,
    quote: `덕행은 스스로를 정당화하면 가치가 떨어진다.`,
    author: `볼테르 - 프랑스의 사상가 : Voltaire`,
  },
  { category: `Success`, quote: `도가 지나친 겸손은 허영심이다.`, author: `폰 코체뷰에` },
  {
    category: `Success`,
    quote: `도박을 즐기는 모든 인간은, 불확실한 것을 얻기 위해서 확실한 것을 걸고 내기를 한다.`,
    author: `파스칼`,
  },
  {
    category: `Success`,
    quote: `도중에서 던져버린 일, 손을 대지 않고 방치해 둔 일은 이윽고 산처럼 쌓인 일이 되어 사람을 괴롭힌다.`,
    author: `베메르길리우스 - 로마의 시인 : BC 70-19`,
  },
  {
    category: `Success`,
    quote: `독립은 선전만으로 될 수 없고 허장성세 만으로 될 수 없다. 독립의 가장 근본적 요소는 각성한 민중이다. 그러므로 우리는 민중의 교양에 총력을 집중하지 않으면 안될 것이다. 2천만민중이 총궐기하여 독립을 부르짖게 되면 한국의 독립은 반드시 성취될 것이다.`,
    author: `서재필 - 개화기 정치가-독립운동가 : 1864-1951`,
  },
  {
    category: `Success`,
    quote: `독립이 자유롭게 사는 조건이라면 여자는 결혼해서는 안된다.`,
    author: `자멘 그리어`,
  },
  {
    category: `Success`,
    quote: `독창성의 장점은 참신이 아니라, 성실이다. 믿는 사람은 독창적인 인간이다.`,
    author: `토머스 칼라일 - 영국비평가,역사가:1795~1881`,
  },
  {
    category: `Success`,
    quote: `돈으로 살 수 있는 행복이라 불리는 상품은 없다.`,
    author: `헨리 벤 다이크`,
  },
  {
    category: `Success`,
    quote: `돈은 진정 중요한 것이다. 따라서 모든 건전하고 성공적인 개인과 국가의 도덕은 이 사실에 기초를 두어야 한다.`,
    author: `조지 버나드 쇼 - George Bernard Shaw`,
  },
  {
    category: `Success`,
    quote: `돈은 최선의 종이요 최악의 주인이다.`,
    author: `프란시스 베이컨 - 영국 철학자 : 1561~1626`,
  },
  {
    category: `Success`,
    quote: `돈이란 훌륭한 하인이기도 하지만, 나쁜 주인이기도 하다.`,
    author: `프랭클린`,
  },
  { category: `Success`, quote: `돈이 많아지면 곧 미덕은 감소된다.`, author: `베베르` },
  {
    category: `Success`,
    quote: `돈이 있어도 이상이 없는 사람은 몰락의 길을 밟는다.`,
    author: `도스도예프스키`,
  },
  {
    category: `Success`,
    quote: `동정은 최고의 모욕이다.`,
    author: `프리드리히 빌헤름 니체 - 독일 철학자:1844~1900`,
  },
  {
    category: `Success`,
    quote: `두려운 것은 죽음이나 고난이 아니라 고난과 죽음에 대한 공포이다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `두 사람의 개성의 만남은 두가지 화확물질의 접촉과 같다, 반응이 있으면 둘 다 변화한다.`,
    author: `융`,
  },
  { category: `Success`, quote: `두 사람의 머리는 한 사람의 머리보다 낫다.`, author: `헤이우드` },
  {
    category: `Success`,
    quote: `두 여인을 화합시키기 보다는 유럽 전체를 화합시키는 편이 쉽다.`,
    author: `루이 14세`,
  },
  {
    category: `Success`,
    quote: `때가 오면 모든 것이 분명해진다. 시간은 진리의 아버지이다.`,
    author: `타블레`,
  },
  {
    category: `Success`,
    quote: `또 다시 역사를 말살하고 조상을 모욕하는 어리석은 후예가 되지 않기 위하여, 자기의 무능과 태만과 비겁으로 말미암아 자손 만대에 누를 끼치는 못난 조상이 되지 않기 위하여, 우리는 이 역사적 사명을 깊이 통찰하고 지성일관 그 완수에 매진해야 할 줄로 안다.`,
    author: `장 준하`,
  },
  {
    category: `Success`,
    quote: `로마에서 신문의 검열이 있었다고 하면 우리는 오늘날 호라티우스나 키케로의 철학적 산문을 갖지 못했을 것이다.`,
    author: `볼테르 - 프랑스 사상가:1694~1778`,
  },
  {
    category: `Success`,
    quote: `마냥 슬픔에 잠긴다는 것은 위험하다. 용기를 빼앗아 갈 뿐 아니라 회복하려는 의욕마저 잃게 하기 때문이다.`,
    author: `앙리 프레데리크 아미엘 - 스위스 철학자`,
  },
  {
    category: `Success`,
    quote: `마땅히 행할 길을 아이에게 가르쳐라. 그러하면 늙어도 그것을 떠나지 않으리라.`,
    author: `성경`,
  },
  { category: `Success`, quote: `마음보다 더 잔인한 무기는 없다.`, author: `장자` },
  {
    category: `Success`,
    quote: `마음에 고민이 있는 자의 하루는 낱낱이 어려운 일뿐인 것이다.`,
    author: `구약성서`,
  },
  {
    category: `Success`,
    quote: `마음을 비우면 건강해지고 정력이 넘친다.`,
    author: `노만 필 박사[미국의 목사]의 저서 [적극적인 사고방식] 에서`,
  },
  { category: `Success`, quote: `마음의 고통은 육체적 고통보다 훨씬 크다.`, author: `사일러스` },
  {
    category: `Success`,
    quote: `마음의 즐거움은 얼굴을 빛나게 하여도 마음의 근심은 심령을 상하게 하느니라.`,
    author: `성경`,
  },
  {
    category: `Success`,
    quote: `마음이 어둡고 산란할 때엔 가다듬을 줄 알아야 하고, 마음이 긴장하고 딱딱할 때엔 놓아 버릴 줄 알아야 한다. 그렇지 못하면 어두운 마음을 고칠지라도 흔들리는 마음이 다시 병들기 쉽다.`,
    author: `채근담`,
  },
  {
    category: `Success`,
    quote: `마음이 어진 사람은 조그마한 집에 살아도 행복하다.`,
    author: `홍자성`,
  },
  {
    category: `Success`,
    quote: `마음이 없으면 보고도 안 보이고 들어도 귀에 들리지 않는다.`,
    author: `중국고전`,
  },
  {
    category: `Success`,
    quote: `마음이 재촉하고 이성이 허용하는데도 모험을 두려워하는 자는 겁쟁이요, 자기 의도에서 멀리 벗어나 모험하는 자는 노예이다.`,
    author: `하인리히 하이네 - Heinrich Heine`,
  },
  {
    category: `Success`,
    quote: `만 가지 이치, 하나의 근원은 단번에 깨쳐지는 것이 아니므로 참마음, 진실된 본체는 애써 연구하는데 있다.`,
    author: `이황`,
  },
  {
    category: `Success`,
    quote: `만나고, 알고, 사랑하고, 그리고 이별하는 것은 모든 인간의 공통된 슬픈 이 야기이다.`,
    author: `콜르리지`,
  },
  { category: `Success`, quote: `만물의 근원은 물.`, author: `탈레스 - Thales` },
  { category: `Success`, quote: `만물의 근원은 불.`, author: `헤라클레이토스 - Herakleiros` },
  { category: `Success`, quote: `만물의 근원은 원자.`, author: `데모크리토스 - Demokritos` },
  { category: `Success`, quote: `만약 급히 서두르려면 돌아 가는 길로 가라.`, author: `영국속담` },
  {
    category: `Success`,
    quote: `만약 자기의 의견을 들어주는 합법수단이 거절되었을 때에는 국민은 폭력으로 호소할 권리가 있다.`,
    author: `앙드레 모루아 - 프랑스 작가 : 1885-1967`,
  },
  {
    category: `Success`,
    quote: `만약 제군이 노예의 목에다 쇠사슬을 감는다면, 그 쇠사슬의 한 끝은 제군의 목에 얽혀 붙을 것이다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `만약 제군이 돈의 가치를 알고 싶으면 나가서 얼마간의 돈을 빌려 보라.`,
    author: `프랭클린`,
  },
  {
    category: `Success`,
    quote: `만약 좋은 펜과 좋은 잉크와 좋은 종이가 있다면 문제없이 걸작을 쓸 것 같은 기분이 드는 날이다.`,
    author: `앙드레 폴 기욤 지드 - 프랑스 소설가 : 1869-1951`,
  },
  {
    category: `Success`,
    quote: `만약 평화가 명예로써 유지되지 못한다면, 그런 평화는 아무런 가치도 없다.`,
    author: `러셀`,
  },
  {
    category: `Success`,
    quote: `만일 자유 사회가 가난한 다수를 도울수 없다면 부유한 소수도 구원할 수 없다.`,
    author: `존 피츠제럴드 케네디 - John Fitzgerald Kennedy`,
  },
  {
    category: `Success`,
    quote: `많은 불행은 난처한 일과 말하지 않은 채로 남겨진 일 때문에 생겼다.`,
    author: `표도르 미하일로비치 도스토예프스키 - 러시아 작가`,
  },
  {
    category: `Success`,
    quote: `많은 벗을 가진 사람은 한 사람의 진실한 벗을 가질 수 없다.`,
    author: `아리스토텔레스`,
  },
  {
    category: `Success`,
    quote: `많은 사람이 충고를 받지만, 오직 현명한 자만이 충고의 덕을 본다.`,
    author: `푸블릴리우스 시루스`,
  },
  {
    category: `Success`,
    quote: `많은 사물중에서 가운데가 제일이다. 내 위치도 가운데가 되게 하라.`,
    author: `포킬리데스`,
  },
  {
    category: `Success`,
    quote: `많은 친구를 가지고 있는 사람은 한 사람의 친구도 없다.`,
    author: `W 글라임`,
  },
  {
    category: `Success`,
    quote: `많이 가진 사람은 더 많은 것을 손에 넣는다. 조금밖에 갖지 못한 사람은 그것마저 빼앗긴다.`,
    author: `하인리히 하이네 - 독일시인:1797~1856`,
  },
  { category: `Success`, quote: `말도 행동이고 행동도 말의 일종이다.`, author: `에머슨` },
  {
    category: `Success`,
    quote: `말로하는 사랑은 쉽게 외면할 수 있으나 행동으로 보여주는 사랑은 저항할 수가 없다.`,
    author: `무니햄`,
  },
  {
    category: `Success`,
    quote: `말만 하고 행동하지 않는 사람은 잡초로 가득 찬 정원과 같다.`,
    author: `하우얼`,
  },
  {
    category: `Success`,
    quote: `말 수가 적고 친절한 것은 여성의 가장 좋은 장식이다.`,
    author: `톨스토이`,
  },
  { category: `Success`, quote: `말은 행동의 거울이다.`, author: `솔론` },
  {
    category: `Success`,
    quote: `말이 입힌 상처는 칼이 입힌 상처보다 깊다.`,
    author: `모로코 속담`,
  },
  {
    category: `Success`,
    quote: `말하는 것은 지식의 영역이고 듣는 것은 지혜의 특권이다.`,
    author: `올리버 웬들 홈스 - Oliver Wendell Holmes, Jr.`,
  },
  {
    category: `Success`,
    quote: `말하자마자 행동하는 사람, 그것이 가치있는 사람이다.`,
    author: `엔니웃스`,
  },
  { category: `Success`, quote: `말 한 마디가 세계를 지배한다.`, author: `쿠크` },
  {
    category: `Success`,
    quote: `맹세는 말에 지나지 않고 말은 바람에 지나지 않는다.`,
    author: `버틀러`,
  },
  {
    category: `Success`,
    quote: `머리 위에는 별이 반짝이는 하늘, 내 마음에는 도덕률.`,
    author: `칸트 - I. Kant`,
  },
  {
    category: `Success`,
    quote: `먹는 것은 자기 자신을 즐겁게 하기 위함이요, 입는 것은 남을 즐겁게 하기 위함이다.`,
    author: `벤저민 프랭클린 - 미국 정치가 : 1706-1790`,
  },
  {
    category: `Success`,
    quote: `먼 곳으로 항해하는 배가 풍파를 만나지 않고 조용히만 갈 수는 없다. 풍파는 언제나 전진하는 자의 벗이다.`,
    author: `프리드리히 빌헬름 니체 - 독일 철학자`,
  },
  {
    category: `Success`,
    quote: `명성은 젊은이에게 광채를 주고, 노인에게는 위엄을 가져다 준다.`,
    author: `랠프 월도 에머슨 - 미국 시인:1803~1882`,
  },
  {
    category: `Success`,
    quote: `명성을 얻은 예술가는 그 때문에 괴로워한다. 따라서 그들의 처녀작이 때로는 최고다.`,
    author: `루트비히 판 베토벤 - 독일 작곡가:1770~1827`,
  },
  {
    category: `Success`,
    quote: `모두들 다 이유가 있다. 그러나 일체가 이유가 없어도 자기 고집 때문에 자 살하는 것은 나뿐이다.`,
    author: `도스토예프스키`,
  },
  { category: `Success`, quote: `모든 개량과 진보의 근본은 근로이다.`, author: `카네기` },
  {
    category: `Success`,
    quote: `모든 개성에는 제각기 아름다움이 있다.`,
    author: `영국 사상가 에머슨`,
  },
  {
    category: `Success`,
    quote: `모든 국가의 기초는 그 나라 젊은이들의 교육이다.`,
    author: `디오게네스`,
  },
  {
    category: `Success`,
    quote: `모든 기술 중에서 제일이며 가장 존경을 받는 것은 농업이다.`,
    author: `장 자크 루소 - 프랑스 사상가 : 1712-1778`,
  },
  {
    category: `Success`,
    quote: `모든 날 중 가장 완전히 잃어버린 날은 웃지 않는 날이다.`,
    author: `샹포르`,
  },
  {
    category: `Success`,
    quote: `모든 사람에 대해서 친구인 사람은 누구에 대해서도 친구가 아닌 것이다.`,
    author: `이 언`,
  },
  {
    category: `Success`,
    quote: `모든 사람은 자기가 진리라고 생각하는 것을 말할 권리가 있으며, 또 그 진리를 위해 자신을 불태울 권리를 가지고 있다.`,
    author: `새뮤얼 존슨 - Samuel Johnson`,
  },
  {
    category: `Success`,
    quote: `모든 사람을 칭찬하는 사람은 그 누구도 찬양하지 않는 거나 마찬가지이다.`,
    author: `사무엘 존슨`,
  },
  {
    category: `Success`,
    quote: `모든 사람의 행복은 다른 사람의 불행위에 세워진다.`,
    author: `이반 세르게예비치 투르게네프 - 러시아 작가 : 1818-1883`,
  },
  {
    category: `Success`,
    quote: `모든 양서를 읽는다는 것은 지난 몇세기 동안에 걸친 가장 훌륭한 사람들과 대화를 하는 것과 같다.`,
    author: `데카르트 - 프랑스 철학자,수학자:1596 ~ 1650`,
  },
  {
    category: `Success`,
    quote: `모든 위대한 사업에도 최초에는 불가능한 일이라고 했던 것들입니다.`,
    author: `카알라일`,
  },
  {
    category: `Success`,
    quote: `모든 위대한 진리는 처음에는 모독의 말로 출발한다.`,
    author: `조지 버나드 쇼 - 영국 작가 : 1856-1950`,
  },
  {
    category: `Success`,
    quote: `모든 일은 계획으로 시작하고, 노력으로 성취되며, 오만으로 망친다.`,
    author: `관자`,
  },
  { category: `Success`, quote: `모든 일은 어려운 고비를 넘겨야 쉬워진다.`, author: `풀러` },
  {
    category: `Success`,
    quote: `모든 일을 용서받는 청년기는 아무것도 스스로 용서치 않으며, 스스로 모든 일을 용서하는 노년기는 아무것도 용서 받지 못한다.`,
    author: `조지 버나드 쇼 - George Bernard Shaw`,
  },
  {
    category: `Success`,
    quote: `모든 자기학대의 감정은 체념이 부족한 까닭이다. 자기학대의 감정은 자기를 다칠뿐만 아니라 나아가서 남을 다치게 한다.`,
    author: `버트런드 아서 윌리엄 러셀 - 영국 철학자`,
  },
  { category: `Success`, quote: `모든 죄악의 기본은 조바심과 게으름이다.`, author: `카프카` },
  {
    category: `Success`,
    quote: `모든 지식중에서 결혼에 관한 지식이 가장 늦어지고 있다.`,
    author: `발자크`,
  },
  {
    category: `Success`,
    quote: `모든 행복한 가족들은 서로 서로 닮은 데가 많다. 그러나 모든 불행한 가족은 그 자신의 독특한 방법으로 불행하다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아 작가:1828 ~ 1910`,
  },
  {
    category: `Success`,
    quote: `모든 혁명은 우선은 한 사람의 인간이 생각해 낸 하나의 사상에 지니지 않 았던 것이다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `모략, 중상만큼 빠른 것이 없고, 쉽게 발설되는 것도 없고, 빨리 받아들여지는 것도 없고, 널리 퍼지는 것도 없다.`,
    author: `마르쿠스 톨리우스 키케로 - 로마 정치가 : BC 106-43`,
  },
  {
    category: `Success`,
    quote: `모방에 의해서 위대하게 된 사람은 아직 한 사람도 없었다.`,
    author: `사무엘 죤슨`,
  },
  { category: `Success`, quote: `모범은 모든 사람이 읽을 수 있는 교훈이다.`, author: `웨스트` },
  { category: `Success`, quote: `모범은 훈화보다 유효하다.`, author: `영국속담` },
  { category: `Success`, quote: `모욕은 잊어버리고, 친절은 결코 잊지 말아라.`, author: `공자` },
  {
    category: `Success`,
    quote: `모자란다는 여백, 그 여백이 오히려 기쁨의 샘이 된다.`,
    author: `파스칼`,
  },
  {
    category: `Success`,
    quote: `목적 없는 생활은 맛이 없고, 목적 있는 생활은 번거롭다.`,
    author: `헷세`,
  },
  { category: `Success`, quote: `목적 없이 존재하는 것은 아무 것도 없다.`, author: `보들레르` },
  { category: `Success`, quote: `목표를 보는 자는 장애물을 겁내지 않는다.`, author: `한나 모어` },
  {
    category: `Success`,
    quote: `못난이의 얼굴을 보고 싶으면 먼저 자신의 얼굴을 거울에 비추어 볼 것.`,
    author: `라블레`,
  },
  {
    category: `Success`,
    quote: `무거운 마음을 가지고 가벼운 시를 즐길 수 없다.`,
    author: `베이커`,
  },
  {
    category: `Success`,
    quote: `무관심 때문에 사람은 실제로 죽기전에 죽어버린다.`,
    author: `위젤`,
  },
  {
    category: `Success`,
    quote: `무례함이란 약한 인간이 강한 인간을 모방할 때 나타난다.`,
    author: `엘리 호퍼`,
  },
  {
    category: `Success`,
    quote: `무수한 사람들 가운데는 나와 뜻을 같이할 사람이 한둘은 있을 것이다. 그것으로 충분하다. 바깥 대기를 호흡하는데 들창문은 하나만으로 족하다.`,
    author: `로맹 롤랑 - 프랑스 작가:1866~1944`,
  },
  { category: `Success`, quote: `무실·역행하고 충의·용감하라.`, author: `도산 안창호 - 安昌浩` },
  {
    category: `Success`,
    quote: `무슨 일이고 참을 수 있는 사람은 무슨 일이고 실행할 수 있다.`,
    author: `보르나르그`,
  },
  { category: `Success`, quote: `무슨 일이든지 한 가지 일에 능통하라.`, author: `경행록` },
  {
    category: `Success`,
    quote: `무엇보다도 먼저 더 소중한 점은 인생에 대한 척도가 경건해야 한다는 것이다. 사람은 지식의 향상과 아울러 항상 경건한 마음을 가지지 않으면 안된다.`,
    author: `앨프리드 테니슨 - 영국 시인`,
  },
  {
    category: `Success`,
    quote: `무엇인가를 이루려고 하는 마음이 없다면 세상 어디를 가나 두각을 나타낼 수가 없다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `무지의 진정한 특징은, 허영과 자만과 교만이다.`,
    author: `새뮤얼 버틀러 - 영국 작가:1835~1902`,
  },
  { category: `Success`, quote: `무지함을 두려워 말라. 거짓 지식을 두려워하라.`, author: `파스칼` },
  {
    category: `Success`,
    quote: `무한한 가능성을 잉태한 미래에의 관념이, 미래 그 자체보다도 중요한 것으로서, 소유보다도 희망에, 현실보다도 꿈에 한층 더 많은 매력이 발견된다.`,
    author: `앙리 루이 베르그송 - Henri Louis Bergson`,
  },
  { category: `Success`, quote: `문명은 그 자신이 배설하는 오물로 더럽혀 있다.`, author: `W R 잉` },
  {
    category: `Success`,
    quote: `문명인은 마차를 발명한 덕택으로 다리가 못쓰게 되었다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `문제를 바르게 파악하면 절반은 해결한 것이나 마찬가지이다.`,
    author: `케터링`,
  },
  {
    category: `Success`,
    quote: `문학과 저널리즘의 차이는 저널리즘이 읽어서 재미없는 것이며, 문학이 읽히지 않는 점이다.`,
    author: `오스카 핑걸 오플레어티윌스 와일드 - 영국 작가 : 1854~1900`,
  },
  {
    category: `Success`,
    quote: `문학의 목적은 인생의 목적과 마찬가지로 不定부정이다.`,
    author: `폴 발레리 - 프랑스 시인 : 1871-1945`,
  },
  {
    category: `Success`,
    quote: `문학이나 예술면에서 실패한 사람이 평론가이다.`,
    author: `벤자민 디즈레일리 - 영국 정치가:1804~1881`,
  },
  {
    category: `Success`,
    quote: `문화는 그 자체의 분석을 시작하기 이전에 만개한다.`,
    author: `앨프리드 노스 화이트헤드 - Alfred North Whitehead`,
  },
  {
    category: `Success`,
    quote: `문화를 역행시킬 수는 없다. 이 세계에 청년이 있기 때문이다. 그들은 고집센 데가 있지만 주어진 능력을 충분히 발휘할 것이다.`,
    author: `헬렌 애덤스 켈러 - 미국 사회사업가:1880~1968`,
  },
  {
    category: `Success`,
    quote: `물고기를 주어라. 한 끼를 먹을 것이다. 물고기 잡는 법을 가르쳐 주어라. 평생을 먹을 것이다.(한마리의 생선을 주면 한끼의 식량이 되지만, 고기잡는 법을 가르치면 평생의 식량이 된다.)`,
    author: `유태경전인 - 탈무드`,
  },
  {
    category: `Success`,
    quote: `미는 자연의 동전, 모아 두어서는 안되며 유통되어야 한다. 그것의 좋은 점은 서로 나누어 갖는 기쁨이다.`,
    author: `존 밀턴 - 영국 시인 : 1608-1674`,
  },
  { category: `Success`, quote: `미련한 자는 자기 행위를 바른 줄로 여긴다.`, author: `성경` },
  {
    category: `Success`,
    quote: `미소, 악수, 혹은 호의로운 눈총 등 무엇인가를 남에게 동냥할 필요가 없는 인간은 없다.`,
    author: `댈버그`,
  },
  {
    category: `Success`,
    quote: `미지를 향해 출발하는 사람은 누구나 외로운 모험에 만족해야 한다.`,
    author: `지드`,
  },
  {
    category: `Success`,
    quote: `민주주의는 결코 최종적 성취는 아니다. 그것은 지칠줄 모르는 노력, 계속적인 희생, 그리고 의지에의 소명이요, 필요하면 그것의 방어를 위해 죽으라는 명령이다.`,
    author: `존 피츠제럴드 케네디 - 미국 대통령:1917~1963`,
  },
  {
    category: `Success`,
    quote: `민주주의는 정지된 것이 아니라 영원히 계속되는 행진이다.`,
    author: `루즈벨트`,
  },
  {
    category: `Success`,
    quote: `민주주의의 모든 질병은 더 많은 민주주의에 의해서 치료될 수 있다.`,
    author: `알프레드 스미스`,
  },
  {
    category: `Success`,
    quote: `민중만큼 정해지지 않은 것은 없고, 여론만큼 애매한 것은 없고, 선거인 전체 의견만큼 허위적인 없다.`,
    author: `마르쿠스 툴리우스 키케로 - Marcus Tullius Cicero`,
  },
  {
    category: `Success`,
    quote: `바다의 물이 마르면 나중에는 밑이 보인다. 그러나 사람은 죽어도 마음은 알지 못한다.`,
    author: `명심보감`,
  },
  { category: `Success`, quote: `바보는 방황하고, 현명한 사람은 여행을 떠난다.`, author: `풀러` },
  {
    category: `Success`,
    quote: `바커스가 불을 부채질할 때에는 비너스는 화롯가에 앉아 있다.`,
    author: `이 언`,
  },
  {
    category: `Success`,
    quote: `바커스는 포세이돈보다 더 많이 쓸데없이 인간을 익사시켰다.`,
    author: `개리벌지`,
  },
  {
    category: `Success`,
    quote: `바탕이 성실한 사람은 항상 편안하고 이익을 보지만 방탕하고 사나운 자는 언제나 위태롭고 해를 입는다.`,
    author: `荀子 - 중국사상가 : BC298-238`,
  },
  { category: `Success`, quote: `바쁜 꿀벌은 슬퍼할 겨를이 없다.`, author: `블레이크` },
  { category: `Success`, quote: `바쁜 사람은 눈물을 흘릴 시간이 없다.`, author: `바이런` },
  {
    category: `Success`,
    quote: `바쁠 때 자기 성품을 어지럽히지 않으려면 모름지기 한가할 때에 심신을 맑게 닦아야 하고, 죽을 때 마음이 흔들리지 않으려면 모름지기 살아 있을 때에 만물의 진상을 간파해야 한다.`,
    author: `홍자성`,
  },
  {
    category: `Success`,
    quote: `반드시 진리가 구체화할 필요는 없다. 진리가 우리의 정신속에 깃들이고 공감을 불러일으키고, 그리하여 종소리처럼 힘세고 자비롭게 공기속에 울리기만 하면 충분하다.`,
    author: `요한 볼프강 폰 궤테`,
  },
  {
    category: `Success`,
    quote: `받아도 되고 받지 않아도 될 때 받는 것은 청렴을 손상시키고 주어도 되고 주지 않아도 될 때 주는 것은 은혜를 손상시키며 죽어도 되고 죽지 않아도 될 때 죽는 것은 용기를 손상시키는 것이다.`,
    author: `맹자 - 중국의선비:BC373 ?~289 ?`,
  },
  {
    category: `Success`,
    quote: `방황과 변화를 사랑한다는 것은 살아 있다는 증거이다.`,
    author: `바그너`,
  },
  { category: `Success`, quote: `배가 고파서는 누구나가 애국자가 될 수 없다.`, author: `W C 브란` },
  { category: `Success`, quote: `배우라,비교하라,사실을 수입하라.`, author: `파플로프` },
  {
    category: `Success`,
    quote: `배우려는 욕구가 많은 곳에서는 필연적으로 많은 논의와 많은 저술, 많은 의견이 있을 것이다. 착한 사람들의 의견은 형성중에 있는 지식에 불과한 것이다.`,
    author: `존 밀턴 - 영국 시인:1608~1674`,
  },
  { category: `Success`, quote: `배운 사람은 항상 자기 속에 재산이 있다.`, author: `필래드라스` },
  {
    category: `Success`,
    quote: `백년을 살 것처럼 일하고 내일 죽을 것처럼 기도하라.`,
    author: `플랭클린`,
  },
  {
    category: `Success`,
    quote: `백발이란 나이를 먹었다는 표시이지 지혜를 나타내는 것은 아니다.`,
    author: ` `,
  },
  { category: `Success`, quote: `버들가지는 약하나 다른 재목을 묶는다.`, author: `하버트` },
  { category: `Success`, quote: `법은 도덕의 최소한.`, author: `옐리네크 - Jellinek` },
  {
    category: `Success`,
    quote: `벼슬 자리 없는 것을 걱정하지 말고, 벼슬에 올라 설 수 있을 만한 자기의 학식이나 능력에 대해 걱정하라. 또 남이 나를 몰라주는 것을 걱정 말고, 남들에게 알려질 만한 일을 하려고 애써라.`,
    author: `논어 이인편`,
  },
  {
    category: `Success`,
    quote: `변경을 허용하지 않는 것은 나쁜 계획이다.`,
    author: `푸볼릴리우스 시루스`,
  },
  {
    category: `Success`,
    quote: `별을 따려고 손을 뻗는 사람은 자기 발밑의 꽃을 잊어버린다.`,
    author: `제레미 벤담 - 영국 정치가 : 1748-1832`,
  },
  {
    category: `Success`,
    quote: `보다 많은 것을 갖기보다는 적게 바라는 것을 선택하라.`,
    author: `토머스 켄피스`,
  },
  {
    category: `Success`,
    quote: `보통 인간은 기회만 있으면 나쁜 짓을 하려고 든다.`,
    author: `아리스토텔레스`,
  },
  {
    category: `Success`,
    quote: `본능적인 충동이 있었던 곳에는 자아가 있을 것이다.`,
    author: `지크문트 프로이트 - 오스트리아 정신분석학자`,
  },
  {
    category: `Success`,
    quote: `봄이 무엇인지는 겨울이 되어 비로소 알 수 있다. 가장 뛰어난 5월의 노래는 爐邊노변에서 만들어 진다. 자유에 대한 사랑은 감옥의 꽃이다. 감옥에 있음으로써 비로소 자유의 가치를 안다.`,
    author: `하인리히 하이네 - 독일 시인 : 1797-1856`,
  },
  {
    category: `Success`,
    quote: `부귀를 누리는 사람들 주변에는 남들도 모여들고, 빈궁한 사람 곁에는 친척들도 거들떠 보지 않는다.`,
    author: `문선`,
  },
  {
    category: `Success`,
    quote: `부는 해수 같아서 많이 마실 수록 목이 마르다.`,
    author: `쇼펜하워`,
  },
  {
    category: `Success`,
    quote: `부당한 이득을 얻지말라, 그것은 손해와 같은 것이다.`,
    author: `헤시오도스`,
  },
  {
    category: `Success`,
    quote: `부드러운 흙으로 만들어진 남자를 기쁘게 하는 편이 딱딱한 뼈로 만들어진 여자를 기쁘게 하는 것보다 훨씬 쉽다.`,
    author: `유태 격언`,
  },
  {
    category: `Success`,
    quote: `부를 멸시하는 사람은 매우 많다. 그러나 부를 나누어줄 줄 아는 사람은 거의 없다.`,
    author: `프랑수아 드 라 로슈푸코 - Francois Ⅵ, duc de La Rochefoucauld`,
  },
  {
    category: `Success`,
    quote: `부모를 왕위에 나아가게 한다해도 그 은혜는 다 갚지 못한다.`,
    author: `석가모니 - 인도 불교 창시자:BC565~485`,
  },
  {
    category: `Success`,
    quote: `부유함이 문명을 낳지는 못하나, 문명은 부유함을 낳는다.`,
    author: `비처`,
  },
  {
    category: `Success`,
    quote: `부자가 되는 가장 가까운 길은 부를 경영하는데 있다.`,
    author: `루시우스 아나에우스 세네카 - Lucius Annaeus Seneca`,
  },
  {
    category: `Success`,
    quote: `부지런한 바보만큼 이웃을 괴롭히는 자는 없다.`,
    author: `H. 가이야`,
  },
  { category: `Success`, quote: `부패한 사회에는 많은 법률이 있다.`, author: `사무엘 죤슨` },
  { category: `Success`, quote: `분노는 바보들의 가슴 속에서만 살아간다.`, author: `아인슈타인` },
  {
    category: `Success`,
    quote: `분별없고 능력도 없고, 또 사려도 없는 자에게는 등산만큼 위험한 것은 없 다.`,
    author: `C E 마슈즈`,
  },
  {
    category: `Success`,
    quote: `불가능은 소심한 자의 환상이요, 비겁한 사람의 도피처이다.`,
    author: `나폴레옹`,
  },
  {
    category: `Success`,
    quote: `불멸의 희망이 없이는 아무도 조국을 위해 스스로 목숨을 바치지 않았을 것이다.`,
    author: `마르쿠스 툴리우스 키케로 - 로마 정치가 : BC 106-43`,
  },
  {
    category: `Success`,
    quote: `불행은 진정한 친구가 아닌 자를 가려준다.`,
    author: `아리스토텔레스`,
  },
  {
    category: `Success`,
    quote: `불행이란 거의 언제나 인생에 대한 그릇된 해석의 표적이다.`,
    author: `몬테르랑`,
  },
  { category: `Success`, quote: `비교는 친구를 적으로 만든다.`, author: `필레몬` },
  {
    category: `Success`,
    quote: `비난은 사람이 유명하게 되었을때 대중에게 바치는 세금이다.`,
    author: `조너선 스위프트 - 영국 시인 : 1667-1745`,
  },
  {
    category: `Success`,
    quote: `비록 내일 지구가 멸망하더라도 나는 한 그루의 사과 나무를 심겠다.`,
    author: `스피노자`,
  },
  {
    category: `Success`,
    quote: `비폭력이란 강력하고 정당한 무기로서 상처없이 잘라내며 그것을 휘두르는 사람을 고상하게 만들어 준다. 비폭력은 치료의 검이다.`,
    author: `마틴 루터 킹 - 미국 흑인지도자:1929 ~ 1968`,
  },
  { category: `Success`, quote: `빈부강약을 막론하고 일하지 않는자를 배척하라.`, author: `루소` },
  { category: `Success`, quote: `빈곤은 부정을 가르친다.`, author: `세네카` },
  { category: `Success`, quote: `빈곤은 재앙이 아니라 불편이다.`, author: `플로리오` },
  { category: `Success`, quote: `빈궁이란 가난하다고 느끼는 것에 있는 것이다.`, author: `에머슨` },
  { category: `Success`, quote: `뿌리가 튼튼해야 열매가 많다.`, author: `용비어천가` },
  {
    category: `Success`,
    quote: `사건을 일으켜서는 안된다. 그것이 일어날 때까지 기다려야 한다.`,
    author: `오토 폰 비스마르크`,
  },
  {
    category: `Success`,
    quote: `사계절은 각각 계절이 오면 언제나 우리에게는 가장 좋다.`,
    author: `솔로`,
  },
  {
    category: `Success`,
    quote: `사고는 수염과 같은것이다. 성장하기 전에는 나오지 않는다.`,
    author: `볼테르 - 프랑스 사상가 :1694~1778`,
  },
  {
    category: `Success`,
    quote: `사나이 뜻을 세워 집을 나가면 공을 이루지 않고서는 살아서 돌아 오지 않으리.`,
    author: `매헌 윤봉길`,
  },
  {
    category: `Success`,
    quote: `사나이의 애정은 자신이 육체적 만족을 취한 순간부터 급격히 떨어진다. 다른 여자라면 누구를 막론하고 그가 소유한 여인보다 많은 매력을 가진 듯이 생각되며 그는 변화를 추구한다. 그것과는 반대로 여인의 애정은 이 순간부터 증대한다.`,
    author: `쇼펜하워`,
  },
  {
    category: `Success`,
    quote: `사람은 고생을 면할 수가 없다. 그러나 잊을 수 있는 능력이 있다.`,
    author: `디즈레일리`,
  },
  {
    category: `Success`,
    quote: `사람은 결코 죽음을 생각해서는 안된다. 오직 삶을 생각하라. 이것이 참된 신앙이다.`,
    author: `벤자민 디즈레일리 - 영국 정치가:1804~1881`,
  },
  {
    category: `Success`,
    quote: `사람은 나이를 먹는 것이 아니라 좋은 포도주처럼 익는 것이다.`,
    author: `필립스`,
  },
  {
    category: `Success`,
    quote: `사람은 돈지갑이 가난해도, 정신적으로는 긍지를 가질 수 있다.`,
    author: `메이슨`,
  },
  {
    category: `Success`,
    quote: `사람은 명예와 지위의 즐거움은 알면서도, 이름 없고 평범하게 지내는 참다운 즐거움은 알지 못한다.`,
    author: `채근담`,
  },
  {
    category: `Success`,
    quote: `사람은 반드시 자기 자신을 아끼는 마음이 있어야만 비로소 자기를 이겨낼 수 있고 자기 자신을 이겨낼 수 있어야 만 비로소 자신을 완성할 수 있다.`,
    author: `王陽明 - 중국 유학자:1472~1528`,
  },
  { category: `Success`, quote: `사람은 사랑하도록 물건은 사용되도록 만들어졌다.`, author: `호위` },
  {
    category: `Success`,
    quote: `사람은 삶이 두려워서 사회를 만들었고 죽은미 두려워서 종교를 만들었다.`,
    author: `스펜서 - H. Spencer`,
  },
  {
    category: `Success`,
    quote: `사람은 성실할수록 자신감을 얻게 된다. 성실할수록 태도가 안정되어 간다. 성실할수록 정신을 자각하게 된다. 성실할 때에만 자기가 엄연히 이 세상에서 존재하고 있다고 생각을 갖게 된다.`,
    author: `아우렐리우스 아우구스티누스 - Aurelius Augustinus`,
  },
  {
    category: `Success`,
    quote: `사람은 아니오를 자꾸 반복하도록 강제하는 어떤 것으로부터도 이탈해야 한다.`,
    author: `프리드리히 빌헴름 니체 - Friendrichdh Nietzsche`,
  },
  {
    category: `Success`,
    quote: `사람은 여자로 태어나지 않는다. 여자로 자라는 것이다.`,
    author: `보봐르`,
  },
  {
    category: `Success`,
    quote: `사람은 입이 하나이고 귀가 둘이다.(유태인의 탈무드) - 심동은 `,
    author: `durimlover@hanmail.net`,
  },
  {
    category: `Success`,
    quote: `사람은 자기 일보다 남의 일을 더 잘 알고 더 잘 판단한다.`,
    author: `테린티우스`,
  },
  {
    category: `Success`,
    quote: `사람은 출생에서 죽음에 이르기까지 법률상 자유 및 평등이다.`,
    author: `인권선언`,
  },
  {
    category: `Success`,
    quote: `사람을 낚아 올리는 악마는 여러가지 맛있는 미끼를 보인다.`,
    author: `요한 볼프강 폰 괴테 - 독일의 문호:1749~1832`,
  },
  {
    category: `Success`,
    quote: `사람을 알려면 그의 지갑, 쾌락, 그리고 불평을 보라.`,
    author: `탈무드`,
  },
  {
    category: `Success`,
    quote: `사람의 가치는 타인과의 관계로서만 측정될 수 있다.`,
    author: `니체`,
  },
  {
    category: `Success`,
    quote: `사람의 얼굴은 하나의 풍경이다. 한권의 책이다. 얼굴은 결코 거짓말을 하지 않는다.`,
    author: `오노레 드 발자크 - 프랑스 소설가:1799~1850`,
  },
  {
    category: `Success`,
    quote: `사람의 잘못은 좀처럼 자신에게는 나타나지 않는다.`,
    author: `셰익스피어`,
  },
  {
    category: `Success`,
    quote: `사람의 척도는 그가 불행을 얼마나 잘 이겨내는지에 달려있다.`,
    author: `프르다크`,
  },
  { category: `Success`, quote: `사람의 천성과 직업이 맞을때 행복하다.`, author: `베이컨` },
  {
    category: `Success`,
    quote: `사람이 마음으로 부터 사랑하는 것은 단 한번 밖에 없다. 그것이 첫 사랑이다.`,
    author: `라 브뤼예르 - 프랑스 모럴리스트:1645 ~ 1696`,
  },
  {
    category: `Success`,
    quote: `사람이 잘 지껄일 수 있는 재간을 지니지 못했으면 침묵을 지킬줄 아는 지각이라도 있어야 한다. 만약 이 두 가지를 갖고 있지 않으면 그 사람은 불행한 사람이다.`,
    author: `라 브뤼예르 - 프랑스 모럴리스트:1645~1696`,
  },
  {
    category: `Success`,
    quote: `사람이 죽고 사는 것은 운명에 달려 있고,부유하고 가난한 것은 천 명에 달려 있으므로, 그 오는 것은 막아서는 안되고, 가는 것은 좇아 가서 안 된다는데, 그대는 무엇을 근심하랴.`,
    author: `백결선생`,
  },
  { category: `Success`, quote: `사랑없이 사는 것은 정말로 사는 것이 아니다.`, author: `몰리에르` },
  { category: `Success`, quote: `사랑은 그 왕국을 무기없이 지배한다.`, author: `허버트` },
  {
    category: `Success`,
    quote: `사랑은 깨닫지 못하는 사이에 찾아 든다. 우리들은 다만 그것이 사라져가는 것을 볼 뿐이다.`,
    author: `도브슨`,
  },
  { category: `Success`, quote: `사랑은 늦게 올수록 격렬하다.`, author: `호리티우스` },
  { category: `Success`, quote: `사랑은 마음을 기쁘게 하는 포도주이다.`, author: `니누바` },
  {
    category: `Success`,
    quote: `사랑은 사람을 치료한다. 사랑을 받은 사람,사랑을 주는 사람 할 것이 없이.`,
    author: `메닝거`,
  },
  { category: `Success`, quote: `사랑은 사시사철의 열매이다.`, author: `테레사 수녀` },
  { category: `Success`, quote: `사랑은 상처입는 것을 계산하지 않는 것이다.`, author: `카미컬` },
  {
    category: `Success`,
    quote: `사랑은 세상에서 가장 좋은 것이고 제일 오래 가는 것이다.`,
    author: `헨리`,
  },
  { category: `Success`, quote: `사랑은 세상의 가장 신비한 에너지이다.`, author: `간디` },
  {
    category: `Success`,
    quote: `사랑은 시간을 가게 하고 시간은 사랑을 가게 한다.`,
    author: `프랑스 속담`,
  },
  { category: `Success`, quote: `사랑은 아낌없이 뺏는 것이다.`, author: `아리시마 다케오` },
  {
    category: `Success`,
    quote: `사랑은 오직 한 종류밖에 없는데 모조품은 수천 가지이다.`,
    author: `리티머`,
  },
  { category: `Success`, quote: `사랑은 인생의 소금이다.`, author: `셰필드` },
  {
    category: `Success`,
    quote: `사랑은 죽음보다도, 죽음의 공포보다도 강하다. 단지 사랑에 의해서만 인생은 주어지고 계속 진보한다.`,
    author: `이반 세르게예비치 투르게네프 - 러시아 작가 : 1818-1883`,
  },
  {
    category: `Success`,
    quote: `사랑은 증오보다 고귀하고, 이해는 분노보다 높으며, 평화는 전쟁보다 고귀하다.`,
    author: `헤르만 헤세 - 독일 시인:1877~1962`,
  },
  {
    category: `Success`,
    quote: `사랑은 진실을 고백했을 때 깨어지는 수가 있고, 우정은 허위로 깨어진다.`,
    author: `보나르`,
  },
  {
    category: `Success`,
    quote: `사랑은 타오르는 불길인 동시에 앞을 비추는 광명이라야 한다. 타오르는 사 랑은 흔하다. 그러나 불길이 꺼지면 무엇에 의지할 것인가. 사랑은 정신생 활 면에 던지는 빛이 있어야 한다.`,
    author: `바이어런`,
  },
  {
    category: `Success`,
    quote: `사랑은 행복을 죽이고, 행복은 사랑을 죽인다.`,
    author: `스페인 명언`,
  },
  {
    category: `Success`,
    quote: `사랑은 홍역과 같은 것이다. 나이가 들어서 걸리면 걸릴수록 중증을 나타낸 다.`,
    author: `윌리암 제롤드`,
  },
  {
    category: `Success`,
    quote: `사랑을 받기만 하는 인생은 아루런 쓸모가 없는 것이고 위험이다. 될 수 있으면 자신을 극복하고 사랑하는 사람이 되고 싶다.`,
    author: `라이너 마리아 릴케 - 독일 시인:1875~1926`,
  },
  {
    category: `Success`,
    quote: `사랑을 세상에서 취하여 간다면 이곳은 무덤이다.`,
    author: `브로잉`,
  },
  {
    category: `Success`,
    quote: `사랑을 하고 있는 사람의 귀는 아무리 낮은 소리라도 다 알아듣는다.`,
    author: `세익 스피어`,
  },
  {
    category: `Success`,
    quote: `사랑을 하다가 사랑을 잃은 편이 한번도 사랑하지 않는 것보다 낫다.`,
    author: `테니슨`,
  },
  {
    category: `Success`,
    quote: `사랑의 절대적 가치는 인생을 가치있게 만든다. 그리하여 인간의 생소하고 어려운 처지를 바람직하게 만든다. 사랑은 인생을 죽음에서 구원할 수는 없다. 그러나 인생의 목적을 충족시킬 수 있다.`,
    author: `조지 스미스 패튼, 아놀드 조지프 토인비 - Arnold Joseph Toynbee`,
  },
  { category: `Success`, quote: `사랑이란 늙는다는 것을 모른다.`, author: `스땅달` },
  {
    category: `Success`,
    quote: `사랑이란 마치 열병같아서 자기 의사와는 관계없이 생겼다간 꺼진다.`,
    author: `스땅달`,
  },
  {
    category: `Success`,
    quote: `사랑이란 어리석은 자의 지혜이며 賢人의 우행이다.`,
    author: `사무엘 죤슨`,
  },
  {
    category: `Success`,
    quote: `사랑이란 젊은 마음에는 너무나도 강력한 즐거움이다. 다른 어떤 신앙이 연 애와 양립될 수 있을 것인가.`,
    author: `로망 로랑`,
  },
  {
    category: `Success`,
    quote: `사랑하고 나서 잃는 것은 전혀 사랑하지 않았던 것보다 더 낫다.`,
    author: `테니슨`,
  },
  {
    category: `Success`,
    quote: `사랑하고 사랑받는 것은 태양을 양쪽에서 쪼이는 것과 같다.`,
    author: `비스코트`,
  },
  { category: `Success`, quote: `사랑하고 재채기는 감출 수 없다.`, author: `헐벗` },
  { category: `Success`, quote: `사랑하는 가슴은 언제나 젊다.`, author: `틸리취` },
  { category: `Success`, quote: `사랑하는 이는 가난을 모른다.`, author: `불버` },
  {
    category: `Success`,
    quote: `사랑할 때는 마음의 평화가 있을 수 없다. 자기가 확보한 이점도, 더한 욕망의 새로운 출발점 이외엔 아무 것도 아니기 때문이다.`,
    author: `마르셀 프루스트 - 프랑스 작가 : 1871-1922`,
  },
  {
    category: `Success`,
    quote: `사막이 아름다운 것은 어딘가에 샘을 숨기고 있기 때문이다.`,
    author: `생텍쥐베리`,
  },
  {
    category: `Success`,
    quote: `사색을 할 동안 인간은 신과 같이 된다. 행동과 욕망에서는 환경의 노예일 뿐이다.`,
    author: `버트런드 아서 윌리엄 러셀 - 영국철학자:1872~1970`,
  },
  {
    category: `Success`,
    quote: `사소한 일들은 아무것도 아닌 것처럼 보이지만, 개별적으로는 무질서한 것 같으면서도 모두가 공중에 향기를 내는 풀밭의 꽃들처럼 평온을 준다.`,
    author: `조르주 베르나노스 - Georges Bernanos`,
  },
  {
    category: `Success`,
    quote: `사십세가 지나면 인간은 자신의 습관과 결혼해 버린다.`,
    author: `메러디즈`,
  },
  {
    category: `Success`,
    quote: `사십세가 지난 인간은 자신의 얼굴에 책임을 져야 한다.`,
    author: `링컨`,
  },
  {
    category: `Success`,
    quote: `사악은 언제나 미덕보다 더 쉽게.왜냐하면 사악은 모든 일에 지름길을 택하기 때문이다.`,
    author: `존스`,
  },
  {
    category: `Success`,
    quote: `사업을 좌우하여라. 사업에 의해 좌우되어서는 안된다.`,
    author: `플랭클린`,
  },
  {
    category: `Success`,
    quote: `사자라 할지라도 파리들로부터 자기 몸을 방어해야 한다.`,
    author: `독일격언`,
  },
  {
    category: `Success`,
    quote: `사치는 가난이나 마찬가지로 악덕이다. 우리들의 목표는 풍부하게 소유하는데 있는 것이 아니고 풍성하게 존재하는 것이어야 한다.`,
    author: `카를 하인리히 마르크스 - Karl Heinrich Marx`,
  },
  {
    category: `Success`,
    quote: `사회는 그 구성원의 이익을 위하여 존재하는 것이지 그 구성원들이 사회의 이익을 위하여 존재하는 것이 아니다.`,
    author: `허버트 스펜서 - 영국의 철학자`,
  },
  {
    category: `Success`,
    quote: `사회는 배와 같다. 누구나 키를 잡을 준비를 하지 않으면 안된다.`,
    author: `헨리크 입센 - Henrik Hohan lbsen`,
  },
  { category: `Success`, quote: `산 기계를 만들지 말고, 인간을 만들어라.`, author: `페스탈로찌` },
  {
    category: `Success`,
    quote: `산다는 것은 곧 고통을 치른다는 것과 같다. 그러므로 성실한 사람일수록 자신에게 이기려고 애를 쓰는 법이다.`,
    author: `보나파르트 나폴레옹 - 프랑스 군인황제`,
  },
  { category: `Success`, quote: `산다는 것은 서서히 태어나는 것이다.`, author: `생텍쥐베리` },
  {
    category: `Success`,
    quote: `'산에는 왜 오르는가 ?' '산이 거기 있기 때문이다.'`,
    author: `G 마로리`,
  },
  {
    category: `Success`,
    quote: `산을 보려면 들로가서 우러러 보아야하고,들을 보려면 산에 올라 내려다 봐야 한다.`,
    author: `아키아벨리`,
  },
  { category: `Success`, quote: `산을 옮기는 사람은 작은 돌멩이부터 옮긴다.`, author: `중국 속담` },
  {
    category: `Success`,
    quote: `산이 높다고 해서 귀한 것이 아니다. 나무가 있기 때문에 귀하다. 사람이 살 쪘다고 해서 귀한 것이 아니다. 지가 있으므로 귀한 것이다.`,
    author: `러스킨`,
  },
  { category: `Success`, quote: `산이 높을수록 풀은 낮다.`, author: `풀러` },
  {
    category: `Success`,
    quote: `산적을 멸하기는 쉬워도 심중의 적을 멸하기는 어렵다.`,
    author: `왕양명 - 王陽明`,
  },
  {
    category: `Success`,
    quote: `살아가는 기술이란 하나의 공격 목표를 골라 그리로 힘을 집중시키는 일이 다.`,
    author: `앙드레 모로아`,
  },
  {
    category: `Success`,
    quote: `살아있는 동안 위대했던 사람은 죽은 뒤에는 두배나 위대해 진다.`,
    author: `토마스 칼라일 - 영국 비평가.역사가:1795~1881`,
  },
  { category: `Success`, quote: `살아있는 실패작은 죽은 걸작보다 낫다.`, author: `버나드 쇼` },
  {
    category: `Success`,
    quote: `살아있는 인간이 죽은 사람보다 더 자선을 필요로 한다.`,
    author: `G 아놀드`,
  },
  {
    category: `Success`,
    quote: `살아 있다는 습관이 붙어 버렸기 때문에 우리는 죽음을 싫어한다. 죽음은 모든 고민을 제거시켜 주는데도.`,
    author: `T.브라운`,
  },
  {
    category: `Success`,
    quote: `삶은 순간들의 연속이다. 한순간,한순간을 사는 것이 성공하는 것이다.`,
    author: `켄트`,
  },
  {
    category: `Success`,
    quote: `삶은 죽음에서 생긴다. 보리가 싹트기 위해서는 씨앗이 죽지 않으면 안된다.`,
    author: `간디`,
  },
  {
    category: `Success`,
    quote: `삶의 어두운 길을 인도하는 유일한 지팡이는 양심이다.`,
    author: `하이네`,
  },
  {
    category: `Success`,
    quote: `상상력을 안 가진 정신은 망원경을 안 가진 천문대 같다.`,
    author: `헨리 포드 피처`,
  },
  { category: `Success`, quote: `상식은 그렇게 흔한 것이 아니다.`, author: `볼테르` },
  {
    category: `Success`,
    quote: `새는 알 속에서 빠져나오려고 싸운다. 알은 세계이다. 태어나기를 원하는 자는 하나의 세계를 파괴하지 않으면 안된다.`,
    author: `헤세`,
  },
  {
    category: `Success`,
    quote: `새로운 구제책을 쓰지 않는 자는 새로운 재앙이 올 것을 각오해야 한다. 시간은 가장 위대한 혁신자이기 때문이다.`,
    author: `프란시스 베이컨 - 영국 철학자`,
  },
  {
    category: `Success`,
    quote: `새로운 진리가 낡은 오류보다도 위험하다는 법은 없다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `생각하는 것이 인생의 소금이라면 희망과 꿈은 인생의 사탕이다. 꿈이 없다면 인생은 쓰다.`,
    author: `바론 리튼`,
  },
  {
    category: `Success`,
    quote: `생각하는 기계를 고안해 낸 탓으로 인간은 기계에 복종해야 할 최후의 한 걸음을 내디디었다.`,
    author: `망포드`,
  },
  {
    category: `Success`,
    quote: `생명의 자랑은 늘 신선하고 기운찬 점에 있다. 사람은 일생을 통하여 완성했다는 순간은 없는 것이다.`,
    author: `알랭 - 프랑스 철학자:1868~1951`,
  },
  { category: `Success`, quote: `생각이 깊지 못한 사람은 항상 입을 놀린다.`, author: `호머` },
  { category: `Success`, quote: `생명이 있는 한, 사람은 무엇인가 바랄 수 있다.`, author: `세네카` },
  {
    category: `Success`,
    quote: `생활은 전부 다음 둘로서 성립되고 있다. 하고 싶지만 할 수 없다, 할 수 있 지만 하고 싶지 않다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `생활의 기술이란 우리의 환경에 대한 계속적인 적응을 의미한다.`,
    author: `오카쿠라 카쿠조`,
  },
  {
    category: `Success`,
    quote: `생활한다는 것은 이 세상에서 가장 드문 일이다. 대다수의 사람들은 존재하고 있을 뿐이다.`,
    author: `와일드`,
  },
  {
    category: `Success`,
    quote: `서툰 의사는 한번에 한 사람을 해치지만, 서툰교사는 130명을 해친다.`,
    author: `보이어`,
  },
  { category: `Success`, quote: `선은 결코 실패하지 않는 유일한 투자이다.`, author: `소로` },
  {
    category: `Success`,
    quote: `선은 오직 하나 밖에 없다. 그것은 자기 양심에 따라 행동하는 일이다.`,
    author: `보봐르`,
  },
  { category: `Success`, quote: `선을 행하는 데는 나중이라는 말이 필요없다.`, author: `괴테` },
  {
    category: `Success`,
    quote: `선을 행함에는 노력이 필요하다. 그러나 악을 억제하려면 보다 더 노력이 필 요하다.`,
    author: `톨스토이`,
  },
  {
    category: `Success`,
    quote: `선이란 어떤 것인가를 모르는 경우라도, 사람들은 이것을 자신의 내부에 保 持하고 있다.`,
    author: `공자`,
  },
  {
    category: `Success`,
    quote: `선한 사람이 되라, 그러면 세상은 선한 세상이 될 것이다.`,
    author: `흰두교 속담`,
  },
  {
    category: `Success`,
    quote: `선한 의도의 자각은 불행할 때 가장 큰 위로가 된다.`,
    author: `마르쿠스 톨리우스 키케로 - 로마 정치가:BC106~43`,
  },
  {
    category: `Success`,
    quote: `선행을 하고도 나쁜 말을 듣는 사람은 행복하다.`,
    author: `마르쿠스 아우렐리우스 - 로마 황제:121~180`,
  },
  {
    category: `Success`,
    quote: `성경은 신앙의 책이요, 교회의 책이요, 도덕의 책이요, 종교의 책이요, 신으로부터 특별히 보내진 묵시의 책이지만 인간 자신의 개인적 책임, 인간 자신의 존엄성, 동포와의 평등을 가르치는 책이기도 하다.`,
    author: `대니얼 웹스터 - 미국 정치가: 1782~1852`,
  },
  {
    category: `Success`,
    quote: `성공으로 통하는 길은 자신의 남편을 믿고 있는 여자들로 혼잡하기 이를 데 없다.`,
    author: `쇼`,
  },
  { category: `Success`, quote: `성공은 결과이지 목적은 아니다.`, author: `플로베르` },
  {
    category: `Success`,
    quote: `성공은 사람의 나쁜 성격을 이끌어 내고 실패는 좋은 성격을 길러준다.`,
    author: `힐티 - 스위스 철학자:1833~1909`,
  },
  {
    category: `Success`,
    quote: `성공의 비결은 목적을 향해 시종일관하는 것이다.`,
    author: `디즈레일리`,
  },
  {
    category: `Success`,
    quote: `성공의 재능은 자기가 잘 할 수 있는것, 그리고 명성을 생각하지 않고 자기가 하는 일을 무엇이나 잘 해내는 일에 불과하다.`,
    author: `헨리 워즈워스 롱펠로 - 미국 시인:1807~1882`,
  },
  {
    category: `Success`,
    quote: `성공적인 결혼이란 매일같이 개축해야 하는 건물과 같은 것이다.`,
    author: `모로아`,
  },
  {
    category: `Success`,
    quote: `성공하는 사람들이란 자기가 바라는 환경을 찾아내는 사람들이다. 발견하지 못하면 자기가 만들면 된다.`,
    author: `조지 버너드 쇼 - George Bernard Shaw`,
  },
  { category: `Success`, quote: `성실이야말로 도덕의 핵심이다.`, author: `토머스 헉슬리` },
  {
    category: `Success`,
    quote: `성실하지 못한 사람은 위대한 것들을 생산할 수가 없다.`,
    author: `제임스 럿셀 로우웰`,
  },
  {
    category: `Success`,
    quote: `성인이 정치를 하는 근거가 되는 道도에 세가지가 있다. 첫째는 이익이요, 둘째는 위세요, 셋째는 명분이다. 이익이란 민심을 얻는 근거가 되고, 위세란 법령을 시행할 근거가 되며, 명분이란 상하가 따라야 할 근거가 된다. 세계는 한권의 책이며, 여행하는 사람들은 그 책의 한 페이지를 읽었을 뿐이다.`,
    author: `아우렐리우스 아우구스티누스 - 로마 철학자:354~430`,
  },
  { category: `Success`, quote: `세계의 역사는 세계의 심판이다.`, author: `실러아` },
  {
    category: `Success`,
    quote: `세계의 절반은 나머지 절반이 꿈을 꿀 수 있도록 땀을 흘리고 신음해야 한다.`,
    author: `헨리 워즈워스 롱펠로 - 미국의 시인`,
  },
  {
    category: `Success`,
    quote: `세상 사람들 모두가 나를 내책으로 알아도 좋고 나의 책을 알아도 좋다.`,
    author: `미셸 에컴 드 몽테뉴 - 프랑스사상가:1533~1592`,
  },
  {
    category: `Success`,
    quote: `세상에서 가장 아름다운 것은 물론 세상 그 자체이다.`,
    author: `스티븐슨`,
  },
  {
    category: `Success`,
    quote: `세상에서 가장 중요한 일은 어떻게 하면 내가 온전히 나 자신의 주인이 되는가를 아는 일이다.`,
    author: `미셸 에켐 드 몽테뉴 - Michel Eyquem de Montaigne`,
  },
  {
    category: `Success`,
    quote: `세상에서 가장 힘든 일은, 모든 사람이 생각하지 않고 말하는 것을, 생각하면서 말하는 것이다.`,
    author: `알랭 - 프랑스 철학자`,
  },
  {
    category: `Success`,
    quote: `세상이 당신에게 준 것보다 더 많이 세상에게 주어라.`,
    author: `헨리포드`,
  },
  {
    category: `Success`,
    quote: `소년기의 이상주의 속에서야말로 인간에게 진리가 인식되는 것이며, 소년기의 이상주의야말로 무엇과도 바꿀 수 없는 인간의 富다.`,
    author: `알베르트 슈바이처 - 독일 철학자,의사:1875~1965`,
  },
  {
    category: `Success`,
    quote: `소년이여, 야망을 가져라.Boys, be ambitious.`,
    author: `클라크 - Clark`,
  },
  { category: `Success`, quote: `소비된 시간은 존재하고 이용된 시간은 생명이다.`, author: `영` },
  {
    category: `Success`,
    quote: `소심하고 용기가 없는 인간에 있어서는 일체의 일이 불가능한 것이다. 왜냐하면, 일체가 불가능하게 보이기 때문인 것이다.`,
    author: `스코트`,
  },
  {
    category: `Success`,
    quote: `소위 어린이와 같은 순진한 생활의 기쁨이란 동물적인 기쁨에 지나지 않는 다.`,
    author: `체포크`,
  },
  {
    category: `Success`,
    quote: `소유물의 부족은 개선할 수 있으나 영혼의 가난은 해결하기 쉬운 것이 아니다.`,
    author: `몽테뉴`,
  },
  {
    category: `Success`,
    quote: `소인은 특별한 것에 관심이 있고, 위인은 평범한 것에 관심이 있다.`,
    author: `허버트`,
  },
  { category: `Success`, quote: `소인의 학문은 귀로 들어오고, 입으로 나간다.`, author: `순자` },
  {
    category: `Success`,
    quote: `속이는 말로 재물을 모으는 것은 죽음을 구하는 것이다.`,
    author: `성경 잠언`,
  },
  { category: `Success`, quote: `쇠가 달아 있는 동안에 쳐라.`, author: `앗다에우스` },
  {
    category: `Success`,
    quote: `수많은 여인의 정을 모은다 해도 내가슴에 타는 우정의 불에는 미치지 못한다. 언제나 이 가슴에 꺼지는 일이 없이 내 가슴은 따뜻한 때에 물결친다.`,
    author: `바이런 - 영국 시인:1788~1824`,
  },
  {
    category: `Success`,
    quote: `수치는 한때 어리석었다는 경험에 있지 않고, 그 어리석음을 곧 버리지 못함에 있다.`,
    author: `호라티우스 - 로마의 시인 : BC 65 ~ BC 8 - Quintus Hoatius Flaccus`,
  },
  { category: `Success`, quote: `순간을 지배하는 사람이 인생을 지배한다.`, author: `에센 바하` },
  {
    category: `Success`,
    quote: `순진함과 모든 완전한 가능성을 지니고 있는 어린이들이 끊이없이 태어나지 않는다면 세계는 얼마나 무시무시한 것으로 변했을까.`,
    author: `존 러스킨 - 영국 비평가 : 1819~1900`,
  },
  {
    category: `Success`,
    quote: `술과 여자와 노래를 사랑하지 않는 자는 일생동안 어리석은 자로 남는다.`,
    author: `마르틴 루터 - 독일 종교개혁가:1483~ 1546`,
  },
  {
    category: `Success`,
    quote: `술은 강하다. 왕은 더 강하다. 여자는 한층 더 강하다. 그러나 진리는 이보다도 한층 더 강하다.`,
    author: `마르틴 루터 - 독일 종교개혁가:1483~1546`,
  },
  { category: `Success`, quote: `술은 인격을 비춰주는 거울이다.`, author: `아르케시우스` },
  {
    category: `Success`,
    quote: `술이 빚은 우정은 술처럼 하룻밤밖에 가지 못한다.`,
    author: `F.V.로가우`,
  },
  {
    category: `Success`,
    quote: `술이 생각해 내는 것은 아무것도 없다. 떠들어댈 뿐이다.`,
    author: `쉴러`,
  },
  {
    category: `Success`,
    quote: `쉬워 보이는 일도 해보면 어렵다. 못할 것 같은 일도 시작해 놓으면 이루어진다. 쉽다고 얕볼 것이 아니고, 어렵다고 팔짱을 끼고 있을 것이 아니다. 쉬운 일도 신중히 하고 곤란한 일도 겁내지 말고 해보아야 한다.`,
    author: `채근담`,
  },
  {
    category: `Success`,
    quote: `스스로 돌아봐서 잘못이 없다면 천만인이 가로막아도 나는 가리라.`,
    author: `맹자`,
  },
  {
    category: `Success`,
    quote: `스승은 영원히 영향을 준다. 스승은 자기의 영향이 미치지 않는 곳을 결코 말할 수 없다.`,
    author: `핸리 브룩스 애덤스 - 미국역사가:1838~1918`,
  },
  {
    category: `Success`,
    quote: `슬프도다 ! 부모는 나를 낳았기 때문에 평생 고생만 했다.`,
    author: `시경`,
  },
  {
    category: `Success`,
    quote: `슬픈 곡조로 나에게 말하지 말라. 인생은 헛된 꿈에 지나지 않는다고.`,
    author: `롱 펠로`,
  },
  {
    category: `Success`,
    quote: `슬픔에서 해방된 인생을 살고 싶으면 바야흐로 일어나려고 하는 일을 마치 이미 일어난 것처럼 생각하라.`,
    author: `에픽테토스 - 그리스 철학자 : 55? -135?`,
  },
  {
    category: `Success`,
    quote: `슬픔은 현자의 교사임에 틀림없이 없다. 왜냐하면 슬픔은 지식이므로.`,
    author: `바 이어런`,
  },
  {
    category: `Success`,
    quote: `슬픔을 지니고 있는 사람은 행복하다. 그들은 위로를 받을 수 있기 때문에.`,
    author: `성서`,
  },
  {
    category: `Success`,
    quote: `습관은 제2의 천성으로 제1의 천성을 파괴한다.`,
    author: `블레즈 파스칼 - 프랑스 수학자,사상가:1623~1662`,
  },
  {
    category: `Success`,
    quote: `습관은 제 2 의 천성으로 제 1 의 천성을 파괴한다.`,
    author: `파스칼`,
  },
  {
    category: `Success`,
    quote: `습관의 쇠사슬은 거의 느끼지 못하만큼 가늘다. 그것을 깨달았을 때는 끊을 수 없을 정도로 이미 굳고 단단해져 있다.`,
    author: `린든 베인스 존슨 - 미국 정치가 `,
  },
  {
    category: `Success`,
    quote: `습관이란 인간으로 하여금 어떤 일이든지 하게 만든다.`,
    author: `도스토예프스키`,
  },
  {
    category: `Success`,
    quote: `승리는 목적이 아니다.목적에 이르는 하나의 단계이며 장애물을 제거하는데 지나지 않는다. 목표를 잃으면 승리도 공허하게 된다.`,
    author: `자와할루 네루 인도 초대 수상`,
  },
  {
    category: `Success`,
    quote: `시간은 말로써 나타낼 수 없을 만큼 멋진 만물의 소재이다.`,
    author: `아놀드 버넷`,
  },
  { category: `Success`, quote: `시간은 언제까지든 당신을 기다리는 것은 아니다.`, author: `짐멜` },
  {
    category: `Success`,
    quote: `시간은 우정을 강하게 만들고 사랑은 약하게 만든다.`,
    author: `라 브르예르`,
  },
  { category: `Success`, quote: `시간을 선택하는 것은 시간을 절약하는 것이다.`, author: `베이컨` },
  {
    category: `Success`,
    quote: `시간을 이용할 줄 아는 사람은 하루를 사흘로 통용한다.`,
    author: `영국 속담`,
  },
  { category: `Success`, quote: `시간을 잘 맞춘 침묵은 말보다 도 좋은 웅변이다.`, author: `터퍼` },
  {
    category: `Success`,
    quote: `시간이 덜어주거나 부드럽게 해주지 않는 슬픔이란 하나도 없다.`,
    author: `키케로`,
  },
  {
    category: `Success`,
    quote: `시간이 말하는 것을 잘 들어라. 시간은 가장 현명한 법률고문이다.`,
    author: `페리클레스 - Pericles`,
  },
  { category: `Success`, quote: `시기와 질투는 언제나 남을 쏘려다가 자신을 쏜다.`, author: `맹자` },
  {
    category: `Success`,
    quote: `시란 감정의 해방이 아니라 감정으로부터의 탈출이며, 인격의 표현이 아니라 인격으로부터의 탈출이다.`,
    author: `토머스 스턴스 엘리엇 - 영국 시인 : 1888-1965`,
  },
  {
    category: `Success`,
    quote: `시란 강력한 감정이 자연스럽게 흐르는 것이다. 그것은 고요한 가운데 회상되는 감정에서부터 솟아난다.`,
    author: `윌리엄 워즈워스 - 영국 시인:1770~ 1850`,
  },
  { category: `Success`, quote: `시련이란 진리로 통하는 으뜸가는 길이다.`, author: `바이런` },
  {
    category: `Success`,
    quote: `시민으로서의 가장 중요한 미덕은 멋지게 돈을 긁어 모으는 재능이다. 다시 말해서 어떠한 일이 있더라도 남에게 폐를 끼치지 말라는 것이다.`,
    author: `표도르 미하일로비치 도스토예프스키 - 러시아 작가:1821 ~ 1881`,
  },
  {
    category: `Success`,
    quote: `시인이란, 그 마음 속에는 남이 알지 못하는 깊은 고뇌를 감추고 있으면서, 그 탄식과 비명이 아름다운 음악을 연주하면서 흘러나오게 되어 있는 입술을 가지고 있는 불행한 사람이다.`,
    author: `쇠렌 오뷔 키에르케고르 - 덴마크 철학자:1813~1855`,
  },
  {
    category: `Success`,
    quote: `시종일관하는 자는 운명을 믿고, 변덕 부리는 자는 요행을 믿는다.`,
    author: `디즈레일리`,
  },
  {
    category: `Success`,
    quote: `식욕없는 식사는 건강에 해롭듯이, 의욕이 동반되지 않은 공부는 기억을 해친다.`,
    author: `레오나르도 다빈치`,
  },
  {
    category: `Success`,
    quote: `신기한 말을 하는 것이 귀함이 아니라 실행함이 귀하다.`,
    author: `이태백`,
  },
  {
    category: `Success`,
    quote: `신념은 연애와 같은 것이어서 강요할 수 없는 것이다.`,
    author: `쇼펜하우어`,
  },
  {
    category: `Success`,
    quote: `신념을 갖지 않는 한 남에게 신념을 줄 수는 없다.`,
    author: `아놀드`,
  },
  {
    category: `Success`,
    quote: `신뢰는 거울의 유리와 같다. 한 번 금이가면 원래대로 하나가 되지 않는다.`,
    author: `앙리 프레데리크 아미엘 - 스위스 철학자:1821~1881`,
  },
  { category: `Success`, quote: `신사를 만드는 것은 옷이 아니다.`, author: `영국 속담` },
  {
    category: `Success`,
    quote: `신앙은 미신과는 다르다. 신앙을 굳게 지니고도 미신에까지 미친다면 그것은 신앙을 파괴하는 행동이다.`,
    author: `파스칼`,
  },
  { category: `Success`, quote: `신앙이 존재하는 곳에 신은 존재한다.`, author: `세르반테스` },
  {
    category: `Success`,
    quote: `신은 괴로워한다. 신은 싸운다. 싸우는 사람들과 함께, 또한 괴로워하는 모든 사람들을 위해서. 왜냐하면 그는 '생명'이며, 어둠 속에 떨어져 확대되어 어둠을 삼키는 한방울 빛이기 때문이다.`,
    author: `로맹 롤랑 - 프랑스 작가 : 1866-1944`,
  },
  {
    category: `Success`,
    quote: `신은 너로 하여금 신을 사랑하도록 만든 것이지, 신을 이해하도록 만든 것은 아니다.`,
    author: `볼테르`,
  },
  {
    category: `Success`,
    quote: `신은 도처에 가 있을 수 없기 때문에 어머니들을 만들었다.`,
    author: `유태 격언`,
  },
  {
    category: `Success`,
    quote: `신은 인간의 지혜를 깊게한다. 신은 무엇에 의해서 인간의 지혜를 심화시키는가. 슬픔에 의해서다. 인간이 도망치고 숨으려고 노력하는 슬픔에 의해서이다.`,
    author: `니콜라이 바실리예비치 고골리 - Nikolay Vasilyevich Gogol`,
  },
  {
    category: `Success`,
    quote: `신의있는 말은 아름답지 않고, 아름다운 말엔 신의가 없다. 착한 사람은 말에 능하지 않고, 말에 능한 사람은 착하지 않다.`,
    author: `노자 - 중국의 사상가`,
  },
  {
    category: `Success`,
    quote: `신의 존재를 부정하는 사람들은 인간의 존엄성을 파괴한다. 분명히 인간은 육체로 보면 짐승들과 같기 때문이다. 만일 인간의 영혼이 신의 것과 같지 않다면 인간은 비천한 피조물이다.`,
    author: `프란시스 베이컨 - 영국 철학자:1561~1626`,
  },
  {
    category: `Success`,
    quote: `신이 인간을 창조한 것이 아니라 인간이 신을 창조했다.`,
    author: `포이에르 바하`,
  },
  {
    category: `Success`,
    quote: `실패한 사람이 다시 일어나지 못하는 것은 그 마음이 교만한 까닭이다. 성공한 사람이 그 성공을 유지하지 못하는 것도 역시 교만한 까닭이다.`,
    author: `석가모니`,
  },
  {
    category: `Success`,
    quote: `쓰고 단것은 외부에서 생기고 어려운 것은 내부에서 자기자신의 노력으로부터 생긴다.`,
    author: `알베르트 아인슈타인 - Albert Einstein`,
  },
  { category: `Success`, quote: `쓴 맛을 보기 전에 단맛을 보아서는 안된다.`, author: `고울딤 헴` },
  {
    category: `Success`,
    quote: `쓸쓸한 마음으로 과거를 되돌아 보지 말라. 그것은 두번 다시 오지 않으니까 빈틈없이 현재를 이용하라. 그것을 할 사람은 곧 그대다. 그림자와 같은 미래를 향하여 나아가라. 두려워하지 말고 늠름하게.`,
    author: `헨리 워즈워스 롱펠로 - 미국시인:1807~1882`,
  },
  { category: `Success`, quote: `아는것이(앎은) 힘이다.`, author: `베이컨 - F. Bacon` },
  {
    category: `Success`,
    quote: `아름다운 것! 그 것은 마음의 눈으로 보여지는 미이다.`,
    author: `주베르`,
  },
  { category: `Success`, quote: `아름다운 것은 선하고 선한 자는 곧 아름다워진다.`, author: `삽포` },
  { category: `Success`, quote: `아름다운 아내를 가진다는 것은 지옥이다.`, author: `셰익스피어` },
  {
    category: `Success`,
    quote: `아름다움이란 경솔한 사람이 그릇생각하듯이 보이는 그대로 외관만의 치레는 아니다.`,
    author: `스펜서`,
  },
  {
    category: `Success`,
    quote: `아름다운 자비는 고결의 진정한 상징이다.`,
    author: `윌리엄 셰익스피어 - William Shakespeare Shakespeare`,
  },
  {
    category: `Success`,
    quote: `아무것도 버릴 수 없는 자는 아무것도 느낄 수 없다.`,
    author: `프리드리히 빌헬름 니체 - Friendricdh Nietzsche`,
  },
  {
    category: `Success`,
    quote: `아무것도 씌어져 있지 않은 백지와 같은 순백한 처녀란 어리석은 잠꼬대에 불과하다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `아무도 그가 사는 生생이상의 生을 잃지 않으며, 그가 잃는 生이상을 살지 않는다는 것을 명심하라.`,
    author: `마르쿠스 아우렐리우스 - 로마 황제`,
  },
  {
    category: `Success`,
    quote: `아무도 일년을 더 못 살 만큼 늙지도 않았으며, 아무도 오늘 죽을 수 없을 만큼 젊지도 않았다.`,
    author: `로하스`,
  },
  {
    category: `Success`,
    quote: `아무런 기대없이 사랑하는 자만이 참된 사랑을 안다.`,
    author: `시라`,
  },
  {
    category: `Success`,
    quote: `아무리 겸손한 사람이라도, 그를 알고 있는 친한 친구가 그에 대해서 생각하고 있는 것보다도 더 깊이 자기에 대해 생각하고 있는 것이다.`,
    author: `에센바흐`,
  },
  {
    category: `Success`,
    quote: `아무리 위대한 천재의 능력일지라도 기회가 없으면 소용이 없다.`,
    author: `보나파르트 나폴레옹 - 프랑스 군인황제:1769~1821`,
  },
  {
    category: `Success`,
    quote: `아무리 화려한 궁전이라도 초라한 내 집만한 곳은 없다.`,
    author: `페인`,
  },
  {
    category: `Success`,
    quote: `아버지는 아들의 덕을 말하지 않고, 아들은 아버지의 허물을 말하지 않아야 한다.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `아아, 자유여! 네 이름으로서 그 얼마나 많은 범죄가 저질러졌는가?`,
    author: `아담 장느 로랑`,
  },
  {
    category: `Success`,
    quote: `아아, 청춘! 사람은 그것을 한때만 가질뿐 나머지 시간은 그것을 상기한다.`,
    author: `앙드레 폴 기욤 지드 - 프랑스 소설가 : 1869-1951`,
  },
  {
    category: `Success`,
    quote: `아예 배우지 않느니 보다는 늦으나마 배우는 편이 낫다.`,
    author: `클레오 불르스`,
  },
  { category: `Success`, quote: `아이들에게 비평보다도 귀감이 필요하다.`, author: `쥬벨` },
  {
    category: `Success`,
    quote: `아직도 자신의 몇 분의 일도 알지 못하고 있다 그러므로 산다는 것에 초조를 느낀다.`,
    author: `제임스 딘`,
  },
  {
    category: `Success`,
    quote: `아직 아무도 지나치게 소박한 생활을 했다고 후회하는 사람은 없다.`,
    author: `톨스토이`,
  },
  {
    category: `Success`,
    quote: `아침잠은 시간의 지출이며, 이렇게 비싼 지출은 달리 없다.`,
    author: `앤드루 카네기 - 미국 사업가:1835~1919`,
  },
  {
    category: `Success`,
    quote: `악덕은 또 사랑과 같다. 사랑은 그것 때문이라면 무엇이든 희생을 한다.`,
    author: `구르몽`,
  },
  { category: `Success`, quote: `악에 대해서 가장 강한 태도는 조용한 태도이다.`, author: ` ` },
  {
    category: `Success`,
    quote: `악은 간혹 승리를 한다. 그러나 결코 정복하지는 못한다.`,
    author: `요셉 루`,
  },
  {
    category: `Success`,
    quote: `악은 선을 인식시키고 고통은 기쁨을 느끼게 한다.`,
    author: `그리스도`,
  },
  {
    category: `Success`,
    quote: `악은 쾌락 속에서도 고통을 주지만 덕은 고통 속에서도 위안을 준다.`,
    author: `콜튼`,
  },
  {
    category: `Success`,
    quote: `악을 피하는 것이 덕의 시작이다. 그리고 지혜의 시작은 어리석음을 면하는 것이다.`,
    author: `호라티우스 - Quintus Hoatius Flaccus`,
  },
  {
    category: `Success`,
    quote: `악의 근원을 이루는 것은 돈 바로 그것이 아니라 돈에 대한 애착인 것이다.`,
    author: `스마일즈`,
  },
  {
    category: `Success`,
    quote: `악의에 찬 적과 비할 데 없을 만큼 선의로 대하는 친구의 그 어느 편이 당신에게 큰 해를 끼치게 될지 예측할 수가 없다.`,
    author: `리튼`,
  },
  {
    category: `Success`,
    quote: `악이 우리들에게 선을 인식시키는 것과 같이 고통은 우리들에게 기쁨을 느끼게 한다.`,
    author: `클라이스크`,
  },
  {
    category: `Success`,
    quote: `안심하면서 먹는 한조각 빵이 근심하면서 먹는 잔치보다 낫다.`,
    author: `이솝`,
  },
  {
    category: `Success`,
    quote: `알맞으면 복이 되고 너무 많으면 해가 되나니, 세상에 그렇지 않은 것이 없거니와 재물에 있어서는 더욱 그것이 심하다.`,
    author: `莊子 - 중국 사상가:B.C. 365 ~ 290`,
  },
  {
    category: `Success`,
    quote: `알차게 보낸 하루가 편안한 잠을 제공하는 것처럼 알찬 생애가 평온한 죽음을 가져다 준다.`,
    author: `다빈치`,
  },
  {
    category: `Success`,
    quote: `암탉은 새벽에 울지 않는다. 암탉이 새벽을 알렸다면 그 집안은 음양이 바뀌어서 불길하게 되리라.`,
    author: `사기`,
  },
  {
    category: `Success`,
    quote: `앞으로의 세계는 지식이 모든 생산 수단을 지배하게 되며 이에 대비한 후세 교육없 이는 어느 나라든 생존하기 어렵다.`,
    author: `앨빈 토플러`,
  },
  { category: `Success`, quote: `애매한 말은 거짓말의 시작이다.`, author: `서양 속담` },
  {
    category: `Success`,
    quote: `야심은 분류와 같이 결코 되를 돌아보지 않는다.`,
    author: `벤 죤슨`,
  },
  {
    category: `Success`,
    quote: `야심이란 복면을 하고 죽마를 탄 탐욕에 지나지 않는다.`,
    author: `월터어 랜도울`,
  },
  {
    category: `Success`,
    quote: `양심은 스스로 돌아보아 브끄럽지 않다는 자각을 갑옷삼아, 아무것도 두렵게 하지 않는 좋은 친구다.`,
    author: `알리기에리 단테 - 이탈리아 시인`,
  },
  {
    category: `Success`,
    quote: `양심은 어떠한 과학의 힘보다도 강하고 현명하다.`,
    author: `라데이러`,
  },
  {
    category: `Success`,
    quote: `어느날 갑자기 착한 사람이 되거나 악인이 되는 사람은 없다.`,
    author: `시드니`,
  },
  {
    category: `Success`,
    quote: `어느 사회에서나 유아들에게 우유를 먹이는 것보다 더 좋은 투자는 없다.`,
    author: `처질`,
  },
  {
    category: `Success`,
    quote: `어느 시대고를 막론하고 그것은 하나의 스핑크스다. 사람이 그 수수께끼를 풀어 버리면 그와 동시에 멸망하지 않으면 안된다.`,
    author: `하이네`,
  },
  {
    category: `Success`,
    quote: `어떠한 것도 바라지 않는 사람은 이 세상 전부를 얻을 것이며, 자기를 잃어버리는 사람은 전 우주가 자기 것이 된다.`,
    author: `매슈 아놀드 - 영국 시인 : 1822-1888`,
  },
  {
    category: `Success`,
    quote: `어떠한 나이라도 사랑에는 약한 것이다. 그러나 젊고 순진한 가슴에는 그것 이 좋은 열매를 맺는다.`,
    author: `푸시킨`,
  },
  {
    category: `Success`,
    quote: `어떠한 일이든지 참아낼 수 있는 사람은 무슨 일이든지 해낼수가 있다. 인내는 인간이 가질수 있는 미덕이기도 하다.`,
    author: `마르틴 루터 - 독일의 종교개혁가:1483~1546`,
  },
  { category: `Success`, quote: `어떠한 충고일지라도 길게 말하지 말라.`, author: `호라티우스` },
  {
    category: `Success`,
    quote: `어떤 가치있는 행동을 하지 아니한 날, 그날은 잃은 날이다.`,
    author: `자콥 보바트`,
  },
  {
    category: `Success`,
    quote: `어떤 남자라도, 여자의 이상한 아름다움에는 저항할 수 없다.`,
    author: `탈무드`,
  },
  {
    category: `Success`,
    quote: `어떤 목적을 위해서 시작된 友情은 그 목적을 달할 때까지도 계속이 되지 않는다.`,
    author: `칼즈`,
  },
  {
    category: `Success`,
    quote: `어떤 불행은 도리어 희망의 토대가 된다. 불행 앞에 굴복하여 슬퍼하지 말고 그 불행을 이용하는 사람이 되라.`,
    author: `오노레 드 발자크 - 프랑스 소설가:1799~1850`,
  },
  {
    category: `Success`,
    quote: `어떤 사람은 과거의 기억을 되살려서 자기와 자기 몸을 학대한다. 어떤 자는 아직 보지도 못한 죄가 두려워서 자기 자신에게 상처를 입힌다. 어느 쪽도 어리석기 짝이 없는 것이다. 과거는 이미 관계가 없어졌고, 미래는 아직 오지 않았으니까...`,
    author: `세네카`,
  },
  {
    category: `Success`,
    quote: `어떤 사람은 슬픔을 딛고 서고, 어떤 사람은 슬픔 밑에 깔린다.`,
    author: `랠프 월도 에머슨 - 미국시인:1803~1882`,
  },
  {
    category: `Success`,
    quote: `어떤 일을 할 때 소인은 반드시 이득을 얻으려 하지만, 군자는 의를 얻으려 한다. 얻으려 한다는 점은 같으나, 그 기대하는 바가 서로 다른다.`,
    author: `회남자`,
  },
  {
    category: `Success`,
    quote: `어떤 일이건 60 분을 계속 생각하면 결국 도달하는 것은 혼란과 불행이다.`,
    author: `제임스 사버`,
  },
  {
    category: `Success`,
    quote: `어떻게 늙어가야 하는지를 아는 것은 슬기의 걸작이요, 삶이라는 위대한 예술에서 가장 어려운 장이다.`,
    author: `앙리 프레데리크 아미엘 - Henri Frederic Amiel`,
  },
  {
    category: `Success`,
    quote: `어떻게 될는지 도무지 알 수 없는 두 가지 경우가 있다. 남자가 처음으로 술 을 마셨을 때, 그리고 여자가 최후(오늘 밤이 마지막이라고)의 술을 마실 때.`,
    author: `O 헨리`,
  },
  {
    category: `Success`,
    quote: `어떻게 사는가를 배우는 데는 자신의 전생활을 필요로 한다.`,
    author: `루시우스 아나에우스 세네카 - 로마 철학자:BC 4~AD 65`,
  },
  {
    category: `Success`,
    quote: `어려운 것은 사랑하는 기술이 아니라 사랑을 받는 기술이다.`,
    author: `알퐁스 도데`,
  },
  {
    category: `Success`,
    quote: `어리석은 자는 수치스러운 일을 할 때에도 그것이 언제나 그의 의무라고 선포한다.`,
    author: `버나드쇼`,
  },
  {
    category: `Success`,
    quote: `어리석은 자의 특징은 타인의 결점을 들어내고, 자신의 약점은 잊어버리는 것이라고 하겠다.`,
    author: `키케로`,
  },
  {
    category: `Success`,
    quote: `어리석은 짓을 삼가는 것이 지혜의 입문이다.`,
    author: `호라티우스`,
  },
  {
    category: `Success`,
    quote: `어리석은 행위의 제1단계는 자기 자신의 현명함에 자기도취하는 것이며, 제2단계는 그것을 고백하는 것이고, 제3단계는 충고를 경멸하는 것이다.`,
    author: `벤저민 프랭클린 - Benjamin Franklin`,
  },
  { category: `Success`, quote: `어린이가 없는 곳에 천국은 없다.`, author: `스위번` },
  {
    category: `Success`,
    quote: `어린이를 불행하게 하는 가장 확실한 방법은 언제든지, 무엇이라도 손에 넣을 수 있게 내 버려 두는 것이다.`,
    author: `루소`,
  },
  {
    category: `Success`,
    quote: `어린이의 교육은 면학의 욕망과 흥미를 환기시키는 것이 가장 중요하다. 그렇지 않으면 책을 등에 진 나귀를 기르는 꼴이 되어버린다.`,
    author: `미셸 에켐 드 몽테뉴 - 프랑스 사상가:1533~1592`,
  },
  {
    category: `Success`,
    quote: `어버이를 공경함은 으뜸가는 자연의 법칙이다.`,
    author: `발레리우스 막시무스`,
  },
  {
    category: `Success`,
    quote: `어울리는 결혼을 원한다면 대등한 사람과 하라.`,
    author: `오비디우스`,
  },
  { category: `Success`, quote: `언론의 자유를 죽이는 것은 진리를 죽이는 것이다.`, author: `밀턴` },
  { category: `Success`, quote: `언제까지 계속되는 불행이란 없다.`, author: `로맹롤랑` },
  {
    category: `Success`,
    quote: `언제나 겸손한 사람은 남에게 칭찬을 들었을 때나 험담을 들었을 때나 변함이 없다.`,
    author: `장 파울 - 독일 소설가 : 1763-1825`,
  },
  { category: `Success`, quote: `언제나 마음에 태양을 품고 살아가자.`, author: ` ` },
  {
    category: `Success`,
    quote: `언제나 사랑하고 있는 사람은 불평을 늘어놓거나 불행에 빠지거나 할 겨를 이 없다.`,
    author: `쥬베르`,
  },
  {
    category: `Success`,
    quote: `언제나 정의를 행하라. 이것은 많은 사람들을 기쁘게 할 것이며, 그밖의 사람들을 놀라게 할 것이다.`,
    author: `마크 트웨인 - 미국작가:1835~1910`,
  },
  {
    category: `Success`,
    quote: `언제나 행위의 동기만을 중요시하여 귀착되는 결과를 생각하지 말라. 報酬보수에의 기대를 행위의 결과로 생각하는 사람이 되지 말라.`,
    author: `루트비히 판 베토벤 - 독일 작곡가`,
  },
  {
    category: `Success`,
    quote: `얻기 어려운 것은 시기요, 놓지기 쉬운 것은 기회이다.`,
    author: `조광조`,
  },
  {
    category: `Success`,
    quote: `얼굴 아는 이는 천하에 가득하되 마음 아는 이는 과연 몇이나 될까.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `얼마나 오래 사느냐가 아니라 어떻게 사느냐가 문제.`,
    author: `베일리`,
  },
  {
    category: `Success`,
    quote: `에로스는 모든 신 중에서 인간의 최대의 벗이고 인류의 구조자이며 또 모든 고뇌의 의사다.`,
    author: `플라톤`,
  },
  {
    category: `Success`,
    quote: `여가를 지적으로 채울 수 있다는 것은 문명의 최대 성과이다.`,
    author: `버트런드 아서 윌리엄 러셀 - Bertrand Russell`,
  },
  {
    category: `Success`,
    quote: `여가를 활용하지 못하는 사람은 항사 여가시간이 없다.`,
    author: `서양 격언`,
  },
  {
    category: `Success`,
    quote: `여러 사람이 우기면 평지에도 숲이 나고, 날개 없이도 날 수 있다.`,
    author: `회남자`,
  },
  {
    category: `Success`,
    quote: `여인들이 혼자 있을 때 어떻게 시간을 보내고 있는가를 남자들이 안다면 남자들은 결코 결혼 같은 것은 하지 않을 것이다.`,
    author: `O.헨리`,
  },
  {
    category: `Success`,
    quote: `여자가 처음으로 사랑할 때는 연인을 사랑하고 두번째 사랑을 할 때는 사랑 자체를 사랑한다.`,
    author: `프랑수아 드 라 로슈푸코 - 프랑스 사상가:1613~1680`,
  },
  {
    category: `Success`,
    quote: `여자는 자신의 장점때문에 사랑을 받게 되는 경우에는 때로는 동의도 하지만 언제나 바라는 것은 자신의 결점을 사랑해주는 사람이다.`,
    author: `프레보`,
  },
  {
    category: `Success`,
    quote: `여자는 커다란 잘못은 용서할 것이다. 그러나 작은 모욕은 결코 잊어버리지 않는다.`,
    author: `토머스 해리버튼`,
  },
  {
    category: `Success`,
    quote: `여자란 눈물을 흘리는 남자 앞에서는 냉정을 유지하기 어렵다.`,
    author: `S.D.코렛`,
  },
  {
    category: `Success`,
    quote: `여자란 아무리 연구를 계속해도 항상 완전히 새로운 존재다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아 작가 : 1828-1910`,
  },
  {
    category: `Success`,
    quote: `여자의 마음을 잡으려면 자기 처에게 남이 말해서는 안되는 그런 소리를 그녀에게 하라.`,
    author: `루나르`,
  },
  {
    category: `Success`,
    quote: `여자의 '예스'와 '노우'는 같은 것이다. 거기에 선을 긋는다는 것은 무모한 짓이다.`,
    author: `세르반테스`,
  },
  {
    category: `Success`,
    quote: `여행과 변화를 사랑하는 사람은 생명이 있는 사람이다.`,
    author: `바그너`,
  },
  {
    category: `Success`,
    quote: `여행이란 젊은이들에게는 교육의 일부이며 연장자들에겐 경험의 일부이다.`,
    author: `베이컨`,
  },
  {
    category: `Success`,
    quote: `역경은 사람을 부유하게 하지는 않으나 지혜롭게 한다.`,
    author: `풀러`,
  },
  {
    category: `Success`,
    quote: `역사란 언제나 패배자에게 등을 돌리고 승리자를 옳다고 하는 것임을 잊어서는 안된다.`,
    author: `S. 츠바이크 - 오스트리아 소설가:1881~1942`,
  },
  {
    category: `Success`,
    quote: `역사란 인쇄된 종이 조각에 불과한 것이다. 중요한 것은 역사를 만드는 일이지, 역사를 쓰는 일이 아니다.`,
    author: `오토 폰 비스마르크`,
  },
  {
    category: `Success`,
    quote: `역사란 자연과 사상, 이 두 개의 작용과 반작용에 지나지 않는다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `역사의 의무는 진실과 허위, 확실과 불확실, 의문과 否認부인을 분명히 구별하는 것이다.`,
    author: `요한볼프강 폰 괴테 - 독일의 철학자`,
  },
  {
    category: `Success`,
    quote: `연애결혼, 그것은 과오를 아버지로 하고 불가피한 필요를 어머니로 한다.`,
    author: `니체`,
  },
  {
    category: `Success`,
    quote: `연애과정에서는 방해가 더 열렬한 연정의 동기가 된다.`,
    author: `셰익스피어`,
  },
  { category: `Success`, quote: `연애는 결혼의 새벽, 결혼은 연애의 황혼이다.`, author: `드 삐노` },
  {
    category: `Success`,
    quote: `연애는 장관의 의자와 같이 그렇게 쉽게는 손에 넣을 수 없는 행복된 장래이다.`,
    author: `스탕달 - 프랑스 소설가 : 1783-1842`,
  },
  {
    category: `Success`,
    quote: `연애란 남자가 단 한 사람의 여자에 만족하기 위해 치르는 노력이다.`,
    author: `폴 제라르디`,
  },
  {
    category: `Success`,
    quote: `연애란 우주를 단 하나의 사람으로 줄이고, 그 사람을 신에 이르기까지 확대하는 것이다.`,
    author: `빅토르 마리 위고 - 프랑스 소설가 : 1802-1885`,
  },
  {
    category: `Success`,
    quote: `연애란 인생에서 맛볼 수 있는 최대의 기쁨이고 인간에게 주어진 광기어린 일이다.`,
    author: `스탕달 - 프랑스 소설가:1783~1842`,
  },
  {
    category: `Success`,
    quote: `연애를 처음으로 해 보는 사람은 비록 그것이 끝을 맺지 못하더라도 신이다. 그러나 두번 다시 연애를 하는 사람은 다군다나 그것을 끝을 맺지 못하면 바보이다.`,
    author: `하인리히 하이네 - 독일의 시인:1797~1856`,
  },
  {
    category: `Success`,
    quote: `연애에서 가질 수 있는 행복은 사랑하는 여자의 손을 처음으로 잡아보는 것이다.`,
    author: `스탕달 - 프랑스 소설가 : 1783-1842`,
  },
  {
    category: `Success`,
    quote: `연정 - 종족보존을 위해 자연이 우리에게 마련한 비겁한 음모 S.`,
    author: `몸`,
  },
  { category: `Success`, quote: `열의없이 성취된 위업이란 아직 하나도 없다.`, author: `애머슨` },
  {
    category: `Success`,
    quote: `열중하는 마음이 없다면 이 세상에 진보란 있을 수 없다.`,
    author: `윌슨`,
  },
  { category: `Success`, quote: `영예의 정상은 미끄러운 곳이다.`, author: `미첼` },
  {
    category: `Success`,
    quote: `영웅 숭배는 인류에 있어서는 어디서나 존재하고 있었고, 또 존재하고 있으 며, 앞으로도 영구히 존재할 것이다.`,
    author: `칼 라일`,
  },
  {
    category: `Success`,
    quote: `영웅이란 자신이 할 수 있는 일을 해낸 사람이다. 범인은 할 수 있는 일을 하지 않고 할 수 없는 일만을 바라고 있다.`,
    author: `로망 롤랑`,
  },
  {
    category: `Success`,
    quote: `영웅적 죽음으로 최후를 장식한 고귀한 일생은, 이 세상에서 가장 강력한 제국의 자존심과 허세와 영광보다도 더 높고 더 오래간다.`,
    author: `제임스 에이브럼 가필드 - 미국 제20대 대통령:1831~1881`,
  },
  {
    category: `Success`,
    quote: `영혼이 깃든 청춘은 그렇게 쉽사리 사라지지 않는다.`,
    author: `카로사`,
  },
  {
    category: `Success`,
    quote: `예술가는 고독한 늑대이다. 동료가 그를 황야에 내쫓는 것은 그를 위해서 좋은 일이다. 자기 만족은 예술가를 멸망시키는 것이다.`,
    author: `윌리엄 서머싯 몸 - 영국 작가 : 1874-1965`,
  },
  {
    category: `Success`,
    quote: `예언은 과오의 가장 근거없는 형태이다.`,
    author: `조지 엘리엇 - George Eliot`,
  },
  { category: `Success`, quote: `예의 가장 기분 좋게 받아들이는 위선의 형식.`, author: `비어스` },
  {
    category: `Success`,
    quote: `옛날부터 죽지 않는 사람은 없고 망하지 않는 나라도 없는데, 죽고 사는 것은 참을 수 있으나 역도를 따르는 일을 해서는 안된다.`,
    author: `김상헌`,
  },
  {
    category: `Success`,
    quote: `옛날, 인간은 노예가 될 위험이 있었다. 그러나, 미래의 위험은 인간이 로봇이 되는 일이다.`,
    author: `에리히 프롬 - 독일 사회학자:1990~1980`,
  },
  {
    category: `Success`,
    quote: `옛 사람들이 함부로 말을 입밖에 내지 않은것은, 자기의 실천이 말을 따르지 못할까 두려워 했기 때문이다.`,
    author: `논어 이인편`,
  },
  {
    category: `Success`,
    quote: `오늘 가장 좋게 웃는 자는 역시 최후에도 웃을 것이다.`,
    author: `니체`,
  },
  {
    category: `Success`,
    quote: `오늘날에 와서는 모든 사람들이 모든 사물의 값을 알고 있지만 가치는 전혀 모르고 있다.`,
    author: `와일드`,
  },
  {
    category: `Success`,
    quote: `오늘 달걀을 한 개 갖는 것보다 내일 암탉을 한 마리 갖는 편이 낫다.`,
    author: `토 머스 플러`,
  },
  {
    category: `Success`,
    quote: `오늘이라는 날은 두번 다시 오지 않는다는 것을 잊지 말라.`,
    author: `알리기에리 단테 - 이탈리아 시인:1265~1321`,
  },
  {
    category: `Success`,
    quote: `오늘 하루를 헛되이 보냈다면 그것은 커다란 손실이다. 하루를 유익하게 보낸 사람은 하루의 보물을 파낸 것이다. 하루를 헛되이 보냄은 내 몸을 헛되이 소모하고 있다는 것을 기억해야 한다.`,
    author: `앙리 프레데리크 아미엘 - 스위스 철학자 : 1821-1881`,
  },
  {
    category: `Success`,
    quote: `오래가는 행복은 정직한 것 속에서만 발견할 수 있다.`,
    author: `리히텐베르히`,
  },
  {
    category: `Success`,
    quote: `오래 살고 싶다면 성급하게 굴지 말고, 침착하고 온화하게 사는 것이 가장 필요하다.`,
    author: `키케로`,
  },
  {
    category: `Success`,
    quote: `오랫동안 사색하고 있는 사람이 언제나 최선의것을 선택한다고는 할 수 없는 것이다.`,
    author: `요한 볼프강 폰 괴테 - 독일 문호 : 1749-1832`,
  },
  {
    category: `Success`,
    quote: `오직 남들을 위하여 산 인생만이 가치 있는 것이다.`,
    author: `아인슈타인`,
  },
  {
    category: `Success`,
    quote: `오직 바보나 죽은 자만이 절대로 자기의 의견을 변화시키지 않는다.`,
    author: `제임스 럿셀 로우웰`,
  },
  {
    category: `Success`,
    quote: `오직 한가지 우리가 두려워해야 할 일은 두려움 그 자체다.`,
    author: `시어도어 루스벨트 - Theodore Roosevelt`,
  },
  {
    category: `Success`,
    quote: `온전한 잘못도 없고, 진실도 없다. 어떠한 잘못 속에도 아직 진실의 껍질은 있다. 어떠한 진실속에서도 무릇 그릇된 씨앗은 있는 것이다.`,
    author: `하인리히 리케트트 - 독일 철학자 : 1863 ~ 1936`,
  },
  {
    category: `Success`,
    quote: `옹졸한 사나이는 벼슬을 얻지 못하였을 때에는 얻으려고 걱정하고, 벼슬을 한번 얻었을 때에는 그것을 잃을까 걱정한다. 참으로 벼슬을 잃을까 걱정하는 사람은 그 수단으로 무슨 짓이라도 한다.`,
    author: `이이`,
  },
  {
    category: `Success`,
    quote: `완전한 자유는 필연적으로 퇴폐를 뜻한다.`,
    author: `허버트 리이드`,
  },
  { category: `Success`, quote: `왔노라, 보았노라, 이겼노라.`, author: `율리어스 카이사르` },
  {
    category: `Success`,
    quote: `왕은 배이고 민중은 물이다. 물은 큰 배를 띄우기도 하고 뒤엎기도 한다.`,
    author: `荀子 - 순자`,
  },
  {
    category: `Success`,
    quote: `왕이건 농부이건 자신의 가정에 평화를 찾아낼 수 있는 자가 가장 행복한 인간이다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `외모는 사람의 껍질을 수단은 편견이 없는 것 즉, 마음이 모든 사상을 위한 신작로가 되게 하는 것이다.`,
    author: `올리버 웬들 홈스 - Oliver Wendell Holmes`,
  },
  { category: `Success`, quote: `요람을 흔드는 손이 세계를 통치하는 손이다.`, author: `월리스` },
  {
    category: `Success`,
    quote: `욕망의 짐을 지겨웁게 지고 있는 자는 조그만 기쁨을 살 때는 괴로움과 손 해를 본다.`,
    author: `세바스찬 브란트`,
  },
  {
    category: `Success`,
    quote: `용기가 없는 사람에게는 어떤 좋은 것도 생기지 않는다.`,
    author: `마르쿠스 아우렐리우스`,
  },
  {
    category: `Success`,
    quote: `용기는 대단히 중요하다, 근육과 같이 사용함으오써 강해진다.`,
    author: `고든`,
  },
  { category: `Success`, quote: `용맹이 여자를 꺾듯, 겸손도 여자를 사로잡는다.`, author: ` ` },
  {
    category: `Success`,
    quote: `우리가 세운 목적이 그른 것이라면 언제든지 실패할 것이요, 우리가 세운 목적이 옳은 것이면 언제든지 성공할 것이다.`,
    author: `안창호`,
  },
  {
    category: `Success`,
    quote: `우리가 우리의 행위를 결정하는 것처럼 우리의 행위는 우리가 결정한다.`,
    author: `엘리어트`,
  },
  {
    category: `Success`,
    quote: `우리가 할 일은 민족의 역량을 기르는 일이지 남과 연결하여 남의 힘을 불러들이는 일이 아니다. 나는 씨앗이 땅 속에 들어가 무거운 흙을 들치고 올라올 때 제 힘으로 들치지 남의 힘으로 올라오는 것 을 본 일이 없다.`,
    author: `1922 년 봄 남강 이승훈`,
  },
  {
    category: `Success`,
    quote: `우리가 행복을 살 수 있을만큼 富부하지 못할 때에는, 행복의 쇼윈도에 너무 가까이 접근하여 그것을 응시해서는 안된다.`,
    author: `트리스탕 베르나르 - 프랑스 극작가`,
  },
  {
    category: `Success`,
    quote: `우리는 다른 미래를 택할 수 있다. 그러나 우리는 과거를 묶어둘 수는 없다. 현대사회는 결코 기술의 과잉으로 해서 괴로워 하지 않으며, 그것이 두루 미치는데 괴로워 하고 있다.`,
    author: `앨빈 토플러 - 미국 미래학자:1928~   `,
  },
  {
    category: `Success`,
    quote: `우리는 모든 것을 빼앗겨도 견딜 수 있지만, 자부심만은 빼앗기면 견딜 수 없다.`,
    author: `윌리엄 해즐릿 - 영국 비평가 : 1778-1830`,
  },
  {
    category: `Success`,
    quote: `우리는 성취에서보다 오히려 욕망에서 살고 있다.`,
    author: `조지 무어 - George Moore`,
  },
  {
    category: `Success`,
    quote: `우리는 어떠한 지배자 밑에 있는 것이 아니다. 자기 정신의 지배하에 있다. 자기 힘으로 하라 !`,
    author: `루시우스 아나에우스 세네카 - 로마 철학자:BC4~AD65`,
  },
  {
    category: `Success`,
    quote: `우리는 우리가 가지고 있는 것을 좀처럼 생각지 않고 언제나 없는 것만 생각하는 경향이 있다. 이것이야 말로 이 세상에서 가장 큰 비극을 만들어 내는 것이다.`,
    author: `아르투어 쇼펜하워 - 독일 철학자:1788~1860`,
  },
  {
    category: `Success`,
    quote: `우리는 전투에는 졌지만, 전쟁에는 아직 지지 아니했다.`,
    author: `드골 - de Gaulle`,
  },
  {
    category: `Success`,
    quote: `우리는 지성적으로 되기 위해 많은 대가를 치른다.`,
    author: `에우리피데스`,
  },
  {
    category: `Success`,
    quote: `우리는 청년들을 위해 미래를 건설할 수는 없으나, 미래를 위해 청년들을 건립할 수는 있다.`,
    author: `프랭클린 델러노 루스벨트 - Franklin Delano Roosevelt`,
  },
  { category: `Success`, quote: `우리들은 감탄과 희망과 사랑으로 산다.`, author: `워즈워드` },
  {
    category: `Success`,
    quote: `우리들은 모두 남의 불행에 견딜 수 있을 만큼 충분히 행복하다.`,
    author: `라로슈 푸꼬`,
  },
  {
    category: `Success`,
    quote: `우리들은 성공에서 보다는 실패에서 더 많은 지혜를 배운다. 하지 말아야 할 것을 발견함으로써 해야할 것을 발견하게 된다.`,
    author: `새뮤엘 스마일스 - Saumel Smiles`,
  },
  { category: `Success`, quote: `우리들은 죽음의 영역에 가까이 있다.`, author: `법구경` },
  {
    category: `Success`,
    quote: `우리들이 가장 조금 밖에 알고 있지 않은 것, 이것만큼 굳게 믿어지는 것은 없다.`,
    author: `몽테뉴`,
  },
  {
    category: `Success`,
    quote: `우리 속에 존재하는 모든 것은 동일하다. 삶과 죽음, 깨어있음과 잠, 젊음과 늙음.`,
    author: `헤라클레이토스 - 고대 그리스 철인 : BC 5세기`,
  },
  {
    category: `Success`,
    quote: `우리에게 생명을 주는 그 시간은, 그 생명을 빼앗기 시작한다.`,
    author: `세네카`,
  },
  {
    category: `Success`,
    quote: `우리의 거의 모든 삶이 어리석은 호기심에 낭비되도 있다.`,
    author: `보들레르`,
  },
  {
    category: `Success`,
    quote: `우리의 나태에 대한 벌로서는, 자기 자신의 불성공 이외에 타인의 성공이 있다.`,
    author: `르나르`,
  },
  {
    category: `Success`,
    quote: `우리 의병들은 이름이나 이익을 위해 일어난 것이 아니라 오직 국가와 민족을 위해 싸우는 것이니 왜적을 격파 하는데만 힘쓰고 죽은 적의 머리를 베어 이를 조정에 바치고 논공행상은 논하지 말라.`,
    author: `곽재우가 의병 활동 때 장병들에게 한 말`,
  },
  {
    category: `Success`,
    quote: `우리의 삶은 고통이며 공포다. 따라서 인간은 불행하다고 할 수 있다. 그러나 인간은 인생을 사랑하고 있다. 그것은 고통과 공포를 사랑하고 있기 때문이다.`,
    author: `표도르 미하일로비치 도스토예프스키 - 러시아 작가 : 1821-1881`,
  },
  {
    category: `Success`,
    quote: `우리의 삶이 밝을 때도 어두울 때도, 나는 결코 인생을 욕하지 않겠다.`,
    author: `헤르만 헤세 - 독일 시인:1877~1962`,
  },
  {
    category: `Success`,
    quote: `우리의 운명은 우리가 아직 그것의 본성을 배우기 전부터도 우리에게 영향력을 구사한다. 우리의 오늘의 규칙을 폐기하는 것은 우리의 미래이다.`,
    author: `프리드리히 빌헬름 니체 - Friendricdh Nietzsche`,
  },
  {
    category: `Success`,
    quote: `우리의 육체는 우리의 정원이며, 우리의 의지는 이 정원의 정원사이다.`,
    author: `윌리엄 셰익스피어 - 영국 극작가`,
  },
  {
    category: `Success`,
    quote: `우리의 인내가 우리의 힘보다 더 많은 것을 성취할 것이다.`,
    author: `버크`,
  },
  {
    category: `Success`,
    quote: `우리 일생의 가장 결정적인 행동들은 숙고하지 않은 행동일 경우가 가장 많다.`,
    author: `앙드레 폴 기욤 지드 - Andre Paul Guillaume Gide`,
  },
  {
    category: `Success`,
    quote: `우선 무엇이 되고자 하는가를 자신에게 말하라. 그리고 나서 해야 할 일을 하라.`,
    author: `에픽테토스 - 그리스 철학자: 55 ? ~135 ?`,
  },
  {
    category: `Success`,
    quote: `우선 자연을 따르라. 그리고 나서 자연을 정복하라.`,
    author: `베이컨`,
  },
  {
    category: `Success`,
    quote: `우유부단한 것만이 습관으호 되어 있는 사람보다 더 비참한 사람은 없다.`,
    author: `제임스`,
  },
  {
    category: `Success`,
    quote: `우정과 사랑은 서로 용납되지 않는다. 열렬한 사랑을 경험한 사람은 우정을 소홀히 여기고 우정에 정성을 쏟은 사람은 사랑을 위해서는 아무런 일도 한 것이 없다.`,
    author: `林語堂 - 중국문학가:1895~1976`,
  },
  { category: `Success`, quote: `友情은 기쁨을 두배로 하고 슬픔을 반감시킨다.`, author: `쉴러` },
  {
    category: `Success`,
    quote: `우정은 기쁨을 두 배로 하고 슬픔을 반으로 한다.`,
    author: `영국 소설가 본`,
  },
  { category: `Success`, quote: `우정은 날개 없는 사랑이다.`, author: `영국 시인 바이런` },
  {
    category: `Success`,
    quote: `우정은 사랑과 마찬가지로 잠시동안의 단절로 강화될 수는 있을지 모르나, 오랜 부재에 의해서 파괴된다.`,
    author: `새뮤얼 존슨 - 영국 문인 :1709-1784`,
  },
  {
    category: `Success`,
    quote: `우정은 평등한 사람간의 사리없는 상거래다. 사랑은 폭군과 노예간의 비열한 교섭이다.`,
    author: `골드스미드`,
  },
  {
    category: `Success`,
    quote: `우정은 흔히 애정으로 발전한다. 그러나 애정은 결코 우정으로 내려가지 않는다.`,
    author: `바이런 - 영국 시인:1788~1824`,
  },
  {
    category: `Success`,
    quote: `우정이란 성장이 더딘 식물이다. 그것이 우정이라고 불리울 만한 가치가 있 게 되기에 그것은 몇 번이고 어려운 충격을 받고 또 그것에 견디어 내지 않 으면 안된다.`,
    author: `워싱톤`,
  },
  {
    category: `Success`,
    quote: `우주의 삼라만상이 조물주의 손에서 나왔을 때 모든 것은 선이었으나 인간의 손에 넘어오면 모든 것이 부패해진다.`,
    author: `장 자크 루소 - 프랑스 사상가:1712~1778`,
  },
  {
    category: `Success`,
    quote: `운명은 용기있는 자 앞에 약하고 비겁한 자 앞에는 강하다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `운명의 여신은 한 인간을 존경할 만한 것으로 만들고 싶으면 그에게 덕을 주고, 존경받게 만들고 싶으면 그에게 성공을 준다.`,
    author: `조제프 주베르 - 프랑스 도덕가·문학가 : 1754-1824`,
  },
  {
    category: `Success`,
    quote: `울지 않는 청년은 야만인이요, 웃지 않는 노인은 바보다.`,
    author: `조지 산타야나`,
  },
  {
    category: `Success`,
    quote: `웃으라, 그러면 이 세상도 함께 웃을 것이다. 울어라, 그러면 너 혼자 울게 되리라.`,
    author: `윌콕스`,
  },
  { category: `Success`, quote: `웅변의 목적은 진리가 아니라 설득이다.`, author: `마코레` },
  {
    category: `Success`,
    quote: `원인은 숨겨지지만 결과는 잘 알려진다.`,
    author: `나소 오비디우스 - Publius Ovidius Naso`,
  },
  {
    category: `Success`,
    quote: `원래 기술이란 과잉된 것의 생산이다. 인간은 원래 기술에 의해서 과잉을 만 들어내는 존재다.`,
    author: `올테가이 가셋트`,
  },
  {
    category: `Success`,
    quote: `원한을 품지 말라. 대단한 것이 아니라면 정정당당하게 자기가 먼저 사과하라. 미소를 띠고 악수를 청하면서 일체를 흘려 버리고자 하는 사람이 큰 인물이다.`,
    author: `카네기`,
  },
  {
    category: `Success`,
    quote: `위기의 시기에는 가장 대담한 방법이 때로는 가장 안전하다.`,
    author: `키신저`,
  },
  {
    category: `Success`,
    quote: `위대한 것을 멸시하고,과도함 보다는 중용을 택하는 것이 군자듸 특징이다.`,
    author: `세네카`,
  },
  {
    category: `Success`,
    quote: `위대한 것 치고 정열이 없이 이루어진 것은 없다.`,
    author: `에머슨`,
  },
  { category: `Success`, quote: `위대한 사람은 모두가 겸손하다.`, author: `레싱` },
  {
    category: `Success`,
    quote: `위대한 사람은 목적을, 소인들은 공상을 가지고 있다.`,
    author: `와싱턴 어빙`,
  },
  {
    category: `Success`,
    quote: `위대한 사람은 절대로 기회가 부족하다고 불평하지 않는다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `위대한 사상은 반드시 커다란 고통이라는 밭을 갈아서 이루어진다. 갈지 않고 그냥 둔 밭에서는 잡초만이 무성할 뿐이다. 사람도 고통을 겪지 않고서는 언제까지나 평범하고 천박함을 벗어나지 못한다. 모든 고통은 차라리 인생 의 벗이다.`,
    author: `카를 힐티 - 스위스 철학자:1833~1909`,
  },
  {
    category: `Success`,
    quote: `위대한 사회란 사람들이 자기들 소유물의 양보다 자기들 목표의 질에 더 관심을 갖는 곳이다.`,
    author: `린든 베인스 존슨 - 미국 정치가`,
  },
  {
    category: `Success`,
    quote: `위대한 정신의 소유자에게는 목표가 있으며 凡人범인들에게는 소망이 있다.`,
    author: `워싱턴 어빙 - Washington lrving`,
  },
  {
    category: `Success`,
    quote: `위대한 지도자는 비전과 일상의 간격을 메워 주는 교육자여야 한다. 그러나 자기가 선택한 길을 사회가 따라 오게 하기 위해 혼자서 그 길을 걸어가야만 하는 사람이다.`,
    author: `헨리 앨프리드 키신저 - Henry Alfred Kissinger : 미국 前국무장관`,
  },
  { category: `Success`, quote: `위대한 포부가 위대한 사람을 만든다.`, author: `풀러` },
  { category: `Success`, quote: `위인이란 소리를 듣는 것은 오해를 받는 일이다.`, author: `에머슨` },
  {
    category: `Success`,
    quote: `위험에 대한 공포는 위험 그 자체보다 천 배나 무겁다.`,
    author: `디포`,
  },
  {
    category: `Success`,
    quote: `위험을 느끼는 항구에는 일절 정박을 하지 않는 것처럼, 안전 제일주의로 친구를 택하는 사람은 친구로 삼지 말라.`,
    author: `마르쿠스 아우렐리우스 - 로마의 황제:121~180`,
  },
  {
    category: `Success`,
    quote: `유감없이 보낸 하루는 즐거운 잠을 가져온다. 잘 보낸 일생은 편안한 죽음을 가져온다.`,
    author: `다빈치`,
  },
  { category: `Success`, quote: `유능한 사람은 언제나 배우는 사람인 것이다.`, author: `괴테` },
  { category: `Success`, quote: `유리와 처녀는 항상 위험하다.`, author: `토르리지아노` },
  { category: `Success`, quote: `육체의 노예가 된 자가 어찌 자유를 찾겠는가.`, author: `세네카` },
  {
    category: `Success`,
    quote: `육체의 활동은 정신적 고뇌를 해방시킨다. 또 가난한 사람을 행복하게 만들어 준다.`,
    author: `프랑수아 드 라 로슈푸코 - 프랑스 사상가`,
  },
  {
    category: `Success`,
    quote: `은혜를 입은 자는 잊지 말아야 하고 베푼자는 기억하지 말아야 한다.`,
    author: `피체 찰론`,
  },
  {
    category: `Success`,
    quote: `음악은 인간의 마음 속에 존재하는 위대한 가능성을 인간에게 보이는 것이라고 한다.`,
    author: `랠프 월도 에머슨 - 미국시인:1803~1882`,
  },
  { category: `Success`, quote: `의무의 길은 영광의 길이었다.`, author: `테니슨` },
  {
    category: `Success`,
    quote: `의복에만 마음이 쏠리는 것은 마음과 인격이 잠든 탓이다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `의심스러운 사람은 쓰지 말고, 사람을 썼거든 의심하지 말라.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `의심할 여지가 없는 순수한 희열의 하나는 근로 뒤의 휴식이다.`,
    author: `칸트 - 독일 철학자:1724~1804`,
  },
  {
    category: `Success`,
    quote: `의인의 수고는 생명에 이르고 악인의 소득은 죄에 이른다.`,
    author: `성경 잠언`,
  },
  {
    category: `Success`,
    quote: `의지가 굳은 사람은 행복할지니, 너희는 고통을 겪겠지만 그 고통은 오래가지 않을 것이다.`,
    author: `테니슨`,
  },
  {
    category: `Success`,
    quote: `의학의 괄목할만한 성공에도 불구하고 현대 의학이라는 거대한 건물은 그 유명한 피사의 사탑처럼 약간 균형이 기울어져 있다. 우리가 얼마나 물에 의존하고 있고 의사들이 얼마나 쉽게 우리병에 대해 마치 만병통치약처럼 약을 처방하는지 끔찍스럽기만 하다.`,
    author: `찰스 - 영국 왕세자:1948~   `,
  },
  {
    category: `Success`,
    quote: `이것은 인간의 한 작은 일보지만, 인류를 위해서는 거대한 도약의 일보이다.`,
    author: `암스트롱 - N. Armdtrong`,
  },
  {
    category: `Success`,
    quote: `이것은 한 번은 통과해야 하는 길. 한시간이라도 더 버티면 그만큼 빨리 목적지에 도착한다. 그만큼 빨리 자유롭게 된다.`,
    author: `필립 체스터 필드`,
  },
  {
    category: `Success`,
    quote: `이것이 끝이 아니다. 끝의 시작도 아니다. 아마 시작의 끝일 것이다.`,
    author: `윈스턴 처칠 - Sir Winston Leonard Spencer Churchill`,
  },
  {
    category: `Success`,
    quote: `이기는 것이 중요한 것이 아니다, 어떻게 노력하는가가 문제이다.`,
    author: `쿠베르탕`,
  },
  {
    category: `Success`,
    quote: `이놈, 눈에 보이지 않는 술의 정이여! 너에게 아직 이름이 없다면 앞으로 너 를 악마라고 부를테다.`,
    author: `세익스피어`,
  },
  {
    category: `Success`,
    quote: `이 대지에서는 나의 기쁨이 샘솟고 있다. 태양은 나의 모든 고통을 씻을 듯 이 그 자비로운 빛과 함께 따스하게 감싸준다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `이런 일은 도저히 불가능하다고 자신이 믿고 시작하는 것은 그것을 제 자신 이 불가능하게 만드는 수단이다.`,
    author: `워너 메이커`,
  },
  {
    category: `Success`,
    quote: `이 무한한 공간의 영원한 침묵은 나를 두렵게 한다.`,
    author: `파스칼 - Pascal`,
  },
  {
    category: `Success`,
    quote: `이미 얻은 명예는 앞으로 얻지 않으면 안될 명예의 담보다.`,
    author: `프랑수아 드 라 로슈푸코`,
  },
  {
    category: `Success`,
    quote: `이별의 뼈아픔을 맛봄으로써만 사랑의 심연을 들여다본다.`,
    author: `조지 엘리엇 - 영국의 여류소설가`,
  },
  {
    category: `Success`,
    quote: `이세상 어느것 하나도 나와 관계없는 것은 없다. 인륜, 도덕의 문제도 나의 일이며, 진리와 자유와 인도와 정의의 문제를 추궁함도 나의 일이다. 순전히 제 한몸 제 일만 생각하는 에고이스트는 부끄러워하라.`,
    author: `아우렐리우스 아우구스티누스 - 로마 철학자`,
  },
  {
    category: `Success`,
    quote: `이 세상은 한 권의 아름다운 책이다. 그러나 그것을 읽으려고 하지 않는 사 람에게는 아무런 쓸모도 없게 된다.`,
    author: `골드니아`,
  },
  {
    category: `Success`,
    quote: `이 시대에는 진리는 막연하고 허위는 확실시되어 있으므로 사람은 진리를 사랑하지 아니하고는 진리를 알 수 없다.`,
    author: `블레즈 파스칼 - 프랑스 수학자`,
  },
  {
    category: `Success`,
    quote: `이십대의 사랑은 환상이다. 30대의 사랑은 외도이다. 사람은 40세에 와서야 처음으로 참된 사랑을 알게 된다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `이유없는 질책은 재치 있는 칭찬의 한 형식이다.`,
    author: `에센바흐`,
  },
  {
    category: `Success`,
    quote: `이익에 있어서 투철한 사람은 흉년도 그를 죽이지 못하며, 덕에 있어서 투철한 사람은 사악한 세상도 그를 혼란시키지 못한다.`,
    author: `맹 자 - 중국 유학자`,
  },
  { category: `Success`, quote: `이익으로 분열되고 범죄로 뭉쳐진다.`, author: `볼테르` },
  {
    category: `Success`,
    quote: `이해가 부족한 사람이 오해가 많은 사람보다 낫다.`,
    author: `아나톨 프랑스`,
  },
  { category: `Success`, quote: `이해 관계를 떠나야 참된 사랑을 가질 수 있다.`, author: `쉴러` },
  {
    category: `Success`,
    quote: `이해성이 있는 사람은 자신을 세상에 적응시킨다. 완고한 사람은 자신에게 세상을 적응시키려고 버틴다. 그러므로 모든 발전은 완고한 자들의 덕택이다.`,
    author: `버너드 쇼`,
  },
  {
    category: `Success`,
    quote: `이해하고 있지 않은 것은 소유하고 있는 것이 아니다.`,
    author: `요한 볼프강 폰 괴테`,
  },
  { category: `Success`, quote: `인간성 이외에는 본질적으로 진실한 것은 없다.`, author: `콩트` },
  {
    category: `Success`,
    quote: `인간은 교육을 통하지 않고는 인간이 될 수 없는 유일한 존재다.`,
    author: `칸트`,
  },
  {
    category: `Success`,
    quote: `인간은 그가 말하는 것에 의해서보다는 침묵하는 것에 의해서 더욱 인간답다.`,
    author: `알베르트 카뮈 - 프랑스 철학자:1913~1960`,
  },
  {
    category: `Success`,
    quote: `인간은 나이 먹어감에 따라 새로운 친구들을 사귀지 않으면 그는 곧 외로움을 느끼게 된다. 인간은 꾸준히 우정을 수선해 나가지 않으면 안된다.`,
    author: `새뮤얼 존슨 - 영국의 문인:1709~1784`,
  },
  { category: `Success`, quote: `인간은 도구를 만드는 동물.`, author: `프랭클린 - B. Frankin` },
  { category: `Success`, quote: `인간은 만물의 척도.`, author: `프로타고라스 - Protagoras` },
  {
    category: `Success`,
    quote: `인간은 모방적인 동물이다. 이 특질은 인간의 모든 교육의 근원이다. 요람에서 무덤까지 인간은 남이 하는 것을 보고 그대로 하기를 배운다.`,
    author: `토머스 제퍼슨 - 미국 3대 대통령 : 1743~1826`,
  },
  {
    category: `Success`,
    quote: `인간은 바르지 못하나 신은 공정하며 최후엔 반드시 정의가 승리한다.`,
    author: `헨리 워즈워스 롱펠로 - 미국 시인:1807~1882`,
  },
  {
    category: `Success`,
    quote: `인간은 사회에서 여러 가지를 배울 수 있다. 그러나 영감을 받는 것은 오직 고독에 있어서만 가능하다.`,
    author: `괴테`,
  },
  { category: `Success`, quote: `인간은 사회적 동물이다.`, author: `아리스토텔레스` },
  {
    category: `Success`,
    quote: `인간은 상호관계로 묶어지는 매듭이요, 거미줄이며, 그물이다. 이 인간관계만이 유일한 문제이다.`,
    author: `앙투안 드 생텍쥐페리 - Antoine [Marie-Roger] de Saint Exupery`,
  },
  { category: `Success`, quote: `인간은 생각하는 갈대이다.`, author: `파스칼` },
  {
    category: `Success`,
    quote: `인간은 생각하는 것이 적으면 적을수록 더욱 말이 많다.`,
    author: `미셸 에켐 드 몽테뉴 - 프랑스 사상가 : 1533-1592`,
  },
  {
    category: `Success`,
    quote: `인간은 선이기 때문에 욕구하는 것이 아니라 욕구하기 때문에 선이다.`,
    author: `스피노자`,
  },
  { category: `Success`, quote: `인간은 선천적으로 사회적인 동물이다.`, author: `아리스토텔레스` },
  {
    category: `Success`,
    quote: `인간은 어떤 기도를 할 때든지 기적이 일어나기를 빈다. 기도는 모름지기 다음과 같은 것으로 요약된다. 위대한 하나님이시여, 둘에 둘을 보태면 넷이 안된다는 것을 들어주십시오.`,
    author: `투르게네프`,
  },
  {
    category: `Success`,
    quote: `인간은 오직 사랑 속에서만, 사랑의 환상의 그늘에 숨어서만 창조되는 것이다.`,
    author: `프리드리히 빌헬름 니체 - 독일 철학자 : 1844-1900`,
  },
  {
    category: `Success`,
    quote: `인간은 의연하게 현실의 운명을 받아 들여야 한다. 거기에 모든 진리가 숨겨져 있다.`,
    author: `빈센트 반 고흐 - 네덜란드 화가`,
  },
  { category: `Success`, quote: `인간은 이성적 동물이다.`, author: `세네카` },
  {
    category: `Success`,
    quote: `인간은 자기 자신에 대해서 너무도 무지하므로 건강할 때도 죽지나 않을까 하고 생각하며, 죽음을 맞이하면서도 건강하다고 생각한다. 열이 나고 곪으려고 하여도 느끼지 못한다.`,
    author: `블레즈 파스칼 - 프랑스 수학자,사상가:1623~1662`,
  },
  {
    category: `Success`,
    quote: `인간은 자신에 관해서는 좀처럼 모르고 있는 터이므로 많은 사람들은 건강한 데도 죽어가는 듯이 생각하고 또한 대다수의 사람들은 죽어가고 있는데도 건강하다고 생각한다.`,
    author: `파스칼`,
  },
  { category: `Success`, quote: `인간은 죽을 때까지 완전한 인간이 못된다.`, author: `플랭클린` },
  {
    category: `Success`,
    quote: `인간은 죽음을 두려워한다. 그것은 생을 사랑하기 때문이다.`,
    author: `도스토예프스키`,
  },
  {
    category: `Success`,
    quote: `인간은 진리에 대해서는 얼음같이 차지만, 허위에 대해서는 불과 같이 뜨거 워진다.`,
    author: `라 퐁떼에느`,
  },
  { category: `Success`, quote: `인간은 천에 따라서 자기 옷을 지어야 한다.`, author: `내쉬` },
  {
    category: `Success`,
    quote: `인간은 태어나면서부터 허영심이 강하고 타인의 성공을 질투하기 쉬우며 자신의 이익 추구에 대해서는 무한정한 탐욕을 지닌 자다.`,
    author: `니콜로 마키아벨리 - 이탈리아 정치사상가 : 1469-1527`,
  },
  {
    category: `Success`,
    quote: `인간은 패배하였을 때 끝나는 것이 아니다. 포기 했을 때 끝나는 것이다.`,
    author: `닉슨`,
  },
  {
    category: `Success`,
    quote: `인간은 항상 시간이 모자란다고 불평을 하면서 마치 시간이 무한정 있는 것처럼 행동한다.`,
    author: `세네카`,
  },
  {
    category: `Success`,
    quote: `인간은 환경을 창조하고 환경은 인간을 창조한다.`,
    author: `밝은사회`,
  },
  {
    category: `Success`,
    quote: `인격은 당신의 아이들에게 남겨줄 수 있는 최대의 유산이다.`,
    author: `아놀드 그라소우`,
  },
  { category: `Success`, quote: `인간은 신의 걸작품이다.`, author: `퀼즈` },
  {
    category: `Success`,
    quote: `인간은 아직까지도 모든 컴퓨터중에서 가장 후륭한 컴퓨터이다.`,
    author: `케네비`,
  },
  {
    category: `Success`,
    quote: `인간을 자유롭게 할 수 있는 것은 오직 이성 뿐이다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아 작가`,
  },
  {
    category: `Success`,
    quote: `인간을 자유롭고 고상하게 살지 못하게 하는 것은 다른 무엇보다도, 소유에 대한 몰두이다.`,
    author: `버트런드 아서 윌리엄 러셀 - 영국의 철학자`,
  },
  {
    category: `Success`,
    quote: `인간의 가장 행복한 시간은 일에 몰두하고 있을 때이다.`,
    author: ` `,
  },
  { category: `Success`, quote: `인간의 고독감은 삶의 공포일 뿐이다.`, author: `오닐` },
  {
    category: `Success`,
    quote: `인간의 공동사회란 인간 개개인과 마찬가지로 건강한 시기가 있는가 하면 병약한 시기가 있다. 심지어는 젊음과 노쇠, 희망과 절망의 시기가 있다.`,
    author: `존 어니스트 스타인벡 - John Ernst Steinbeck`,
  },
  {
    category: `Success`,
    quote: `인간의 눈은 그의 현재를 말하며 입은 그가 앞으로 될 것을 말한다.`,
    author: `골즈워디`,
  },
  {
    category: `Success`,
    quote: `인간의 덕은 그 비상한 노력으로서가 아니라 그 일상적인 행동에 의해서 측 정되어야 할 것이다.`,
    author: `파스칼`,
  },
  {
    category: `Success`,
    quote: `인간의 마음은 출생할 때에는 백지와 같다.`,
    author: `로크 - J. Locke`,
  },
  {
    category: `Success`,
    quote: `인간의 인격은 항시 스스로 나타난다. 가장 순식간의 행위와 말, 일신상의 의도가 인격을 나타낸다.`,
    author: `랠프 월도 에머슨 - Ralph Waldo Emerson`,
  },
  {
    category: `Success`,
    quote: `인간의 진정한 재산은 그가 이 세상에서 행하눈 선행인 것이다.`,
    author: `마호메드`,
  },
  {
    category: `Success`,
    quote: `인간의 행복은 거의 건강에 의하여 좌우되는 것이 보통이며 건강하기만 하다면 모든 일은 즐거움과 기쁨의 원천이 된다. 반대로 건강하지 못하면 이러한 외면적 행복도 즐거움이 되지 않을 뿐 아니라 뛰어난 지, 정, 의조차도 현저하게 감소된다.`,
    author: `아르투어 쇼펜하워 - 독일 철학자 : 1788-1860`,
  },
  {
    category: `Success`,
    quote: `인간의 행복의 원리는 간단하다. 불만에 자기가 속지 않으면 된다. 어떤 불만으로 해서 자기를 학대하지 않으면 인생은 즐거운 것이다.`,
    author: `러셀`,
  },
  {
    category: `Success`,
    quote: `인간의 힘이란 일반적으로 명확하게 이익이 될 수 있는 미래를 얻기 위한 현재의 수단이다.`,
    author: `T 호프스`,
  },
  {
    category: `Success`,
    quote: `인간이란 것은 자기 자유의지로 스스로 자신에게 자초한 상처나 그밖의 병은 타인의 손으로 가해진 것만큼 고통을 느끼지 않는다.`,
    author: `니콜로 마키아벨리 - 이탈리아 정치사상가:1469~1527`,
  },
  {
    category: `Success`,
    quote: `인간이란 미소와 눈물 사이를 왕래하는 시계추와 같은 것이다.`,
    author: `바이어런`,
  },
  {
    category: `Success`,
    quote: `인간이란 생각하는 것이 적을 수록 많이 지껄여댄다.`,
    author: `몽테스키외`,
  },
  {
    category: `Success`,
    quote: `인간이란 이렇게도 되었다가 저렇게도 되고 마음대로 살아가는 것이기 때문에 오늘의 착한 사람이 내일이면 악당이 될 수 있다.`,
    author: `고리키 - 러시아 소설가 : 1868-1936`,
  },
  {
    category: `Success`,
    quote: `인간이 현명해지는 것은, 경험에 의한 것이 아니고, 경험에 대처하는 능력에 따르는 것이다.`,
    author: `쇼`,
  },
  {
    category: `Success`,
    quote: `인간이 호랑이를 죽일 때는 그것을 스포츠라고 한다. 호랑이가 인간을 죽일 때는 사람들은 그것을 재난이라고 한다. 범죄와 정의와의 차이도 이것과 비슷한 것이다.`,
    author: `버너드 쇼`,
  },
  {
    category: `Success`,
    quote: `인간이 호랑이를 죽이려고 하는 경우에는 그것을 자신의 위안으로 생각하지만 그 호랑이가 인간을 죽이려고 하면 사람들은 그것을 모질다고 한다. 죄악과 정의도 거의 이런 것이다.`,
    author: `조지 버나드쇼 - 영국 작가:1850~1950`,
  },
  {
    category: `Success`,
    quote: `인간 일반을 안다는 일은 한 사람 한 사람의 인간을 아는 것보다는 쉽다.`,
    author: `라 로슈푸꼬`,
  },
  {
    category: `Success`,
    quote: `인격은 공상으로 형성되는 것이 아니다. 망치를 들고 틀에 넣어서 다져 만들어지는 것이다.`,
    author: `웨링턴`,
  },
  { category: `Success`, quote: `인내는 성공의 반이다.`, author: ` ` },
  { category: `Success`, quote: `인내는 쓰다. 그러나 그 열매는 달다.`, author: `루소` },
  { category: `Success`, quote: `인내는 어떠한 괴로움에도 듣는 명약이다.`, author: `플라토우스` },
  {
    category: `Success`,
    quote: `인내는 힘이 낳은 딸, 고집은 약함이-다시 말하면 약한 이성이 낳아 놓은 딸 이다.`,
    author: `에센바흐`,
  },
  {
    category: `Success`,
    quote: `인내란, 무거운 짐을 지고 불평 없이 달리고 있는 나귀의 덕이다.`,
    author: `죠지 그 랜빌`,
  },
  {
    category: `Success`,
    quote: `인내를 지닐 수 있는 사람은 그가 바라는 것은 무엇이든 손에 넣을 수가 있 다.`,
    author: `프랭클린`,
  },
  {
    category: `Success`,
    quote: `인내와 시간과 돈이 있으면 안되는 일이 없다. 인내와 온화는 힘이다.`,
    author: `레이 헌트`,
  },
  {
    category: `Success`,
    quote: `인내하라, 경험하라, 조심하라. 그리고 희망을 가져라.`,
    author: `조셉 에디슨`,
  },
  {
    category: `Success`,
    quote: `인류를 위해 사는 것은 자기의 이름을 위해 사는 것보다 훌륭한 것이다.`,
    author: `바첼 린드세이`,
  },
  {
    category: `Success`,
    quote: `인류의 목적은 휴식이 아니다. 그것은 지적이며 도덕적인 완성이다.`,
    author: `르낭`,
  },
  {
    category: `Success`,
    quote: `인민의, 인민에 의한 인민을 위한 정부.`,
    author: `파커 - T. Parker`,
  },
  {
    category: `Success`,
    quote: `인생과 문학을 생각하면 할수록 점점 더 나는 통감한다. 모든 훌륭한 것들의 배후에는 개인이 서있으며 인간을 만드는 것은 시대가 아니고 시대를 창조하는 것이 인간이라는 것을.`,
    author: `오스카 핑걸 오플레어티 와일드 - 영국 작가:1854~1900`,
  },
  {
    category: `Success`,
    quote: `인생에게 종말이 없었다면 누가 자기 운명에 절망할 것인가. 죽음은 비운을 더없이 괴로운 것으로 만든다.`,
    author: `보브나르그 - 프랑스 모럴리스트 : 1715-1747`,
  },
  {
    category: `Success`,
    quote: `인생에서 가장 쓸데없는 것이 탄식이다. 무엇을 얻을까 눈을 두리번거리기 전에 먼저 탄식을 버려라.`,
    author: `루시우스 아나에우스 세네카 - 로마의 철학자`,
  },
  {
    category: `Success`,
    quote: `인생에서 중요한 법칙은 만사에 중용을 지키는 일이다.`,
    author: `테렌티우스`,
  },
  {
    category: `Success`,
    quote: `인생에 있어서 가장 중요한 것은 실패했다고 해서 낙심하지 않는 일이며, 성공했다고 해서 기쁨에 도취되지 않는 것이다.`,
    author: `표도르 미하일로비치 도스토예프스키 - 러시아 작가:1821~1881`,
  },
  {
    category: `Success`,
    quote: `인생에 있어서 많은 고통을 면하는 최상의 방법은 자기의 이익을 아주 적게 생각하는 일이다.`,
    author: `쥬베르`,
  },
  {
    category: `Success`,
    quote: `인생에 있어서 우리에게 일어난 일을 어떻게 받아들이느냐 하는 것은 현재 일어난일 못지않게 우리들의 행불행과 중요한 관련이 있다.`,
    author: `카를 빌헬름 폰 훔볼트 - 독일 언어학자,정치가:1767~1835`,
  },
  {
    category: `Success`,
    quote: `인생에 있어서 일어난 일을 어떻게 받아들이느냐 하는 것은 일어난 일 못지 않게 우리들의 행.불행과 중요한 관련이 있다.`,
    author: `카를 빌헬름 폰 훔볼트 - Karl Wilhelm, Freiherr von Humboldt`,
  },
  {
    category: `Success`,
    quote: `인생에 있어서 최고의 행복은 우리가 사랑받고 있다는 확신이다. `,
    author: ` V. 위고 - 레 미제라블 `,
  },
  {
    category: `Success`,
    quote: `인생은 그것을 느끼는 사람에게는 비극적인 것이고, 인생을 생각하는 사람에게는 희극인 것이다.`,
    author: `라 브뤼예르 - 프랑스 모럴리스트:1645~1695`,
  },
  {
    category: `Success`,
    quote: `인생은 뒤를 향해야만 이해될 수 있다. 그러나 그것은 앞을 향해서 살아 져야 한다.`,
    author: `쇠렌 오뷔 키에르케고르 - Soren Abye Kierkegaard`,
  },
  { category: `Success`, quote: `인생은 불확실한 항해이다.`, author: `셰익스피어` },
  {
    category: `Success`,
    quote: `인생은 비극이라고 생각할때 우리는 비로소 살기 시작하는 것이다.`,
    author: `윌리엄 버틀러 예이츠 - 아일랜드 시인,극작가:1865~1939`,
  },
  {
    category: `Success`,
    quote: `인생은 살 가치가 있다는 것, 그것이 모든 예술의 궁극적 내용이고 위안이다.`,
    author: `헤르만 헤세 - 독일 시인:1877~1962`,
  },
  {
    category: `Success`,
    quote: `인생은 연극과 같다. 훌륭한 배우가 걸인도 되고, 삼류배우가 대감이 될 수도 있다. 어쨌든 지나치게 인생을 거북하게 생각하지 말고 솔직하게 어떤 일이든지 열심히 하라.`,
    author: `후쿠자와 유키치`,
  },
  {
    category: `Success`,
    quote: `인생은 왕복차표를 발행하지 않는다. 일단 떠나면 다시는 돌아오지 못한다.`,
    author: `로맹 롤랑 - 프랑스 작가:1866~1944`,
  },
  { category: `Success`, quote: `인생은 일방통행의 길이다.`, author: `버너스 베렌스` },
  {
    category: `Success`,
    quote: `인생은 표를 사서 궤도 위를 달리는 차에 타는 사람에게는 알 수 없다.`,
    author: `윌리엄 서머싯 몸 - 영국작가 : 1874-1965`,
  },
  {
    category: `Success`,
    quote: `인생은 하나의 미래에 의해서 만들어지고 있다. 마치 육체가 공허에서 만들어지고 있는 것과 같이.`,
    author: `장 폴 사르트르 - 프랑스 작가:1905~1980`,
  },
  {
    category: `Success`,
    quote: `인생은 학교다. 그리고 거기서의 실패는 성공보다도 훌륭한 교사다.`,
    author: `그라 나츠이`,
  },
  {
    category: `Success`,
    quote: `인생은 한 권의 책과 같다. 어리석은 사람은 아무렇게나 책장을 넘기지만 현명한 사람은 공들여 읽는다. 왜냐하면 그들은 단 한번밖에 그것을 읽지 못함을 알고 있기 때문이다.`,
    author: `장 파울 - 독일 소설가 : 1763-1825`,
  },
  {
    category: `Success`,
    quote: `인생은 활동함으로써 값어치가 있으며, 빈곤한 휴식은 죽음을 의미한다.`,
    author: `볼테르`,
  },
  {
    category: `Success`,
    quote: `인생은 흘러가는 것이 아니고 성실로써 이루어져가는 것이라야 한다. 우리는 하루하루를 보내는 것이 아니고 내가 가진 것으로 채워 가는 것이라야 한다.`,
    author: `존 러스킨 - Jon ruski`,
  },
  {
    category: `Success`,
    quote: `인생을 진실하게 그리고 전체로써 보아라.`,
    author: `에피쿠로스 - Epicurose`,
  },
  {
    category: `Success`,
    quote: `인생을 해롭게 하는 비애를 버리고 명랑한 기질을 간직하라.`,
    author: `세익스피어`,
  },
  {
    category: `Success`,
    quote: `인생의 상대는 돈이 아니다. 우리들의 상대는 인간이다.`,
    author: `푸시킨`,
  },
  { category: `Success`, quote: `인생의 어려움은 선택에 있다.`, author: `무어` },
  {
    category: `Success`,
    quote: `인생의 위대한 목표는 지식이 아니라 행동이다.`,
    author: `토머스 헨리 헉슬리 - 영국 자연과학자`,
  },
  {
    category: `Success`,
    quote: `인생의 참된 목적은 영원히 생명을 깨닫는데 있다.`,
    author: `톨스토이`,
  },
  {
    category: `Success`,
    quote: `인생이란 느끼는 자에게는 비극, 생각하는 자에게는 희극이다.`,
    author: `라 브뤼에르`,
  },
  {
    category: `Success`,
    quote: `인생이란 대단히 대단히, 대단히 중요한 것이다. 진지한 표정으로 거론할 수 있는 그런 하찮은 것이 아니다.`,
    author: `와일드`,
  },
  {
    category: `Success`,
    quote: `인위로 천하를 다스리려고 하는 것은 바다가 강을 걸어서 건너려고 하는 것 과 같다.`,
    author: `장자`,
  },
  {
    category: `Success`,
    quote: `일반적이고 추상적인 관념은 인류의 가장 큰 잘못의 근원이다.`,
    author: `장 자크 루소 - 프랑스 사상가`,
  },
  {
    category: `Success`,
    quote: `일생동안 친구는 한 명이면 족하다. 두 명은 많고 세 명은 거의 불가능하다.`,
    author: `애덤스`,
  },
  {
    category: `Success`,
    quote: `일생에 있어서 기회가 적은 것은 아니다. 그것을 볼 줄아는 눈과 붙잡을 수 있는 의지를 가진 사람이 나타나기까지 기회는 잠자고 있는 것이다. 비록 재난이라 할지라도 그것을 휘어잡는 의지있는 사람 앞에서는 도리어 건설적인 귀중한 가능성을 품고 있는 것이다.`,
    author: `로런스 굴드`,
  },
  {
    category: `Success`,
    quote: `일은 나날을 풍요하게 하고, 술은 일요일을 행복하게 한다.`,
    author: `보들레르 - 프랑스 시인:1821~1867`,
  },
  { category: `Success`, quote: `일은 시작할 때가 언제나 가장 좋다.`, author: `파스칼` },
  {
    category: `Success`,
    quote: `일은 인간생활의 피할 수 없는 조건이며,인간 복지의 참된 근원이다.`,
    author: `톨스토이`,
  },
  {
    category: `Success`,
    quote: `일은 인류를 사로잡는 모든 질환과 비참을 치료해 주는 주요한 치료제이다.`,
    author: `카라일`,
  },
  { category: `Success`, quote: `일은 하라, 일에 쫓기지 말라.`, author: `프랭클린` },
  {
    category: `Success`,
    quote: `일을 몰고 가라. 그렇지 않으면 일이 너를 몰고 갈 것이다.`,
    author: `프랭클린`,
  },
  {
    category: `Success`,
    quote: `일을 바르게 처리하는 방법은 한 가지 뿐이지만 일을 바르게 보는데도 한가지 방법뿐이다. 곧 일 전체를 보는 것이다.`,
    author: `존 러스킨 - Jon ruskin`,
  },
  { category: `Success`, quote: `일을 쫓아라. 일에 쫓기지 말라.`, author: `프랭클린` },
  {
    category: `Success`,
    quote: `일의 기량을 닦기 위해서 가장 중요한 것은 실행과 경험이다.`,
    author: `콜루맬라`,
  },
  {
    category: `Success`,
    quote: `일이 뜻대로 되지 않을 때는 나보다 못한 사람을 생각하라. 원망하고 탓하는 마음이 저절로 사라지리라. 마음이 게을러지거든 나보다 나은 사람을 생각하라. 저절로 분발하리라.`,
    author: `홍자성`,
  },
  {
    category: `Success`,
    quote: `일이 재미있으면 인생은 낙원이다. 일이 의무라면 인생은 지옥이다.`,
    author: `고리끼`,
  },
  {
    category: `Success`,
    quote: `입과 혀라는 것은 화와 근심의 문이요, 몸을 죽이는 도끼와 같다.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `자기가 가지고 있는 곳을 모르는 사람은 결코 높이 향상하지 못한다.`,
    author: `크롬웰`,
  },
  {
    category: `Success`,
    quote: `자기가 그만한 힘이 없으면서도 커다란 존재라고 생각하는 사람은 거만하다. 또, 자기의 가치를 실제보다 적게 생각하는 사람은 비굴하다.`,
    author: `아리스토 텔레스`,
  },
  {
    category: `Success`,
    quote: `자기가 소유하고 있는 것을 가장 풍부한 재산으로 여기지 않는 자는 누구나, 비록 이 세상의 주인이라도 불행하다.`,
    author: `에피쿠로스 - 그리스 철학자 : Eqicouros`,
  },
  {
    category: `Success`,
    quote: `자기가 할 수 있는 모든 것을 하는 것은 인간이 되는 것이요, 자기가 하고 싶은 모든 것을 하는 것은 신이 되는 것이다.`,
    author: `나폴레옹`,
  },
  { category: `Success`, quote: `자기가 할 수 있는 일은 남에게 밀지 마라.`, author: `제퍼슨` },
  {
    category: `Success`,
    quote: `자기 반성을 엄중히 하고 다른 사람을 꾸짖는 것을 가볍게 하면 남의 원망이 멀어진다.`,
    author: `공자 - 유교의 시조:BC 551~479`,
  },
  {
    category: `Success`,
    quote: `자기본위는 살기 원하듯 사는 것이 아니라, 타인더러 살기 원하듯 살라고 요구하는 것이다.`,
    author: `오스카 핑걸 오플레어티 윌스 와일드 - Oscar Fingal O'Flahertie Wills wilde`,
  },
  { category: `Success`, quote: `자기 신뢰가 성공의 제1의 비결이다.`, author: `에머슨` },
  { category: `Success`, quote: `자기 신뢰는 위대한 사업의 제일의 필요 조건이다.`, author: `존슨` },
  {
    category: `Success`,
    quote: `자기에게 타인을 결합시키는 유대는 우리의 마음속에만 존재한다.`,
    author: `마르셀 프루스트 - Marcel Proust`,
  },
  {
    category: `Success`,
    quote: `자기와 남의 인격을 수단으로 삼지 말고 항상 목적으로 대우해야 한다.`,
    author: `칸트 - I. Kant`,
  },
  {
    category: `Success`,
    quote: `자기의 명성이 자기의 진실보다 더 빛나지 않는 사람은 복이 있다.`,
    author: `라빈드라나트 타고르 - Rabindranath Tagore`,
  },
  {
    category: `Success`,
    quote: `자기의 잘못을 인정하는 것만큼이나 어려운 것은 없다.`,
    author: `이즈 테일러`,
  },
  {
    category: `Success`,
    quote: `자기의 지성을 강화하는 유일한 수단은 편견이 없는 것 즉, 마음이 모든 사상을 위한 신작로가 되게 하는 것이다.`,
    author: `존 키츠 - John Keats`,
  },
  { category: `Success`, quote: `자기 일을 멸시하는 자는 먹을 양식과 싸운다.`, author: `스퍼전` },
  {
    category: `Success`,
    quote: `자기 일을 찾은 자는 복이 있다. 그가 다른 복을 찾지 않게 하라.`,
    author: `토마스 칼라일 - 영국의 비평가, 역사가`,
  },
  { category: `Success`, quote: `자기 자신을 아는 것은 참된 진보이다.`, author: `안데르센` },
  {
    category: `Success`,
    quote: `자기 자신을 예찬하는 자는 신의 미움을 받는다.`,
    author: `클레멘스`,
  },
  {
    category: `Success`,
    quote: `자기 자신을 위해서 무엇인든 탐내지 말라. 구하지 말고, 마음이 움직이지 말고, 부러워하지 말라. 네 운명과 장래는 항상 미지의 것이어야 한다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아작가:1828~1910`,
  },
  {
    category: `Success`,
    quote: `자기 자신을 이겨낼 수 있는 힘을 가진 사람이 가장 강하다.`,
    author: `루시우스 아나에우스 세네카 - 로마 철학자:BC 4~AD 65`,
  },
  {
    category: `Success`,
    quote: `자기 자신을 자제하는 사람은 그가 즐거움을 찾아낼 수 있는 만큼 쉽게 슬픔을 이겨낼 수 있다.`,
    author: `오스카 핑걸 오플레어티 와일드 - 영국 작가 : 1854-1900`,
  },
  {
    category: `Success`,
    quote: `자기 자신을 현명하다고 생각하는 인간은 그야말로 바보이다.`,
    author: `볼테르`,
  },
  {
    category: `Success`,
    quote: `자녀에게 회초리를 쓰지 않으면 자녀가 아비에게 회초리를 든다.`,
    author: ` `,
  },
  { category: `Success`, quote: `자녀를 정직하게 기르는 것이 교육의 시작이다.`, author: `러스킨` },
  {
    category: `Success`,
    quote: `자만심은 손해를 초래하지만, 겸허함은 이익을 가져다 준다.`,
    author: `서경`,
  },
  {
    category: `Success`,
    quote: `자백을 하지 않으려면 자살밖에 없다. 그러나 자살은 자백인 것이다.`,
    author: `D 웨 브스타`,
  },
  { category: `Success`, quote: `자비·검약·겸허를 몸가짐의 삼보로 하라.`, author: `노자 - 老子` },
  {
    category: `Success`,
    quote: `자비는 가정에서부터, 정의는 이웃에 서부터 시작한다.`,
    author: `찰스 디킨스 - Charles`,
  },
  {
    category: `Success`,
    quote: `자살이란 살인의 최악의 방식이다. 왜냐하면 그것은 후회할 기회가 하나도 없으므로.`,
    author: `J C 크린스`,
  },
  {
    category: `Success`,
    quote: `자살이란 어떤 의미에서는 그리고 마치 멜로 드라마 속에서와 같아 고백하 는 것이다. 그것은 인생에 패배했다는 것을 혹은 인생을 이해하지 못한 것 을 고백하는 것이다.`,
    author: `까뮈`,
  },
  {
    category: `Success`,
    quote: `자신에 대한 신뢰가 타인을 신뢰하는 중요한 요소가 된다.`,
    author: `프랑수아 드 라 로슈푸코 - 프랑스 사상가 : 1613-1680`,
  },
  {
    category: `Success`,
    quote: `자신은 할 수 없다고 생각하고 있는 동안은 사실은 그것을 하기 싫다고 다짐하고 있는 것이다. 그러므로 그것은 실행되지 않는 것이다.`,
    author: `스피노자`,
  },
  { category: `Success`, quote: `자신을 알수 있는 사람이야말로 진정한 현인이다.`, author: `초서` },
  {
    category: `Success`,
    quote: `자신의 나라를 사랑하려거든 역사를 읽을 것이며,다른 사람들에게 나라를 사랑하게 하려거든 역사를 읽게 할 것이다.`,
    author: `단재 신채호`,
  },
  {
    category: `Success`,
    quote: `자신의 영혼에 안주하라. 자신이 스스로의 주인임을 명심하라. 한 남자로서, 인간으로서, 시민으로서, 그리고 궁극적으로는 죽음을 맞게 될 운명을 타고난 사람으로서 인생을 대하라.`,
    author: `마르쿠스 아루렐리우스 - 로마의 황제:121~180`,
  },
  {
    category: `Success`,
    quote: `자신의 주인이 되은 자는 곧 다른 사람들의 주인이 될 것이다.`,
    author: `퓰러`,
  },
  {
    category: `Success`,
    quote: `자신의 칭찬을 부정하는 자는 다시 한번 그 칭찬을 듣기 위해서이다.`,
    author: `라 로시푸코`,
  },
  {
    category: `Success`,
    quote: `자신의 행동이 빗나간 사람일수록 맨 먼저 남을 모략한다.`,
    author: `몰리에르`,
  },
  {
    category: `Success`,
    quote: `자신이 의식하고 있는 겸손은 죽어 있는 것이다.`,
    author: `에센바흐`,
  },
  { category: `Success`, quote: `자신이 자신의 지휘관이다.`, author: `플라우투스` },
  {
    category: `Success`,
    quote: `자신이 현명하다고 생각하고 있는 인간은 정녕 구제할 수 없는 바보이다.`,
    author: `볼테르`,
  },
  {
    category: `Success`,
    quote: `자연-우리들은 자연에 둘러싸이고 안기고 있다-그 속에서 빠져나올 수 없고 더욱 깊이 들어갈 수도 없다.`,
    author: `괴 테`,
  },
  {
    category: `Success`,
    quote: `자연은 결코 우리를 속이지 않는다. 우리를 속이는 것은 언제나 우리 자신이다.`,
    author: `장 자크 루소 - 프랑스 사상가:1712~1778`,
  },
  {
    category: `Success`,
    quote: `자연은 언제나 완전하다. 결코 잘못을 저지르지 않는다. 우리의 입장, 우리의 눈에서 잘못이 있는 것이다.`,
    author: `로댕 - 프랑스 조작가:1840~1917`,
  },
  {
    category: `Success`,
    quote: `자연은 우리에게 두가지 귀중한 선물을 주었다. 언제 어느 때나 바라는 대로 잠들 수 있는 능력과 과식할 수 없는 육체의 조건이다.`,
    author: `보나파르트 나폴레옹 - 프랑스 군인 황제 : 1769-1821`,
  },
  {
    category: `Success`,
    quote: `자연은 인간을 만들었다. 그리고 만들었을 때의 본은 부숴 버렸다.`,
    author: `아리오스트`,
  },
  {
    category: `Success`,
    quote: `자연은 절대로 우리들을 속이지 않는다. 우리들 자신을 속이는 자는 언제나 우리들이다.`,
    author: `루소`,
  },
  {
    category: `Success`,
    quote: `자연은 책략가다. 그러나 그 목적하고 있는 것은 선이다. 그 책략하는 것은 걱정하지 않는 것이 좋다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `자연은 하나님의 작품이요, 예술은 사람의 작품이다.`,
    author: `롱펠로우`,
  },
  {
    category: `Success`,
    quote: `자연은 하느님의 묵시이며 예술은 인간의 묵시이다.`,
    author: `헨리 워즈워스 롱펠로 - 미국 시인:1807~1882`,
  },
  {
    category: `Success`,
    quote: `자연을 지배하고 있는 것은 연속성, 복귀의 연속성이다. 장미꽃은 줄기차게 장미꽃을 피우고, 새는 집을 짓고, 젊은 마 음은 사랑을 하고, 젊은 입술은 옛날부터 몇 만번이고 옛날의 입술에 올랐던 사상과 감정을 노래한다.`,
    author: `아미 엘`,
  },
  {
    category: `Success`,
    quote: `자연의 극치는 사랑이다. 사랑에 의해서만 사람은 자연에 접근할 수 있다.`,
    author: `괴테`,
  },
  {
    category: `Success`,
    quote: `자연의 道도는 말로써 표현할 수 없고 자연의 德덕은 인위적인 노력으로 이룰 수 없다.`,
    author: `장자 - 莊子`,
  },
  {
    category: `Success`,
    quote: `자연이 예술을 아쉬워하는 일은 결코 없다. 예술은 자연의 모습의 복사물이기 때문이다.`,
    author: `마르쿠스 아우렐리우스 - 로마황제:121~180`,
  },
  {
    category: `Success`,
    quote: `자유는 법률의 보호를 받아 처음으로 성립한다. 이 세상에 법 외에 자유가 있을 수 없다.`,
    author: `아우렐리우스 아우구스티누스 - 로마철학자:354~430`,
  },
  { category: `Success`, quote: `자유는 새로운 종교이며 우리들 시대의 종교다.`, author: `하이네` },
  {
    category: `Success`,
    quote: `자유는 시간의 문제이다. 그러나 때로는 기회의 문제이기도 하다.`,
    author: `히포크라테스`,
  },
  {
    category: `Success`,
    quote: `자유는 책임을 뜻한다. 이 때문에 대부분의 사람들이 자유를 두려워 한다.`,
    author: `쇼`,
  },
  { category: `Success`, quote: `자유는 획득하는 것보다 간직하는 것이 더 어렵다.`, author: `컬훈` },
  {
    category: `Success`,
    quote: `자유란 모든 특권을 유효하게 발휘시키는 특권이다.`,
    author: `칸트`,
  },
  {
    category: `Success`,
    quote: `자유를 위해서라면 명예와 마찬가지로 생명을 걸 수도 있으며 또 걸어야 한다.`,
    author: `미겔 데 사아베드라 세르반테스 - 스페인 소설가:1547~1616`,
  },
  { category: `Success`, quote: `자유야말로 고도한 교양이 싹터 나가는 흙이다.`, author: `피프테` },
  {
    category: `Success`,
    quote: `자유와 속박은 한가지이면서 다른 것이 되어야하는 똑같은 필요성의 양면이다.`,
    author: `앙투안 드 생텍쥐페리 - Antoine Marie Roger de Saint Exupery`,
  },
  {
    category: `Success`,
    quote: `자유 , 인간은 태어났을 때는 자유다. 그러나 그 후 도처에서 쇠사슬로 묶여진다.`,
    author: `루소`,
  },
  {
    category: `Success`,
    quote: `자유 정신은 경쟁을 싫어한다. 자유 정신은 자기의 적의 편을 든다.`,
    author: `봐레 리`,
  },
  {
    category: `Success`,
    quote: `작은 구멍이 배를 침몰시키고 죄 한가지가 사람을 파멸시킨다.`,
    author: `번연`,
  },
  {
    category: `Success`,
    quote: `작은 구멍 하나가 큰 배를 침몰시키는 것이다.`,
    author: `에프라임 도마라츠키`,
  },
  {
    category: `Success`,
    quote: `작은 도끼라도 찍고 찍으면 큰 참나무는 넘어진다.`,
    author: `세익스피어`,
  },
  {
    category: `Success`,
    quote: `작은 성공을 만족스럽게 생각한는 사람은 큰 성공을 얻지 못한다.`,
    author: `제세 메서 게만`,
  },
  {
    category: `Success`,
    quote: `작지만 청결한 것은 큰 것이요, 크지만 불결한 것은 작은 것이다.`,
    author: `바이`,
  },
  {
    category: `Success`,
    quote: `잔잔한 바다에서는 좋은 뱃사공이 만들어지지 않는다.`,
    author: `영국 속담`,
  },
  {
    category: `Success`,
    quote: `잔혹은 고대의 악덕이고 허영은 근대의 악덕이다. 허영은 최후의 병이다.`,
    author: `조지 에드워드 무어 - George Edward Moore`,
  },
  {
    category: `Success`,
    quote: `잘 닦여진 구리는 갓 캐낸 금보다도 한층 더 많은 사람의 눈에 띄기 쉽다.`,
    author: `체스터필드`,
  },
  {
    category: `Success`,
    quote: `잘못을 저지르고도 후회할 줄 모르는 자는 下等의 사람이요. 후회하면서도 고칠줄 모르는 자도 下等의 사람이다.`,
    author: `소학`,
  },
  {
    category: `Success`,
    quote: `잠을 발명한 자에게 하나님의 축복이 있을지어다. 그것은 모든 사람의 생각을 뒤덮는 외투요, 모든 굶주림을 치료해 주는 음식이요, 목동과 왕, 무학자와 현자를 평등하게 하는 저울추이다.`,
    author: `미겔 데 사아베드라 세르반테스 - 스페인 소설가:1547~ 1616`,
  },
  {
    category: `Success`,
    quote: `잠자리에 들때 이튿날 일어날 일을 즐거움으로 삼고 있는 인간은 행복하다.`,
    author: `힐티 - 스위스 철학자 : 1833-1909`,
  },
  {
    category: `Success`,
    quote: `장점과 훌륭한 예의는 어디서나 번영할 것이다.`,
    author: `체스터필드`,
  },
  {
    category: `Success`,
    quote: `재능이 있는 사람은 사람들을 설득하며 천재는 오로지 자극을 준다.`,
    author: `부르워 리튼`,
  },
  { category: `Success`, quote: `재산가들 중에는 상식을 가진 자가 드물다.`, author: `유베날리스` },
  {
    category: `Success`,
    quote: `재치는 우리와 암흑 사이를 막는 유일한 담벽이다.`,
    author: `벤 도른`,
  },
  {
    category: `Success`,
    quote: `재치있게 지껄일 수 있는 위트도 없고, 그렇다고 해서 침묵을 지킬 만큼의 분별력도 가지지 못한다는 것은 커다란 불행인 것이다.`,
    author: `라 브뤼에르`,
  },
  {
    category: `Success`,
    quote: `저널리즘의 힘은 크다. 세계를 설득할 수 있는 유능한 편집자는 모두 세계의 지배자가 아닐까.`,
    author: `토머스 칼라일 - 영국 비평가, 역사가 : 1795-1881`,
  },
  {
    category: `Success`,
    quote: `저녁을 하루가 거기서 죽어간다고 생각하고 바라보며, 아침을 모든 것이 거기서 태어난다고 생각하고 바라보아라. 그대의 시각이 한 순간마다 새로워지는 것처럼, 현명한 사람이란 모든 것에 경탄 하는 사람을 말한다.`,
    author: `앙드레 폴 기욤 지드 - 프랑스 소설가:1869~1951`,
  },
  {
    category: `Success`,
    quote: `적당주의자가 되지 말라. 그것은 세상에서 가장 위험한 것이다.`,
    author: `휴그 왈폴`,
  },
  {
    category: `Success`,
    quote: `적막한 달밤에 칼머리의 바람은 세찬데 / 칼끝에 찬서리가 고국생 각을 돋구누나 / 삼천리 금수강산에 왜놈이 왠말인가 / 단장의 아픈 마음 쓰러버릴 길 없구나.`,
    author: `김좌진`,
  },
  {
    category: `Success`,
    quote: `적은 것을 적다고 하지 말며 천한 것을 천하게 여기지 말라.`,
    author: `소자`,
  },
  {
    category: `Success`,
    quote: `적은 말로 많은 것은 이해시키는 것이 큰 인물의 특징이라면, 소인은 이와 반대로 많은 말을 농락하면서도 하나도 말할것이 없는 천부의 재능을 지니고 있다.`,
    author: `프랑수아 드 라 로슈푸코 - 프랑스 사상가:1613~1680`,
  },
  {
    category: `Success`,
    quote: `적을 만들지 못하는 자는 친구도 만들지 못한다.`,
    author: `앨프리드 테니슨 - 영국시인 : 1809~1892`,
  },
  {
    category: `Success`,
    quote: `전력을 다하여 자기 자신을 충실히 하기에 힘써라. 어찌 남이 내 비위를 맞추어 주지 않는다고 탓하면서 자신의 마음과 몸을 자기의 뜻대로 복종시키려고 하지 않는가.`,
    author: `마르쿠스 아우렐리우스 - 로마의 황제`,
  },
  { category: `Success`, quote: `전력을 다해서 시간에 대항하라.`, author: `톨스토이` },
  {
    category: `Success`,
    quote: `전시에는 항상 사람들의 맥박을 짚어보고 체온을 재는 갤럽 여론조사의 신경질적 분위기에서 사는 것보다 더 위험한 일은 없다.`,
    author: `윈스턴 처칠 - Sir Winston Leonard Spencer Churchill`,
  },
  {
    category: `Success`,
    quote: `전쟁에서는 오직 한 번 죽지만은 정치에서는 여러번 죽는다.`,
    author: `처칠`,
  },
  {
    category: `Success`,
    quote: `전쟁에선 어느 편이 스스로를 승자라고 부를지라도 승리자는 없고 모두 패배자뿐이다.`,
    author: `챔벌린`,
  },
  { category: `Success`, quote: `전쟁이란 국왕의 영업이다.`, author: `드라이덴` },
  { category: `Success`, quote: `전쟁이란 파괴의 과학이다.`, author: `죤 아보트` },
  {
    category: `Success`,
    quote: `전혀 결점을 보이지 않는 인간은 바보가 아니면 위선자이다.`,
    author: `주베르`,
  },
  {
    category: `Success`,
    quote: `절대적인 진리는 쉽게 붙잡을 수 있는 가까운 곳에 있다. 그것은 타인의 손에 의해서 붙드는 것이 아니고 자기 스스로 붙드는 것이다.`,
    author: `장 폴 사르트르 - 프랑스 작가:1905~1980`,
  },
  {
    category: `Success`,
    quote: `절망적인 불행이 빠른 치료를 요구 할때 불신은 비겁이요, 신중은 어리석다.`,
    author: `새뮤얼 존슨 - 영국 시인,평론가`,
  },
  {
    category: `Success`,
    quote: `절제는 정열과 그외의 부당한 마음의 마음의 충동에 대한 확고하고 온당한 이성의 지배이다.`,
    author: `마르쿠스 툴리우스 키케로 - 로마정치가`,
  },
  {
    category: `Success`,
    quote: `절제와 근면은 인간에게 참다운 처방이다. 즉 일은 식욕을 돋구고 절제는 그것을 통제하는 힘이 된다.`,
    author: `장 자크 루소 - Jean-Jacques Rousseau`,
  },
  {
    category: `Success`,
    quote: `절제와 노동은 인간에게 가장 진실한 두 의사다.`,
    author: `장 자크 루소 - Jean-Jacques Rousseau`,
  },
  { category: `Success`, quote: `젊게 보입니다. 하는 말은 늙었다는 증거이다.`, author: `어빙` },
  {
    category: `Success`,
    quote: `젊은이는 희망에 살고, 노인은 추억에 산다.`,
    author: `프랑스 격언`,
  },
  {
    category: `Success`,
    quote: `접근하는 남자는 거절하고, 미워하는 남자를 사랑하는 것이 여자의 일반적인 상식이다.`,
    author: `세르반테스`,
  },
  {
    category: `Success`,
    quote: `정당하게 사는 자에게는 어느 곳이든 안전하다.`,
    author: `에픽테투스`,
  },
  {
    category: `Success`,
    quote: `정사의 경험이 단 한번도 없다는 여인은 있지만 한번 밖에 없다는 여인은 드물다.`,
    author: `라 로시푸코`,
  },
  {
    category: `Success`,
    quote: `정신으로 창조된 것은 물질보다 한결 생명적이다.`,
    author: `보들레르`,
  },
  {
    category: `Success`,
    quote: `정열은 강이나 바다와 가장 비슷하다. 아픈 것은 소리를 내지만 깊은 것을 침묵을 지킨다.`,
    author: `까뮈`,
  },
  {
    category: `Success`,
    quote: `정의란 각기 자기가 할 일을 다하고 타인을 방해하거나 간섭하지 않는 것이다.`,
    author: `플라톤 - Platon`,
  },
  { category: `Success`, quote: `정직은 가장 확실한 자본이다.`, author: `에머슨` },
  { category: `Success`, quote: `정직한 노동은 사랑스런 얼글을 낳는다.`, author: `대커` },
  { category: `Success`, quote: `정치에 있어서 실험은 혁명을 뜻한다.`, author: `벤자민 디즈렐리` },
  {
    category: `Success`,
    quote: `정치 브로커는 다음 선거를 생각하고, 정치가는 다음 세대를 생각한다.`,
    author: `제임스 프리먼 클라크`,
  },
  {
    category: `Success`,
    quote: `정치적인 변혁은, 커다란 저항을 진압한 뒤가 아니면 결코 행해서는 안된다.`,
    author: `허버트 스펜서`,
  },
  {
    category: `Success`,
    quote: `정치적 자유는 우리들의 마음이 자유가 아닐 때는 우리에게 자유를 주지 않 는다.`,
    author: `타골`,
  },
  {
    category: `Success`,
    quote: `정해진 해결법같은 것은 없다. 인생에 있는 것은 진행중의 힘뿐이다. 그 힘을 만들어내야 하는 것이다. 그것만 있으면 해결법 따위는 저절로 알 게 되는 것이다.`,
    author: `생텍쥐베리`,
  },
  {
    category: `Success`,
    quote: `절제는 모두 미덕의 진주고리를 이어주는 비단의 실이다.`,
    author: `홀`,
  },
  { category: `Success`, quote: `제일의 부는 건강이다.`, author: `R.W.에머슨` },
  {
    category: `Success`,
    quote: `제 집에 있을 때 손님 맞아들일 줄 모르면, 밖에 나갔을 때 비로소 자기를 환대해줄 주인 적음을 알리라.`,
    author: `명심보감`,
  },
  { category: `Success`, quote: `조금 알기 위해서 많이 공부해야 한다.`, author: `몽테스키외` },
  {
    category: `Success`,
    quote: `조선의 국토 산하는 그대로 조선의 역사이다. 그리고 조선인의 정신 이 이 땅에 깃들어 있다.`,
    author: `김교신`,
  },
  { category: `Success`, quote: `조용한 물이 깊이 흐른다.`, author: `릴리` },
  {
    category: `Success`,
    quote: `존경할 만한 가치가 있는 것은 이 세상에 3가지가 존재한다. 이 것은 승려와 군인과 시인이다. 다시 말하면 지식과 살인과 창조이다.`,
    author: `보들레르 - 프랑스시인:1821~1867`,
  },
  {
    category: `Success`,
    quote: `존재하는 것을 변화시키는 것은 성숙하게 만드는 것이다.`,
    author: `헨리 버그슨`,
  },
  { category: `Success`, quote: `존재하는 모든 훌륭한 것은 독창력의 열매이다.`, author: `밀` },
  {
    category: `Success`,
    quote: `좀더 높은 이상이 없었다면 인류는 쉬지 않고 일만 하는 개미떼와 무슨 차이가 있었을 것인가.`,
    author: `게오르크 빌헬름 프리드리히 헤겔 - 독일 철학자:1770~1831`,
  },
  { category: `Success`, quote: `종교는 많다. 그러나 도덕은 단 하나다.`, author: `라스킨` },
  {
    category: `Success`,
    quote: `종교를 사랑하고 그것을 지켜가기 위해서는 그것을 지키지 않는 사람을 미워하거나 박해할 필요가 없다.`,
    author: `몽테스키외 - 프랑스 사상가 : 1689-1755`,
  },
  { category: `Success`, quote: `종소리처럼 맑고 분명해라.`, author: `레이` },
  {
    category: `Success`,
    quote: `좋은 가문에서 태어나는 것은 바람직한 일이다. 그러나 그 영광은 조상의 것이다.`,
    author: `플루타르쿠스`,
  },
  {
    category: `Success`,
    quote: `좋은 결혼은 있어도, 즐거운 결혼은 좀체로 없다.`,
    author: `라 로슈푸꼬`,
  },
  { category: `Success`, quote: `좋은 나무는 좋은 열매를 맺는다.`, author: `랭런드` },
  {
    category: `Success`,
    quote: `좋은 밤을 찾다가 좋은 낮을 잃어버리는 사람들이 많다.`,
    author: `네덜란드 격언`,
  },
  {
    category: `Success`,
    quote: `좋은 일을 많이 해내려고 기다리는 사람는 하나의 좋은 일도 해낼 수가 없다.`,
    author: `사무엘 존스`,
  },
  { category: `Success`, quote: `좋은 전쟁 또는 나쁜 평화는 없다.`, author: `플랭클린` },
  {
    category: `Success`,
    quote: `좋은 전쟁이란 있어 본 일이 없다. 혹은 또 나쁜 평화라는 것도 있어 본 일 이 없다.`,
    author: `프랭클린`,
  },
  { category: `Success`, quote: `좋은 친구는 건강에도 좋다.`, author: `시라손` },
  { category: `Success`, quote: `죄는 취소될 수 없다. 용서될 뿐이다.`, author: `스트라빈스키` },
  {
    category: `Success`,
    quote: `죄란 금지되어 해로운 것이 아니라, 해롭기 때문에 금지된 것이다. 의무도 명령을 받았기 때문에 유익한 것이 아니라 유익하기 때문에 명령받은 것이다.`,
    author: `조르주 베르나노스, 벤저민 프랭클린 - Benjamin Franklin`,
  },
  {
    category: `Success`,
    quote: `죄를 저지르는 일은 인간이 하는 일이며, 자기의 죄를 정당화하려는 것은 악마의 일이다.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아 작가 : 1828-1910`,
  },
  { category: `Success`, quote: `주사위는 던져졌다.`, author: `율리어스 카이사르` },
  {
    category: `Success`,
    quote: `죽은 자로 명예를 즐기게 하고 산 자로 사랑을 즐기게 하라 사랑은 끝없는 신비 이다.`,
    author: `타고르`,
  },
  { category: `Success`, quote: `죽을 때를 모르는 사람은 살아갈 때도 모른다.`, author: `러스킨` },
  {
    category: `Success`,
    quote: `죽음은 사람을 슬프게 한다. 삶의 3 분의 1 을 잠으로 보내는 주제에.`,
    author: `바이런`,
  },
  {
    category: `Success`,
    quote: `죽음을 두려워하는 나머지 삶을 시작조차 못하는 사람이 많다.`,
    author: `벤다이크`,
  },
  {
    category: `Success`,
    quote: `죽음이란, 우리에게 등을 돌린 빛이 비치지 않는 생의 한 측면이다.`,
    author: `라이너 마리아 릴케 - 독일의 시인:1875~1926`,
  },
  { category: `Success`, quote: `중간이 가장 안전할 것이다.`, author: `오비디우스` },
  {
    category: `Success`,
    quote: `중요한 것은 어떤 책, 어떤 경험을 사람이 지녀야 하는가가 아니라, 그런 책들이나 경험 가운데 자신의 무엇을 주입하느냐의 문제다.`,
    author: `헨리 밸런타인 밀러 - 미국 소설가:1891~1980`,
  },
  {
    category: `Success`,
    quote: `즐거움에 찬 얼굴은 한접시의 물로도 연회를 만들 수 있다.`,
    author: `허버트`,
  },
  {
    category: `Success`,
    quote: `증오는 가슴에서 나오고, 경멸은 머리에서 나온다. 어느 감정도 완전히 우리의 제어하에 있지 않다.`,
    author: `아르투어 쇼펜하워 - Arthur Schopennauer`,
  },
  {
    category: `Success`,
    quote: `증오란 정당한 것이다. 부정을 미워할 줄 모르는 사람은 정의를 사랑하지 못한다.`,
    author: `로맹 롤랑 - 프랑스 작가 : 1866-1944`,
  },
  { category: `Success`, quote: `지갑이 가벼우면 마음이 무겁다.`, author: `프랭클린` },
  {
    category: `Success`,
    quote: `지구상에는 인간이외는 위대한 것이 없다. 인간에게는 지성이외엔 훌륭한 것이 없다.`,
    author: `헤밀턴`,
  },
  {
    category: `Success`,
    quote: `지극한 즐거움 중 책읽는 것에 비할 것이 없고, 지극히 필요한 것 중 자식을 가르치는 일 만한 것이 없다.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `지나가 버린 아름다운 나날은 또 다시 내 앞으로 되돌아 오지 않는다.`,
    author: `알프렛 테니슨`,
  },
  {
    category: `Success`,
    quote: `지나치게 숙고하는 인간은 큰 일을 성취시키지 못한다.`,
    author: `실러`,
  },
  {
    category: `Success`,
    quote: `지난날 우리에게는 깜박이는 불빛이 있었으며, 오늘날 우리에게는 타오르는 불빛이 있다. 그리고 미래에는 온 땅 위와 바다 위를 비추어주는 불빛이 있을 것이다.`,
    author: `윈스턴 처칠 - 영국 정치가:1974~1965`,
  },
  {
    category: `Success`,
    quote: `지도력은 적성이 요구된다. 즉 훌륭한 기술자나 관리자인 사람이 지도력의 적성없이 충분한 경우는 드물다. 지도력은 또한 기초적 자세가 요구된다. 기초적 마음가짐만큼 한정하기 어려운 것도 없고,변하기 어려운 것도 없다.`,
    author: `피터 드러커 - 영국의 경제학자`,
  },
  { category: `Success`, quote: `지도자란 희망을 파는 상인이다.`, author: `보나파르트 나폴레옹` },
  {
    category: `Success`,
    quote: `지도자로서 성공하려면 자기 시대에서 너무 많이 앞질러 가면 안된다. 자기를 업고 있는 대중의 눈으로 사물을 보지 않으면 안된다.`,
    author: `해럴드 조지프 래스키 - 1893 ~ 1950 : 영국의 정치학자`,
  },
  {
    category: `Success`,
    quote: `지독히 화가 날 때에는 인생이 얼마나 덧없는가를 생각해 보라.`,
    author: `마르쿠스 아우렐리우스 - 로마의 황제 : 121-180`,
  },
  {
    category: `Success`,
    quote: `지성이란 그것을 갖고 있지 않는 사람에게는 보이지 않는다.`,
    author: `쇼펜하우어`,
  },
  {
    category: `Success`,
    quote: `지성인은 자기의 마음으로 자기 자신을 망보는 사람이다.`,
    author: `까뮈`,
  },
  {
    category: `Success`,
    quote: `지식과 목재는 세파에 시달리지 아니하면 많이 애용될 수가 없다.`,
    author: `올리버 웬델 홈즈`,
  },
  { category: `Success`, quote: `지식에 투자하는 것이 가장 이윤이 높다.`, author: `프랭클린` },
  {
    category: `Success`,
    quote: `지식은 고령자에겐 기분좋은 은거처이며 필요한 피난처이다. 젊을 때 지식을 심어두지 않으면 늙었을때 햇볕을 가려주는 구실을 해주지 않을 것이다.`,
    author: `필립 도머 스태넙 체스터필드 - 영국 정치가 : 1694-1773`,
  },
  {
    category: `Success`,
    quote: `지식이 缺如결여하고 애국심이 박약한 이 국민으로 하여금 나라가 곧 제 집이라는 것을 깨닫게 하기 전에는 아무 것으로도 나라를 건질 수는 없다.`,
    author: `金九 - 독립운동가.정치가:1876~1949`,
  },
  { category: `Success`, quote: `지식이 깊은 사람은 시간의 손실을 가장 슬퍼한다.`, author: `단테` },
  {
    category: `Success`,
    quote: `지식인은 정치가를 경멸하고 정치가는 지식인을 경멸한다.`,
    author: `로망 로랑`,
  },
  {
    category: `Success`,
    quote: `지식인은 지금까지 일어났던 일을 안다. 천재는 앞으로 일어날 일을 안다.`,
    author: `치이다`,
  },
  {
    category: `Success`,
    quote: `지혜가 깊은 사람은 자기에게 무슨 이익이 있음으로 해서 사랑하는 것이 아니다. 사랑한다는 그 자체속에서 행복을 느낄 수 있기 때문에 사랑하는 것이다.`,
    author: `블레즈 파스칼 - 프랑스 수학자.사상가 : 1623-1662`,
  },
  { category: `Success`, quote: `지혜는 간혹 누더기 가면을 덮어쓰고 있다.`, author: `스타티우스` },
  { category: `Success`, quote: `지혜는 고통을 통해서 생긴다.`, author: `아에스킬루스` },
  {
    category: `Success`,
    quote: `지혜없는 힘은 그 자체의 무게 때문에 쓰러진다.`,
    author: `호라티우스 - 로마시인`,
  },
  {
    category: `Success`,
    quote: `지혜·용기·전체가 조화될 때 정의가 실현되고, 또한 만인의 행복을 보장하는 이상 국가가 이루어질 수 있다.`,
    author: `플라톤 - Platon`,
  },
  {
    category: `Success`,
    quote: `지혜의 가장 명백한 징조는 쉴새없이 명랑한 것이다.`,
    author: `몽테뉴`,
  },
  { category: `Success`, quote: `진리는 인간이 보존하고 있는 최고의 것이다.`, author: `쵸오서어` },
  { category: `Success`, quote: `진리는 많은 말을 필요로 하지 않는다.`, author: `이 언` },
  { category: `Success`, quote: `진리는 적이건 아군이건 모두 초월한다.`, author: `쉴러` },
  {
    category: `Success`,
    quote: `진보로 통하는 가장 훌륭한 길은 자유의 길이다.`,
    author: `존 피츠제럴드 케네디 - 미국 대통령`,
  },
  {
    category: `Success`,
    quote: `진실도 때로는 우리를 다치게 할 때가 있다. 하지만 그것은 머지않아 치료를 받을 수 있는 가벼운 상처이다.`,
    author: `앙드레 폴 기욤 지드 - 프랑스 소설가:1869~1951`,
  },
  {
    category: `Success`,
    quote: `진실없는 삶이란 있을 수가 없다. 진실이란 삶 그 자체인 것이다.`,
    author: `카프카 - 독일 소설가 : 1883-1924`,
  },
  {
    category: `Success`,
    quote: `진실은 빛과 같이 눈을 어둡게 한다. 반대로 거짓은 아름다운 저녁 노을과 같이 모든 것을 아름답게 보이게 한다.`,
    author: `알베르트 카뮈 - 프랑스철학자:1913~1960`,
  },
  {
    category: `Success`,
    quote: `진실은 아름답다. 익살만 없다면, 거짓말도 마찬가지다.`,
    author: `랠프 월도 에머슨 - 미국 시인 : 1803-1882`,
  },
  {
    category: `Success`,
    quote: `진실은 언제나 우리의 가장 가까운 곳에 있다. 다만 사람들이 그것에 주의하지 않았을 뿐이다. 항상 진실을 찾아야 한다. 진실은 우리를 늘 기다리고 있다.`,
    author: `블레즈 파스칼 - 프랑스 수학자, 사상가:1623~1662`,
  },
  {
    category: `Success`,
    quote: `진실은 정당한 명분을 결코 해치지 않는다.`,
    author: `마하트마 간디 - 인도의 성인`,
  },
  { category: `Success`, quote: `진실은 존재한다. 오직 거짓말만이 만들어진다.`, author: `브라크` },
  {
    category: `Success`,
    quote: `진실이 가치 있다면 그것은 진실이기 때문이지 진실을 말하는 것이 용감하기 때문은 아니다.`,
    author: `윌리엄 서미싯 몸 - William Somerset Maugham`,
  },
  {
    category: `Success`,
    quote: `진실한 사랑에 빠진 남자는 그 애인 앞에서 어쩔 줄을 몰라 제대로 사랑을 고백하지도 못한다.`,
    author: `칸트`,
  },
  {
    category: `Success`,
    quote: `진심으로 사랑하는 사람은 결코 늙지 않는다.`,
    author: `A W 피네로`,
  },
  {
    category: `Success`,
    quote: `진정으로 사랑하고 있는 남자는 여인 앞에서는 어찌할 바를 모르고 졸렬하며 애교도 부리지 못한다.`,
    author: `칸트 - 독일 철학자 : 1724-1804`,
  },
  { category: `Success`, quote: `진정한 벗은 제2의 자기인 것이다.`, author: `아리스토텔레스` },
  {
    category: `Success`,
    quote: `진정한 위인치고 자신을 위인으로 생각하는 자는 없다.`,
    author: `해즐리트`,
  },
  {
    category: `Success`,
    quote: `진정한 유머는 머리에서 나온다기보다 마음에서 나온다. 그것은 웃음에서 나오는 것이 아니라 조용한 미소에서 나온다.`,
    author: `토머스 칼라일 - Thomas Carlyle`,
  },
  {
    category: `Success`,
    quote: `진정한 창조는 신만이 할 수가 있다. 인간이 어떤 새로운 것을 만들어 냈다고 하더라도 그것은 어디까지나 신의 계시에 의한 모방일 뿐이다.`,
    author: `토머스 칼라일 - 영국 비평가 : 1795-1881`,
  },
  {
    category: `Success`,
    quote: `진정한 창조는 침묵 속에서 이루어진다.`,
    author: `힐티 - 스위스 철학자:1833~1909`,
  },
  {
    category: `Success`,
    quote: `진정한 행복을 만드는 것은 수많은 친구가 아니며, 훌륭히 선택된 친구들이 다.`,
    author: `벤 죤슨`,
  },
  { category: `Success`, quote: `진주를 간직하고 있는 것은 병든 굴이다.`, author: `세드` },
  {
    category: `Success`,
    quote: `진지한 표정으로 거론할 수 있는 하찮은 것은 아니다.`,
    author: `와일드`,
  },
  {
    category: `Success`,
    quote: `진짜 지도자는 인도할 필요성을 갖지 않는다. 즉, 그는 길을 가리켜 주는 것으로 족하다.`,
    author: `헨리 밸런타인 밀러 - 미국 소설가`,
  },
  {
    category: `Success`,
    quote: `질병은 느낄 수 있지만 건강은 전혀 느껴지지 않는 것.`,
    author: `토머스 풀러`,
  },
  {
    category: `Success`,
    quote: `질이 좋지 않은 사람을 가까이 하면 덕을 잃게 되고 기물을 수집하거나 새, 짐승을 즐겨 기르면 심지를 잃게 된다.`,
    author: `시경`,
  },
  {
    category: `Success`,
    quote: `집은 어머니의 몸을 대신하는 것이다. 어머니의 몸이야말로 언제까지나 사람들이 경하는 최초의 집이다. 그속에서 인간은 안전했으며 또 몹시 쾌적하기도 했다.`,
    author: `지크문트 프로이트 - 오스트리아 정신분석학자 : 1856-1939`,
  },
  {
    category: `Success`,
    quote: `집을 이룰 아이는 인분도 금처럼 아끼고, 집을 망칠 아이는 금도 인분처럼 쓴다.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `착한 행동이란 나쁜 행동을 삼가는 것이 아니라 나쁜 행동을 바라지 않는 것이다.`,
    author: `쇼`,
  },
  {
    category: `Success`,
    quote: `참고 버티라.그 고통은 차츰차츰 너에게 좋은 것으로 변할 것이다.`,
    author: `오비디우스`,
  },
  {
    category: `Success`,
    quote: `참나무가 더 단단한 뿌리를 갖도록 하는 것은 바로 사나운 바람이다.`,
    author: `조오지 허버`,
  },
  { category: `Success`, quote: `참된 등산가는 동시에 방황자이다.`, author: `망메리` },
  {
    category: `Success`,
    quote: `참된 삶을 맛보지 못한 자만이 죽음을 두려워 하는 것이다.`,
    author: `제이 메이`,
  },
  { category: `Success`, quote: `참된 힘은 내 자신에서만 끄집어 낼 수 있다.`, author: ` ` },
  {
    category: `Success`,
    quote: `참을성이 있는 사람의 분노의 폭발에 조심하라 !.`,
    author: `존 드라이든`,
  },
  {
    category: `Success`,
    quote: `참을 수 없는 고통은 우리를 무척이나 괴롭힌다. 하지만 오랫동안 계속되는 고통은 참을 수 있다. 그리하여 마음은 그 자신속에 머무르며, 상처를 받게 되는 사람들은 만일 가능하다면 그 고통에 대해서 각자의 의견을 나타내는 것이 좋다.`,
    author: `마르쿠스 아우렐리우스 - 로마의 황제 : 121-180`,
  },
  {
    category: `Success`,
    quote: `창조는 고민속에서 나오고 발전은 고생 속에서 움튼다.`,
    author: `밝은사회`,
  },
  {
    category: `Success`,
    quote: `창조적인 예술가는 그 전의 작품에 만족하지 않기 때문에 다음 작품을 만든다.`,
    author: `쇼스타코비치`,
  },
  {
    category: `Success`,
    quote: `책은 남달리 키가 큰 사람이요, 다가오는 세대가 들을 수 있도록 소리 높이 외치는 유일한 사람이다.`,
    author: `브라우닝`,
  },
  {
    category: `Success`,
    quote: `책은 위대한 천재가 인류에게 남겨주는 유산이며, 그것은 아직 태어나지 않은 자손들에게 주는 선물로서, 한 세대에서 다른 세대로 전달된다.`,
    author: `에디슨 - 미국 발명가 : 1847-1931`,
  },
  {
    category: `Success`,
    quote: `책은 인류의 저주다. 현존하는 서적의 9할은 시시한 것이고 똑똑한 책은 그 시시함을 논파하는 것이다. 인간에게 내리는 최대의 불행은 인쇄의 발명이다.`,
    author: `벤자민 디즈레일리 - 영국 정치가 : 1804-1881`,
  },
  { category: `Success`, quote: `책이 없는 궁궐보다 책이 있는 오두막이 났다.`, author: `카알라일` },
  {
    category: `Success`,
    quote: `책임과 권위는 동전의 양면과 같다. 권위가 없는 책임이란 있을 수 없으며 책임이 따르지 않는 권위도 있을 수 없다.`,
    author: `막스 베버 - Max Weber`,
  },
  {
    category: `Success`,
    quote: `처세술이란 것은 무엇보다도 자기가 한 결심을 재치있게 해내는 일이다. 그러므로 자기가 하고 있는 일에 대해서 군소리를 하지 않는 사람이야말로 처세술이 능한 사람이라 할 것이다.`,
    author: `알랭 - 프랑스 철학자:1868~1951`,
  },
  {
    category: `Success`,
    quote: `처음에는 진실과 조금 밖에 빗나가지 않은 것이라도 후에는 천배나 벌어지게 된다.`,
    author: `아리스토텔레스 - 그리스 철학자:BC 384~322`,
  },
  { category: `Success`, quote: `천금의 구술은 반드시 깊은 여울속에 있다.`, author: `장자` },
  {
    category: `Success`,
    quote: `천리나 되는 제방도 땅강아지와 개미가 뚫은 조그만 구멍으로 물이 새어나오고, 백척이나 되는 거목도 조그만 굴뚝에서 새어나오는 연기로 불이 난다.`,
    author: `회남자`,
  },
  {
    category: `Success`,
    quote: `천성이 참기에 적합지 않은 사람에게는 아무 일도 일어나지 않는다.`,
    author: `마르쿠스 아우렐리우스 - 로마의 황제 : 121-180`,
  },
  { category: `Success`, quote: `천재가 낳은 것도 모두 열중의 산물이다.`, author: `디즈레일리` },
  {
    category: `Success`,
    quote: `천재는 노력하기 때문에 어떤 일에도 탁월하다. 그러나 천재는 탁월하기 때문에 그 일에 노력하는 것이다.`,
    author: `윌리엄 해즐릿 - 영국비평가:1778~1830`,
  },
  { category: `Success`, quote: `천재는 위업을 시작하나 노력만이 그 일을 끝낸다.`, author: ` ` },
  {
    category: `Success`,
    quote: `천재는 일(1) 퍼센트의 영감이요. 99 퍼센트는 노력이다.`,
    author: `보비`,
  },
  {
    category: `Success`,
    quote: `천재란 굴 껍질 속의 진주와도 같이 빛나는 일종의 병이 아닐까?`,
    author: `하이네`,
  },
  {
    category: `Success`,
    quote: `천재란 인내에 대한 위대한 자질 이외에는 아무것도 아니다.`,
    author: `뷰퐁`,
  },
  {
    category: `Success`,
    quote: `천재란 하늘이 주는 1% 의 영감과, 그가 흘리는 99% 의 땀으로 이루어진다.`,
    author: `에디슨 - Edison`,
  },
  { category: `Success`, quote: `청소년기는 제 2 의 탄생이다.`, author: `루소 - J.J. Rousseau` },
  {
    category: `Success`,
    quote: `청년과 처녀가 만난다. - 이 사실이 없다면 인류는 멸망하고 말았으리라.`,
    author: `H 보우만`,
  },
  {
    category: `Success`,
    quote: `청년기는 대실수이다. 장년기는 투쟁이다. 그리고 노년기는 후회이다.`,
    author: `디즈레일리`,
  },
  {
    category: `Success`,
    quote: `청년기란 실패, 중년기는 고투, 노년기는 후회.`,
    author: `디즈레일리`,
  },
  {
    category: `Success`,
    quote: `청년이여 일하라. 좀 더 일하라. 끝까지 열심히 일하라.`,
    author: `비스마르크`,
  },
  {
    category: `Success`,
    quote: `청춘은 다시 돌아오지 않고 하루에 새벽은 한번뿐이다. 좋은때에 부지런히 힘쓸지니 세월은 사람을 기다리지 않는다.`,
    author: `陶淵明 - 도연명 : 중국 진나라 시인:365~427`,
  },
  {
    category: `Success`,
    quote: `최고급 회개란 과거의 죄를 청산하고 똑바로 행동하는 것이다.`,
    author: `윌리암 제임스`,
  },
  { category: `Success`, quote: `최고에 도달하려면 최저에서 시작하라.`, author: `P.시르스` },
  {
    category: `Success`,
    quote: `최고의 불행은 포기가 아니라 하려고 하지 않는 것이다.`,
    author: `무명씨`,
  },
  { category: `Success`, quote: `최대다수의 최대 행복은 도덕과 입법의 초석이다.`, author: `벤담` },
  {
    category: `Success`,
    quote: `최대의 과오는 어떠한 과오를 보이더라도 조금도 깨닫지 못하는 일이다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `최악의 고독이란, 한 사람의 친우도 없는 것이다.`,
    author: `프랜시스 베이컨`,
  },
  {
    category: `Success`,
    quote: `최초의 큰 웃음 보다는 마지막의 미소가 오히려 낫다.`,
    author: `영국속담`,
  },
  { category: `Success`, quote: `추위에 떤 사람일수록 태양의 따뜻함을 느낀다.`, author: `휘트먼` },
  {
    category: `Success`,
    quote: `추위에 떤 자일수록 태양의 따뜻함을 느낀다. 인생의 고뇌를 맛본 자일수록 생명의 존귀함을 느낀다.`,
    author: `호이토 맨`,
  },
  { category: `Success`, quote: `충고는 좀처럼 환영받지 못한다.`, author: `체스터필드` },
  {
    category: `Success`,
    quote: `충고자는 아무리 신랄하여도 결코 해를 끼치지는 않는다.`,
    author: `부블릴리우스 시루스`,
  },
  {
    category: `Success`,
    quote: `충실한 삶의 깊이를 아는 자는 아름다운 죽음의 가치를 안다.`,
    author: `레오도로`,
  },
  {
    category: `Success`,
    quote: `옳고 그름을 분별하는 마음은 지의 시초이다.`,
    author: `맹자 - Mencius`,
  },
  { category: `Success`, quote: `치료를 받을 생각을 말고 질병을 만들지 말라.`, author: `호이트맨` },
  {
    category: `Success`,
    quote: `친구가 많다는 것은 친구가 전혀 없다는 것이다.`,
    author: `그리스 철학자 아리스토텔레스`,
  },
  {
    category: `Success`,
    quote: `친구끼리의 이별은 확실히 우울하고 슬픈 일, 그러나 愛人끼리의 이별과 같 은 고민은 느끼지 않는다.`,
    author: `불워 리턴`,
  },
  {
    category: `Success`,
    quote: `친구들에게서 기대하는 것을 친구들에게 베풀어야 한다.`,
    author: `아리스토텔레스`,
  },
  {
    category: `Success`,
    quote: `친구들을 불신한다는 것은 그들에게 속은 것보다 더 수치스러운 일이다.`,
    author: `로셔푸코`,
  },
  {
    category: `Success`,
    quote: `친구라면 신중하게 교제하라. 혀는 혀, 마음은 마음이라고 하는 사람이야말로 무서운 사람이다. 그런 사람은 친구로 삼을 것이 아니라 적으로 삼으라.`,
    author: `테오그니스`,
  },
  {
    category: `Success`,
    quote: `친구란 무엇인가 ? 두사람의 신체에 사는 하나의 영혼이다.`,
    author: `아리스토텔레스 - 그리스 철학자:BC 384~322`,
  },
  {
    category: `Success`,
    quote: `친구를 선택하려면 지도자를 찾지 말고 친구를 찾아라.`,
    author: `노신`,
  },
  {
    category: `Success`,
    quote: `친구를 얻는 유일한 방법은 스스로 완전한 친구가 되는 것이다.`,
    author: `에머슨`,
  },
  {
    category: `Success`,
    quote: `친구를 칭찬할 때는 널리 알도록 하고 친구를 책망할 때는 남이 모르게 한다.`,
    author: `독일속담`,
  },
  {
    category: `Success`,
    quote: `친구한테 속지 않으려고 애쓰는 것보다도 차라리 친구한테 속는 사람이 행복하다. 친구를 믿는다는 것은 설사 친구한테 속더라도 어디까지나 나 자신만은 성실했다는 표적이 된다.`,
    author: `채근담`,
  },
  {
    category: `Success`,
    quote: `친해하는 미국 국민들이여, 당신의 조국이 당신을 위해 무엇을 할 수 있는가를 묻지말고 당신이 조국을 위해 무엇을 할 수 있는가를 물으라.`,
    author: `케네디 - J.F.Kennedy`,
  },
  {
    category: `Success`,
    quote: `침대는 우리의 일생을 다 알고 있다. 우리는 거기서 태어났고, 거기서 살고, 거기서 죽으리니.`,
    author: `기 드 모파상 - 프랑스 소설가 : 1850-1893`,
  },
  { category: `Success`, quote: `침묵이란 경멸을 가장 잘 나타내는 표현이다.`, author: `B 쇼` },
  {
    category: `Success`,
    quote: `커다란 슬픔은 슬퍼하는 자를 변모시킨다. 그것은 신성하고도 백열하는 광채 다.`,
    author: `위고`,
  },
  { category: `Success`, quote: `쾌락의 탐구란 모든 인류 행위의 동인이다.`, author: `스땅달` },
  {
    category: `Success`,
    quote: `크기는 위대함이 아니며, 영토가 국가를 만들지 않는다.`,
    author: `토머스 헨리 헉슬리 - Thomas Henry Huxley`,
  },
  {
    category: `Success`,
    quote: `큰 그릇은 늦게야 이루어지고, 아주 큰 소리는 도리어 잘 들을 수 없고, 큰 모습 즉 道도는 형체가 없다.`,
    author: `노자`,
  },
  { category: `Success`, quote: `큰 나무는 바람을 많이 받는다.`, author: `카네기` },
  {
    category: `Success`,
    quote: `큰나무도 가느다란 가지에서 시작되는 것이다. 10 층의 탑도 작은 벽돌을 하나씩 쌓아올리는 데에서 시작되는 것이다. 마지막에 이르기까지 처음과 마찬가지로 주의를 기울이면 어떤 일도 해낼 수 있을 것이다.`,
    author: `노자`,
  },
  { category: `Success`, quote: `큰 시련은 큰 의무를 완수하게 만든느 것이다.`, author: `톰슨` },
  {
    category: `Success`,
    quote: `큰 실패를 경험하고서도 그 경험을 현금으로 바꾸지 못하는 자는 낙제생이다.`,
    author: `앨버트 허버드 - 미국의 작가`,
  },
  {
    category: `Success`,
    quote: `큰일에는 진지하게 대하지만 작은 일에는 손을 빼는 것이 당연하다고 생각하는것, 몰락은 언제나 여기에서 시작된다.`,
    author: `헤르만 헤세 - Hermann Hesse`,
  },
  {
    category: `Success`,
    quote: `큰일에 착수할 경우에는 기회를 만들어 내는 것 보다도 눈앞의 기회를 이용하려고 힘써야 한다.`,
    author: `라 로시푸코`,
  },
  {
    category: `Success`,
    quote: `큰일을 목적하는 자는 또한 큰 고통을 당해야한다.`,
    author: `M.L.크랏수스.플루타르쿠스 [영웅전]`,
  },
  {
    category: `Success`,
    quote: `클레오파트라의 코가 조금만 낮았더라면 대지의 표면은 바뀌어졌을 것이다.`,
    author: `파스칼`,
  },
  {
    category: `Success`,
    quote: `타인의 결점은 우리들의 눈앞에 있고 우리들 자신의 결점은 우리의 등 뒤에 있다.`,
    author: `무명씨`,
  },
  {
    category: `Success`,
    quote: `탐구정신은 우리가 살고 있는 시대의 위대한 특징이다.`,
    author: `풀`,
  },
  {
    category: `Success`,
    quote: `탐구하여 찾아질 수 없을 정도로 어려운 문제는 존재하지 않는다.`,
    author: `티랜티우스`,
  },
  {
    category: `Success`,
    quote: `태만은 천천히 움직이므로 가난이 곧 따라잡는다.`,
    author: `프랭클린`,
  },
  {
    category: `Success`,
    quote: `태만이란 약한 마음을 가진 사람의 유일한 피난처이다.`,
    author: `펠립 도머 스태넙 체스터필드 - Philip Dormer Stanhope, 4th Earl of Chesterfield`,
  },
  {
    category: `Success`,
    quote: `태만을 즐기고 있을 때는 태만함을 느끼지 못한다.`,
    author: `가스가 세안`,
  },
  {
    category: `Success`,
    quote: `태산이 높다 하되 하늘 아래 뫼이로다.오르고 또 오르면 못 오를리 없건마는사람이 제 아니 오르고 뫼만 높다 하더라. 태양은 도덕적이지도 부도덕하지도 않다. 그는 있는 그대로 존재하는 것이다. 그는 어둠을 정복한다. 예술도 그와 마찬가지다.`,
    author: `로맹 롤랑 - 프랑스 작가:1866~1944`,
  },
  {
    category: `Success`,
    quote: `태양이 빛나는 것과 폭풍우가 불어닥치는 것은 같은 하늘의 다른 표정에 지나지 않는다. 달든 쓰든 운명을 좋은 양식으로서소용되게 하자.`,
    author: `헤르만 헤세 - 독일 시인 : 1877-1962`,
  },
  {
    category: `Success`,
    quote: `패배를 극복하는 법을 배워야 한다. 그럴때에 당신의 인격이 향상된다.`,
    author: `닉슨`,
  },
  { category: `Success`, quote: `편견이란 실효성이 없는 의견이다.`, author: `암브로스 빌` },
  {
    category: `Success`,
    quote: `편안하게 자유를 누리며 살고 싶다고 생각하거든 없어도 상관없는 사치물을 자기 주변에서 제거하라.`,
    author: `톨스트이`,
  },
  {
    category: `Success`,
    quote: `평생동안 가장 좋은 친구는 한명이면 족하다, 두명이면 너무 많고 세명은 불가능하다.`,
    author: `미상`,
  },
  {
    category: `Success`,
    quote: `평안하게 자유롭게 살고 싶거든 없어도 살 수 있는 것을 멀리하라.`,
    author: `레프 니콜라예비치 톨스토이 - 러시아 작가`,
  },
  {
    category: `Success`,
    quote: `평온한 마음으로 아껴 생활하는 것이 사람에게 큰 부이다.`,
    author: `크레티우스`,
  },
  {
    category: `Success`,
    quote: `평화는 인간의 세계에는 존재하지 않는다. 보통 평화라고 할때 그것은 전쟁이 난 직후 아직 전쟁이 시작되지 않았을 때를 가리켜말하는 데 불과하다.`,
    author: `루쉰 - 魯迅 : 중국 문학의 거장, 1881~1936`,
  },
  {
    category: `Success`,
    quote: `평화의 종교를 지니는 인간에게 그 최고의 가치는 사랑이다. 전쟁의 종교를 지니는 인간에게 그 최고의 가치는 투쟁이다.`,
    author: `찰스 디킨스 - 영국 소설가 : 1812-1870`,
  },
  {
    category: `Success`,
    quote: `포대기 시절을 면치 못하고 일찍 죽는 자가 태반인데도, 우리는 20세가 넘었으니, 이는 그 첫째 행복이다.`,
    author: `유정`,
  },
  { category: `Success`, quote: `폭력에는 폭력으로 대하라.`, author: `페론` },
  { category: `Success`, quote: `폭풍은 참나무가 더욱 뿌리를 깊게 박도록 한다.`, author: `허버드` },
  { category: `Success`, quote: `풍랑은 항상 능력있는 항해자 편이다.`, author: `기번` },
  { category: `Success`, quote: `풍요의 낭비는 부족의 원천이다.`, author: `피코크` },
  {
    category: `Success`,
    quote: `핑계를 잘 대는 사람은 거의 좋은 일을 하나도 해내지 못한다.`,
    author: `벤자민 프랭클린`,
  },
  {
    category: `Success`,
    quote: `하나님 앞에서는 울어라, 그러나 사람들 앞에서는 웃어라.`,
    author: `유태속담`,
  },
  {
    category: `Success`,
    quote: `하나님 이외에는 그 누구도, 그 무엇도 두려워 할 필요는 없다.`,
    author: `간디`,
  },
  {
    category: `Success`,
    quote: `하나의 모범은 천 마디의 논쟁보다 더 가치 있는 것이다.`,
    author: `토마스 카알라일`,
  },
  { category: `Success`, quote: `하나의 소란의 치료는 다른 소란이다.`, author: `타키토우스` },
  {
    category: `Success`,
    quote: `하나의 악덕을 행사하지 않고서는 자국의 존망에 관계된다는 비상사태 아래서는 오명 따위는 관계없이 받아들이는게 좋다.`,
    author: `니콜로 마키아벨리 - 이탈리아 정치사상가:1469~1527`,
  },
  {
    category: `Success`,
    quote: `하나의 작은 꽃을 만드는 데도 오랜 세월의 노력이 필요하다.`,
    author: `블레이크`,
  },
  {
    category: `Success`,
    quote: `하늘에는 입이 없으므로, 사람으로 하여금 말하게 한다.`,
    author: `하이케이야기`,
  },
  {
    category: `Success`,
    quote: `하루라도 책을 읽지 않으면 입안에 가시가 돋는다.`,
    author: `안중근`,
  },
  { category: `Success`, quote: `하루를 일하지 않으면 하루를 먹지 않는다.`, author: `백장회해` },
  {
    category: `Success`,
    quote: `하루의 생활을 다음과 같이 시작하면 좋을 것이다. 즉 눈을 떴을때 오늘 단 한사람에게라도 좋으니 그가 기뻐할 만한 무슨 일을 할 수 없을까, 생각하라.`,
    author: `프리드리히 빌헬름 니체 - Friendricdh Nietzsche`,
  },
  {
    category: `Success`,
    quote: `학문과 예술만이 인간을 신성에까지 끌어 올린다.`,
    author: `베토벤 - Beethoven`,
  },
  { category: `Success`, quote: `학문의 최대의 적은 자기 마음속에 있는 유혹이다.`, author: `처칠` },
  {
    category: `Success`,
    quote: `학자는 입으로 먹은 것을 토하여 새끼를 기르는 큰 까마귀와 같은 자이고 사상가는 뽕잎을 먹고 명주실을 토해 내는 누에와 같은자이다.`,
    author: `林語堂 - 중국 문학가:1895~1976`,
  },
  {
    category: `Success`,
    quote: `한 가지 일을 경험하지 않으면 한 가지 지혜가 자라지 않는다.`,
    author: `명심보감`,
  },
  {
    category: `Success`,
    quote: `한가한 인간은 고인 물처럼 끝내 썩어 버린다.`,
    author: `프랑스 명언`,
  },
  {
    category: `Success`,
    quote: `한 건축물에서 보아야 할 세가지가 있다. 그것은 적절한 자리에 서 있는가, 안전하게 기초가 되어 있는가, 잘 지어져 있는가이다.`,
    author: `요한 볼프강 폰 괴테 - 독일의 문호:1749~1832`,
  },
  {
    category: `Success`,
    quote: `한 나라가 위대한 작가를 가진다는 것은 제2의 정부를 가지는 것과 같이 위험한 일이다. 그 때문에 어느 정치체제도 위대한작가들을 좋아한 적이 없었으며 다만 대수롭잖은 작가들만을 좋아했다.(솔제니친 - 소련 소설가:`,
    author: `1918~   `,
  },
  {
    category: `Success`,
    quote: `한 나라의 가치는 결국 그 나라를 구성하고 있는 개인들의 가치이다.`,
    author: `존 스튜어트 밀 - John Stuart Mill`,
  },
  {
    category: `Success`,
    quote: `한나라의 진정한 재산은 땀흘려 일하는 부지런한 주민의 수에 있다.`,
    author: `나폴레옹`,
  },
  {
    category: `Success`,
    quote: `한때의 분한 감정일랑 참으라. 그러면 백일의 근심을 모면할 것이다.`,
    author: `경함록`,
  },
  {
    category: `Success`,
    quote: `한마리 곤충을 괴로움으로부터 구하는 것으로서 나는 인간이 생물에 대해서 줄곧 범하고 있는 죄의 얼마간을 감하려 하는 것이다.`,
    author: `알베르트 슈바이처 - 독일 철학자,의사:1875~1965`,
  },
  {
    category: `Success`,
    quote: `한명의 죽음은 비극이요, 백만 명의 죽음은 통계이다.`,
    author: `스탈린`,
  },
  {
    category: `Success`,
    quote: `한사람 또는 소수자의 노예가 되지 말라. 만인의 노예가 되라. 그때 너는 만 인의 친구가 될 수 있는 것이다.`,
    author: `키케로`,
  },
  {
    category: `Success`,
    quote: `한 사람을 무고하게 죽여도 오히려 안 되는데, 지금 선비들이 죄없이 많이 죽어서 원기가 쪼개졌으니 나라는 어찌 되랴 ?`,
    author: `이산해`,
  },
  {
    category: `Success`,
    quote: `한 사람의 근면, 착실, 정직한 모습은 당대뿐만아니라 후세에까지 영향을 미치게게 된다. 왜냐하면 그의 선행과 인격이무의식적으로 남의 생활속으로 스며들어가 후대에까지 모범이 되기 때문이다.`,
    author: `새뮤엘 스마일스 Saumel Smiles : 1812. 12. 23 스코틀랜드 버윅셔 해딩턴 ~ 1904. 4. 16 런던`,
  },
  {
    category: `Success`,
    quote: `한 손으로 다른 손을 씻고, 두 손으로 얼굴을 씻는다.`,
    author: `플로리오`,
  },
  {
    category: `Success`,
    quote: `한 시대의 철학은 다음 시대에서 평범한 상식에 불과하다.`,
    author: `헨리 W. 비치`,
  },
  {
    category: `Success`,
    quote: `한 알의 모래에서 하나의 세계를 보고, 한 송이의 들꽃에서 천국을 본다.`,
    author: `윌리엄 블레이크 - 영국 시인 : 1757-1827`,
  },
  {
    category: `Success`,
    quote: `한 작가가 아직 살아 있을 때는 우리는 그의 가장 못한 작품으로 그를 평가하고 그가 죽으면 그의 가장 뛰어난 작품으로 그를평가한다.`,
    author: `새뮤얼 존슨 - 영국 시인,평론가:1709~1784`,
  },
  {
    category: `Success`,
    quote: `한층 많이 하면 할수록 그만큼 능숙해진다. 다망하면 다망할수록, 그만큼 여 가가 생긴다.`,
    author: `허츠리트`,
  },
  { category: `Success`, quote: `한치의 기쁨마다 한자의 고민이 있다.`, author: `베넘` },
  {
    category: `Success`,
    quote: `한 친구를 얻는 데는 오래 걸리지만 잃는 데는 잠시이다.`,
    author: `릴리`,
  },
  {
    category: `Success`,
    quote: `할 수 있는 한 훌륭한 인생을 만들라. 인생은 짧고 곧 지나간다.`,
    author: `오울디즈`,
  },
  {
    category: `Success`,
    quote: `할 일을 많이 가지고 있지 않는 한 나태를 즐길 수는 없다.`,
    author: `J K 제롬`,
  },
  {
    category: `Success`,
    quote: `항상 무엇인가를 듣고 무엇인가를 생각하며 무엇인가를 배우자.`,
    author: `아서 헬프스`,
  },
  {
    category: `Success`,
    quote: `해와 달이 비록 밝지만 엎어놓은 소래기 밑은 비추지 못하고, 칼날이 비록 잘 들지만 죄 없는 사람은 베지 못한다. 불의의 재화는조심하고 집 문에는 들지 못한다.`,
    author: `명심보감`,
  },
  { category: `Success`, quote: `햇빛이 비치는 동안에 건초를 만들자.`, author: `세르반테스` },
  {
    category: `Success`,
    quote: `행동가처럼 생각하라. 그리고 생각하는 사람처럼 행동하라.`,
    author: `핸리 버그슨`,
  },
  {
    category: `Success`,
    quote: `행동에 부주의하지 말며,말에 혼동되지 말며,생각에 방황하지 말라.`,
    author: `마르크스아우렐리우스`,
  },
  { category: `Success`, quote: `행동은 낮게 하고 목표는 높게 하라.`, author: `조지 허버트` },
  {
    category: `Success`,
    quote: `행동을 초래시키지 않는 생각, 그것은 생각이 아니라 공상이다.`,
    author: `엘리자 램브 마틴`,
  },
  {
    category: `Success`,
    quote: `행동의 씨앗을 뿌리면 습관의 열매가 열리고, 습관의 씨앗을 뿌리면 성격의 열매가 열리고, 성격의 씨앗을 뿌리면 운명의 열매가열린다.`,
    author: `나폴레옹`,
  },
  {
    category: `Success`,
    quote: `행동하는데 만족하고 말하는 것은 다른 사람들 몫으로 남겨두라.`,
    author: `발타자르 그라시안 - Baltasar Gracian`,
  },
  { category: `Success`, quote: `행복은 무엇보다 건강 속에 있다.`, author: `G W 커티스` },
  {
    category: `Success`,
    quote: `행복을 사치한 생활 속에서 구하는 것은 마치 태양을 그림에 그려놓고 빛이 비치기를 기다리는 것이나 다름없다.`,
    author: `나폴레옹`,
  },
  {
    category: `Success`,
    quote: `행복을 잃기는 무척 쉽다. 왜냐하면 행복이란 언제나 분에 넘치는 것이기 때문이다.`,
    author: `알베르 카뮈 - 프랑스소설가,극작가:1913~1960`,
  },
  { category: `Success`, quote: `행복이란 불만에 자기가 속지 않으면 된다.`, author: `러셀` },
  {
    category: `Success`,
    quote: `행복이란 우리집 화롯가에서 성장한다. 그것은 남의 집 뜰에서 따와서는 안 된다.`,
    author: `제롤드`,
  },
  { category: `Success`, quote: `행복하게 산다는 것은 마음의 평온함을 뜻한다.`, author: `시세로` },
  {
    category: `Success`,
    quote: `행복하게 지내는 사람은 대개 노력가이다. 게으름뱅기가 행복하게 지내는 것을 보았는가. 수확의 기쁨은 흘린 땀에 정비례한다.`,
    author: `윌리엄 블레이크 - 영국시인:1757~1827`,
  },
  {
    category: `Success`,
    quote: `행복하려는 것은 권리지만 인간으로서 할 수 있는 한 알고 싶은 것을 배우고, 자신에게 최고의 기쁨을 가져다 줄 재능과 능력은연마해야 함이 분명히 요구된다.`,
    author: `버트런드 아서 윌리엄 러셀 - Bettrand Arthur William Russell`,
  },
  {
    category: `Success`,
    quote: `행복한 결혼에는 애정 위에 언젠가는 아름다운 우정이 접목되게 마련이다. 이 우정은 마음과 육체가 서로 결부되어 있기 때문에한층 견고한 것이다.`,
    author: `앙드레 모루아 - 프랑스 작가 : 1885-1967`,
  },
  {
    category: `Success`,
    quote: `행복함에는 두 갈래의 길이 있다. 욕망을 적게 하거나 재산을 많게 하거나 하면 된다.`,
    author: `프랭클린`,
  },
  {
    category: `Success`,
    quote: `행실은 각자가 자기의 이미지를 보여주는 거울이다.`,
    author: `괴테`,
  },
  { category: `Success`, quote: `행운은 때론 일찍 일어나는 것을 이긴다.`, author: `아일랜드 속담` },
  {
    category: `Success`,
    quote: `행운은 마음의 준비가 있는 사람에게만 미소를 짓는다.`,
    author: `파스퇴르`,
  },
  {
    category: `Success`,
    quote: `험담은 세 사람을 죽인다. 말하는 자, 험담의 대상자. 듣는다.`,
    author: `미드라쉬`,
  },
  {
    category: `Success`,
    quote: `험한 언덕을 오르려면 처음에는 서서히 걸어야 한다.`,
    author: `셰익스피어`,
  },
  {
    category: `Success`,
    quote: `혁명을 성공시키는 것은 희망이지 절망을 아니다.`,
    author: `끄로뽀또낑`,
  },
  {
    category: `Success`,
    quote: `혁명이란 하나의 불행이다. 그리고 가장 큰 불행은 실패할 혁명이다.`,
    author: `하이네`,
  },
  {
    category: `Success`,
    quote: `현대인의 최대의 정신적 범죄는 자기자신에 대해서 불성실한 것이다.`,
    author: ` `,
  },
  {
    category: `Success`,
    quote: `현대화 보다 더 고상한 것이 있다. 그것은 바로 영원한 것이다.`,
    author: `솔로몬 세치터`,
  },
  {
    category: `Success`,
    quote: `현명한 사람은 그가 발견하는 이상의 많은 기회를 만든다.`,
    author: `베이컨`,
  },
  {
    category: `Success`,
    quote: `현실에 대한 눈은 감을 수 있어도 기억에 대한 눈은 감을 수는 없다.`,
    author: `스타니스러우J.룩`,
  },
  {
    category: `Success`,
    quote: `현재나 미래에 있어 이 말은 잊지 말라. 인생은 헛된 꿈이 아니다. 영원을 바탕으로 하고 영원에 싸여있는 존귀한 實在실재인 것을.`,
    author: `로맹 롤랑 - 프랑스 작가:1866~1944`,
  },
  {
    category: `Success`,
    quote: `형제들이 집안에서는 서로 다투는 일이 있지만 외부에서 침략해오면 일치단결해서 외세를 물리친다.`,
    author: `시경`,
  },
  {
    category: `Success`,
    quote: `호기심이란 무지의 고백인데 그것은 의도적이며 당당하며 열렬하다.`,
    author: `류빈슈타인`,
  },
  {
    category: `Success`,
    quote: `호랑이는 그리되 뼈는 그리기 어렵고, 사람을 알되 마음은 알지 못한다.`,
    author: `명심보감`,
  },
  { category: `Success`, quote: `혼인의 일에 재물을 논함은 오랑캐의 도이다.`, author: `명심보감` },
  {
    category: `Success`,
    quote: `화가나면 열을 세어라. 풀리지 않는다면 백을 세어라.`,
    author: `제퍼슨`,
  },
  {
    category: `Success`,
    quote: `화상과 그 그림자와의 관계, 그것은 하나의 사건과 겸손과의 관계와 같다. 왜냐하면 후자는 전자에 힘과 표현을 주기때문에.`,
    author: `라 브르예르`,
  },
  {
    category: `Success`,
    quote: `화폐는 인간의 노동과 생존의 양도된 본질이다. 이 본질은 인간을 지배하며, 인간은 이것을 숭배한다.`,
    author: `카를 하인리히 마르크스 - 독일 경제학자`,
  },
  { category: `Success`, quote: `확실한 벗은 불확실한 처지에 있을때 알려진다.`, author: `시세로` },
  { category: `Success`, quote: `환각이 다하면 슬픔이 많다.`, author: `한무제` },
  {
    category: `Success`,
    quote: `환락은 망상 위에 세울 수 있으나, 행복은 진리 위에만 세워진다.`,
    author: `니꼬라`,
  },
  { category: `Success`, quote: `황금 보기를 돌 같이 하라.`, author: `최영 장군` },
  { category: `Success`, quote: `회복의 유일한 길은 다시 시작하는 것이다.`, author: `체이즈` },
  {
    category: `Success`,
    quote: `회화는 말없는시요, 시는 말하는 그림이다.`,
    author: `시모니데 - Simonides`,
  },
  {
    category: `Success`,
    quote: `效用효용은 사람으로 하여금 준비하게 만든다.`,
    author: `프란시스 베이컨 - Francis Bacon Viscount St. Albans`,
  },
  {
    category: `Success`,
    quote: `후회의 씨앗은 젊었을 때 즐거움으로 뿌려지지만, 늙었을 때 괴로움으로 거둬 들이게 된다.`,
    author: `콜튼`,
  },
  { category: `Success`, quote: `훌륭한 말은 훌륭한 무기이다.`, author: `퓰러` },
  {
    category: `Success`,
    quote: `훌륭한 사람을 잡아먹는 가장 무서운 것은 가난이다. 이것은 무엇보다도 무 섭다.`,
    author: `테오그라스`,
  },
  {
    category: `Success`,
    quote: `훌륭한 삶에는 세가지 요소가 있다. 즉 배우는 일, 돈 버는 일, 무엇인가 하고 싶은 일.`,
    author: `크리스토퍼 달링턴 몰리 - 미국 작가:1890 ~ 1957`,
  },
  { category: `Success`, quote: `훌륭한 충고보다 값진 선물은 없다.`, author: `에라스무스` },
  { category: `Success`, quote: `희망은 가난한 인간의 빵이다.`, author: `탈레스` },
  {
    category: `Success`,
    quote: `희망이란 무엇인가. 갸냘픈 풀잎에 맺힌 아침 이슬이거나, 좁디 좁은 위태로운 길목에서 빛나는 거미줄이다.`,
    author: `윌리엄 워즈워스 - 영국 시인 : 1770-1850`,
  },
  {
    category: `Success`,
    quote: `힘없는 정부는 미약하고, 정의없는 힘은 포악이다.`,
    author: `파스칼`,
  },
  {
    category: `Success`,
    quote: `힘으로서 사람을 복종시키지 말고 덕으로서 사람을 복종시켜라.`,
    author: `맹자`,
  },
];

export const AllQuotesList = [...MotivationQuotes, ...SuccessQuotes];
